webpackJsonp([231608221292675],[
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _apiRunnerBrowser = __webpack_require__(91);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(143);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _reactRouterDom = __webpack_require__(62);
	
	var _gatsbyReactRouterScroll = __webpack_require__(413);
	
	var _domready = __webpack_require__(371);
	
	var _domready2 = _interopRequireDefault(_domready);
	
	var _history = __webpack_require__(125);
	
	var _history2 = __webpack_require__(235);
	
	var _history3 = _interopRequireDefault(_history2);
	
	var _emitter = __webpack_require__(65);
	
	var _emitter2 = _interopRequireDefault(_emitter);
	
	var _pages = __webpack_require__(444);
	
	var _pages2 = _interopRequireDefault(_pages);
	
	var _redirects = __webpack_require__(445);
	
	var _redirects2 = _interopRequireDefault(_redirects);
	
	var _componentRenderer = __webpack_require__(233);
	
	var _componentRenderer2 = _interopRequireDefault(_componentRenderer);
	
	var _asyncRequires = __webpack_require__(232);
	
	var _asyncRequires2 = _interopRequireDefault(_asyncRequires);
	
	var _loader = __webpack_require__(148);
	
	var _loader2 = _interopRequireDefault(_loader);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	if (true) {
	  __webpack_require__(294);
	}
	
	window.___history = _history3.default;
	
	window.___emitter = _emitter2.default;
	
	_loader2.default.addPagesArray(_pages2.default);
	_loader2.default.addProdRequires(_asyncRequires2.default);
	window.asyncRequires = _asyncRequires2.default;
	window.___loader = _loader2.default;
	window.matchPath = _reactRouterDom.matchPath;
	
	// Convert to a map for faster lookup in maybeRedirect()
	var redirectMap = _redirects2.default.reduce(function (map, redirect) {
	  map[redirect.fromPath] = redirect;
	  return map;
	}, {});
	
	var maybeRedirect = function maybeRedirect(pathname) {
	  var redirect = redirectMap[pathname];
	
	  if (redirect != null) {
	    _history3.default.replace(redirect.toPath);
	    return true;
	  } else {
	    return false;
	  }
	};
	
	// Check for initial page-load redirect
	maybeRedirect(window.location.pathname);
	
	// Let the site/plugins run code very early.
	(0, _apiRunnerBrowser.apiRunnerAsync)("onClientEntry").then(function () {
	  // Let plugins register a service worker. The plugin just needs
	  // to return true.
	  if ((0, _apiRunnerBrowser.apiRunner)("registerServiceWorker").length > 0) {
	    __webpack_require__(238);
	  }
	
	  var navigateTo = function navigateTo(to) {
	    var location = (0, _history.createLocation)(to, null, null, _history3.default.location);
	    var pathname = location.pathname;
	
	    var redirect = redirectMap[pathname];
	
	    // If we're redirecting, just replace the passed in pathname
	    // to the one we want to redirect to.
	    if (redirect) {
	      pathname = redirect.toPath;
	    }
	    var wl = window.location;
	
	    // If we're already at this location, do nothing.
	    if (wl.pathname === location.pathname && wl.search === location.search && wl.hash === location.hash) {
	      return;
	    }
	
	    // Listen to loading events. If page resources load before
	    // a second, navigate immediately.
	    function eventHandler(e) {
	      if (e.page.path === _loader2.default.getPage(pathname).path) {
	        _emitter2.default.off("onPostLoadPageResources", eventHandler);
	        clearTimeout(timeoutId);
	        window.___history.push(location);
	      }
	    }
	
	    // Start a timer to wait for a second before transitioning and showing a
	    // loader in case resources aren't around yet.
	    var timeoutId = setTimeout(function () {
	      _emitter2.default.off("onPostLoadPageResources", eventHandler);
	      _emitter2.default.emit("onDelayedLoadPageResources", { pathname: pathname });
	      window.___history.push(location);
	    }, 1000);
	
	    if (_loader2.default.getResourcesForPathname(pathname)) {
	      // The resources are already loaded so off we go.
	      clearTimeout(timeoutId);
	      window.___history.push(location);
	    } else {
	      // They're not loaded yet so let's add a listener for when
	      // they finish loading.
	      _emitter2.default.on("onPostLoadPageResources", eventHandler);
	    }
	  };
	
	  // window.___loadScriptsForPath = loadScriptsForPath
	  window.___navigateTo = navigateTo;
	
	  // Call onRouteUpdate on the initial page load.
	  (0, _apiRunnerBrowser.apiRunner)("onRouteUpdate", {
	    location: _history3.default.location,
	    action: _history3.default.action
	  });
	
	  var initialAttachDone = false;
	  function attachToHistory(history) {
	    if (!window.___history || initialAttachDone === false) {
	      window.___history = history;
	      initialAttachDone = true;
	
	      history.listen(function (location, action) {
	        if (!maybeRedirect(location.pathname)) {
	          // Make sure React has had a chance to flush to DOM first.
	          setTimeout(function () {
	            (0, _apiRunnerBrowser.apiRunner)("onRouteUpdate", { location: location, action: action });
	          }, 0);
	        }
	      });
	    }
	  }
	
	  function shouldUpdateScroll(prevRouterProps, _ref) {
	    var pathname = _ref.location.pathname;
	
	    var results = (0, _apiRunnerBrowser.apiRunner)("shouldUpdateScroll", {
	      prevRouterProps: prevRouterProps,
	      pathname: pathname
	    });
	    if (results.length > 0) {
	      return results[0];
	    }
	
	    if (prevRouterProps) {
	      var oldPathname = prevRouterProps.location.pathname;
	
	      if (oldPathname === pathname) {
	        return false;
	      }
	    }
	    return true;
	  }
	
	  var AltRouter = (0, _apiRunnerBrowser.apiRunner)("replaceRouterComponent", { history: _history3.default })[0];
	  var DefaultRouter = function DefaultRouter(_ref2) {
	    var children = _ref2.children;
	    return _react2.default.createElement(
	      _reactRouterDom.Router,
	      { history: _history3.default },
	      children
	    );
	  };
	
	  var ComponentRendererWithRouter = (0, _reactRouterDom.withRouter)(_componentRenderer2.default);
	
	  _loader2.default.getResourcesForPathname(window.location.pathname, function () {
	    var Root = function Root() {
	      return (0, _react.createElement)(AltRouter ? AltRouter : DefaultRouter, null, (0, _react.createElement)(_gatsbyReactRouterScroll.ScrollContext, { shouldUpdateScroll: shouldUpdateScroll }, (0, _react.createElement)(ComponentRendererWithRouter, {
	        layout: true,
	        children: function children(layoutProps) {
	          return (0, _react.createElement)(_reactRouterDom.Route, {
	            render: function render(routeProps) {
	              attachToHistory(routeProps.history);
	              var props = layoutProps ? layoutProps : routeProps;
	
	              if (_loader2.default.getPage(props.location.pathname)) {
	                return (0, _react.createElement)(_componentRenderer2.default, _extends({
	                  page: true
	                }, props));
	              } else {
	                return (0, _react.createElement)(_componentRenderer2.default, {
	                  page: true,
	                  location: { pathname: "/404.html" }
	                });
	              }
	            }
	          });
	        }
	      })));
	    };
	
	    var NewRoot = (0, _apiRunnerBrowser.apiRunner)("wrapRootComponent", { Root: Root }, Root)[0];
	    (0, _domready2.default)(function () {
	      return _reactDom2.default.render(_react2.default.createElement(NewRoot, null), typeof window !== "undefined" ? document.getElementById("___gatsby") : void 0, function () {
	        (0, _apiRunnerBrowser.apiRunner)("onInitialClientRender");
	      });
	    });
	  });
	});

/***/ }),
/* 1 */,
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	/* global document: false, __webpack_require__: false */
	patch();
	
	function patch() {
	  var head = document.querySelector("head");
	  var ensure = __webpack_require__.e;
	  var chunks = __webpack_require__.s;
	  var failures;
	
	  __webpack_require__.e = function (chunkId, callback) {
	    var loaded = false;
	    var immediate = true;
	
	    var handler = function handler(error) {
	      if (!callback) return;
	
	      callback(__webpack_require__, error);
	      callback = null;
	    };
	
	    if (!chunks && failures && failures[chunkId]) {
	      handler(true);
	      return;
	    }
	
	    ensure(chunkId, function () {
	      if (loaded) return;
	      loaded = true;
	
	      if (immediate) {
	        // webpack fires callback immediately if chunk was already loaded
	        // IE also fires callback immediately if script was already
	        // in a cache (AppCache counts too)
	        setTimeout(function () {
	          handler();
	        });
	      } else {
	        handler();
	      }
	    });
	
	    // This is |true| if chunk is already loaded and does not need onError call.
	    // This happens because in such case ensure() is performed in sync way
	    if (loaded) {
	      return;
	    }
	
	    immediate = false;
	
	    onError(function () {
	      if (loaded) return;
	      loaded = true;
	
	      if (chunks) {
	        chunks[chunkId] = void 0;
	      } else {
	        failures || (failures = {});
	        failures[chunkId] = true;
	      }
	
	      handler(true);
	    });
	  };
	
	  function onError(callback) {
	    var script = head.lastChild;
	
	    if (script.tagName !== "SCRIPT") {
	      if (typeof console !== "undefined" && console.warn) {
	        console.warn("Script is not a script", script);
	      }
	
	      return;
	    }
	
	    script.onload = script.onerror = function () {
	      script.onload = script.onerror = null;
	      setTimeout(callback, 0);
	    };
	  }
	}

/***/ }),
/* 3 */,
/* 4 */,
/* 5 */,
/* 6 */,
/* 7 */,
/* 8 */,
/* 9 */,
/* 10 */,
/* 11 */,
/* 12 */,
/* 13 */,
/* 14 */,
/* 15 */,
/* 16 */,
/* 17 */,
/* 18 */,
/* 19 */,
/* 20 */,
/* 21 */,
/* 22 */,
/* 23 */,
/* 24 */,
/* 25 */,
/* 26 */,
/* 27 */,
/* 28 */,
/* 29 */,
/* 30 */,
/* 31 */,
/* 32 */,
/* 33 */,
/* 34 */,
/* 35 */,
/* 36 */,
/* 37 */,
/* 38 */,
/* 39 */,
/* 40 */,
/* 41 */,
/* 42 */,
/* 43 */,
/* 44 */,
/* 45 */,
/* 46 */,
/* 47 */,
/* 48 */,
/* 49 */,
/* 50 */,
/* 51 */,
/* 52 */,
/* 53 */,
/* 54 */,
/* 55 */,
/* 56 */,
/* 57 */
/***/ (function(module, exports, __webpack_require__) {

	var isSymbol = __webpack_require__(140);
	
	/** Used as references for various `Number` constants. */
	var INFINITY = 1 / 0;
	
	/**
	 * Converts `value` to a string key if it's not a string or symbol.
	 *
	 * @private
	 * @param {*} value The value to inspect.
	 * @returns {string|symbol} Returns the key.
	 */
	function toKey(value) {
	  if (typeof value == 'string' || isSymbol(value)) {
	    return value;
	  }
	  var result = (value + '');
	  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
	}
	
	module.exports = toKey;


/***/ }),
/* 58 */
/***/ (function(module, exports) {

	/**
	 * Performs a
	 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	 * comparison between two values to determine if they are equivalent.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to compare.
	 * @param {*} other The other value to compare.
	 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	 * @example
	 *
	 * var object = { 'a': 1 };
	 * var other = { 'a': 1 };
	 *
	 * _.eq(object, object);
	 * // => true
	 *
	 * _.eq(object, other);
	 * // => false
	 *
	 * _.eq('a', 'a');
	 * // => true
	 *
	 * _.eq('a', Object('a'));
	 * // => false
	 *
	 * _.eq(NaN, NaN);
	 * // => true
	 */
	function eq(value, other) {
	  return value === other || (value !== value && other !== other);
	}
	
	module.exports = eq;


/***/ }),
/* 59 */
/***/ (function(module, exports, __webpack_require__) {

	var isFunction = __webpack_require__(88),
	    isLength = __webpack_require__(139);
	
	/**
	 * Checks if `value` is array-like. A value is considered array-like if it's
	 * not a function and has a `value.length` that's an integer greater than or
	 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
	 * @example
	 *
	 * _.isArrayLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isArrayLike(document.body.children);
	 * // => true
	 *
	 * _.isArrayLike('abc');
	 * // => true
	 *
	 * _.isArrayLike(_.noop);
	 * // => false
	 */
	function isArrayLike(value) {
	  return value != null && isLength(value.length) && !isFunction(value);
	}
	
	module.exports = isArrayLike;


/***/ }),
/* 60 */,
/* 61 */,
/* 62 */,
/* 63 */,
/* 64 */,
/* 65 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _mitt = __webpack_require__(563);
	
	var _mitt2 = _interopRequireDefault(_mitt);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var emitter = (0, _mitt2.default)();
	module.exports = emitter;

/***/ }),
/* 66 */,
/* 67 */,
/* 68 */,
/* 69 */,
/* 70 */,
/* 71 */,
/* 72 */,
/* 73 */,
/* 74 */,
/* 75 */,
/* 76 */,
/* 77 */,
/* 78 */,
/* 79 */,
/* 80 */,
/* 81 */
/***/ (function(module, exports, __webpack_require__) {

	var listCacheClear = __webpack_require__(515),
	    listCacheDelete = __webpack_require__(516),
	    listCacheGet = __webpack_require__(517),
	    listCacheHas = __webpack_require__(518),
	    listCacheSet = __webpack_require__(519);
	
	/**
	 * Creates an list cache object.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function ListCache(entries) {
	  var index = -1,
	      length = entries == null ? 0 : entries.length;
	
	  this.clear();
	  while (++index < length) {
	    var entry = entries[index];
	    this.set(entry[0], entry[1]);
	  }
	}
	
	// Add methods to `ListCache`.
	ListCache.prototype.clear = listCacheClear;
	ListCache.prototype['delete'] = listCacheDelete;
	ListCache.prototype.get = listCacheGet;
	ListCache.prototype.has = listCacheHas;
	ListCache.prototype.set = listCacheSet;
	
	module.exports = ListCache;


/***/ }),
/* 82 */
/***/ (function(module, exports, __webpack_require__) {

	var eq = __webpack_require__(58);
	
	/**
	 * Gets the index at which the `key` is found in `array` of key-value pairs.
	 *
	 * @private
	 * @param {Array} array The array to inspect.
	 * @param {*} key The key to search for.
	 * @returns {number} Returns the index of the matched value, else `-1`.
	 */
	function assocIndexOf(array, key) {
	  var length = array.length;
	  while (length--) {
	    if (eq(array[length][0], key)) {
	      return length;
	    }
	  }
	  return -1;
	}
	
	module.exports = assocIndexOf;


/***/ }),
/* 83 */
/***/ (function(module, exports, __webpack_require__) {

	var isKeyable = __webpack_require__(512);
	
	/**
	 * Gets the data for `map`.
	 *
	 * @private
	 * @param {Object} map The map to query.
	 * @param {string} key The reference key.
	 * @returns {*} Returns the map data.
	 */
	function getMapData(map, key) {
	  var data = map.__data__;
	  return isKeyable(key)
	    ? data[typeof key == 'string' ? 'string' : 'hash']
	    : data.map;
	}
	
	module.exports = getMapData;


/***/ }),
/* 84 */
/***/ (function(module, exports) {

	/** Used as references for various `Number` constants. */
	var MAX_SAFE_INTEGER = 9007199254740991;
	
	/** Used to detect unsigned integer values. */
	var reIsUint = /^(?:0|[1-9]\d*)$/;
	
	/**
	 * Checks if `value` is a valid array-like index.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
	 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
	 */
	function isIndex(value, length) {
	  var type = typeof value;
	  length = length == null ? MAX_SAFE_INTEGER : length;
	
	  return !!length &&
	    (type == 'number' ||
	      (type != 'symbol' && reIsUint.test(value))) &&
	        (value > -1 && value % 1 == 0 && value < length);
	}
	
	module.exports = isIndex;


/***/ }),
/* 85 */
/***/ (function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(26);
	
	/* Built-in method references that are verified to be native. */
	var nativeCreate = getNative(Object, 'create');
	
	module.exports = nativeCreate;


/***/ }),
/* 86 */,
/* 87 */,
/* 88 */,
/* 89 */,
/* 90 */,
/* 91 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.apiRunner = apiRunner;
	exports.apiRunnerAsync = apiRunnerAsync;
	var plugins = [{
	  plugin: __webpack_require__(406),
	  options: { "plugins": [] }
	}, {
	  plugin: __webpack_require__(409),
	  options: { "plugins": [], "pathToConfigModule": "src/util/typography.js" }
	}, {
	  plugin: __webpack_require__(239),
	  options: { "plugins": [] }
	}];
	// During bootstrap, we write requires at top of this file which looks
	// basically like:
	// var plugins = [
	//   {
	//     plugin: require("/path/to/plugin1/gatsby-browser.js"),
	//     options: { ... },
	//   },
	//   {
	//     plugin: require("/path/to/plugin2/gatsby-browser.js"),
	//     options: { ... },
	//   },
	// ]
	
	function apiRunner(api, args, defaultReturn) {
	  var results = plugins.map(function (plugin) {
	    if (plugin.plugin[api]) {
	      var result = plugin.plugin[api](args, plugin.options);
	      return result;
	    }
	  });
	
	  // Filter out undefined results.
	  results = results.filter(function (result) {
	    return typeof result !== 'undefined';
	  });
	
	  if (results.length > 0) {
	    return results;
	  } else if (defaultReturn) {
	    return [defaultReturn];
	  } else {
	    return [];
	  }
	}
	
	function apiRunnerAsync(api, args, defaultReturn) {
	  return plugins.reduce(function (previous, next) {
	    return next.plugin[api] ? previous.then(function () {
	      return next.plugin[api](args, next.options);
	    }) : previous;
	  }, Promise.resolve());
	}

/***/ }),
/* 92 */,
/* 93 */,
/* 94 */,
/* 95 */,
/* 96 */,
/* 97 */,
/* 98 */,
/* 99 */,
/* 100 */,
/* 101 */,
/* 102 */,
/* 103 */,
/* 104 */,
/* 105 */,
/* 106 */,
/* 107 */,
/* 108 */,
/* 109 */,
/* 110 */,
/* 111 */,
/* 112 */,
/* 113 */,
/* 114 */,
/* 115 */,
/* 116 */,
/* 117 */,
/* 118 */,
/* 119 */,
/* 120 */,
/* 121 */,
/* 122 */,
/* 123 */,
/* 124 */,
/* 125 */,
/* 126 */,
/* 127 */,
/* 128 */,
/* 129 */
/***/ (function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(26),
	    root = __webpack_require__(12);
	
	/* Built-in method references that are verified to be native. */
	var Map = getNative(root, 'Map');
	
	module.exports = Map;


/***/ }),
/* 130 */
/***/ (function(module, exports, __webpack_require__) {

	var mapCacheClear = __webpack_require__(520),
	    mapCacheDelete = __webpack_require__(521),
	    mapCacheGet = __webpack_require__(522),
	    mapCacheHas = __webpack_require__(523),
	    mapCacheSet = __webpack_require__(524);
	
	/**
	 * Creates a map cache object to store key-value pairs.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function MapCache(entries) {
	  var index = -1,
	      length = entries == null ? 0 : entries.length;
	
	  this.clear();
	  while (++index < length) {
	    var entry = entries[index];
	    this.set(entry[0], entry[1]);
	  }
	}
	
	// Add methods to `MapCache`.
	MapCache.prototype.clear = mapCacheClear;
	MapCache.prototype['delete'] = mapCacheDelete;
	MapCache.prototype.get = mapCacheGet;
	MapCache.prototype.has = mapCacheHas;
	MapCache.prototype.set = mapCacheSet;
	
	module.exports = MapCache;


/***/ }),
/* 131 */
/***/ (function(module, exports, __webpack_require__) {

	var ListCache = __webpack_require__(81),
	    stackClear = __webpack_require__(537),
	    stackDelete = __webpack_require__(538),
	    stackGet = __webpack_require__(539),
	    stackHas = __webpack_require__(540),
	    stackSet = __webpack_require__(541);
	
	/**
	 * Creates a stack cache object to store key-value pairs.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function Stack(entries) {
	  var data = this.__data__ = new ListCache(entries);
	  this.size = data.size;
	}
	
	// Add methods to `Stack`.
	Stack.prototype.clear = stackClear;
	Stack.prototype['delete'] = stackDelete;
	Stack.prototype.get = stackGet;
	Stack.prototype.has = stackHas;
	Stack.prototype.set = stackSet;
	
	module.exports = Stack;


/***/ }),
/* 132 */
/***/ (function(module, exports, __webpack_require__) {

	var defineProperty = __webpack_require__(196);
	
	/**
	 * The base implementation of `assignValue` and `assignMergeValue` without
	 * value checks.
	 *
	 * @private
	 * @param {Object} object The object to modify.
	 * @param {string} key The key of the property to assign.
	 * @param {*} value The value to assign.
	 */
	function baseAssignValue(object, key, value) {
	  if (key == '__proto__' && defineProperty) {
	    defineProperty(object, key, {
	      'configurable': true,
	      'enumerable': true,
	      'value': value,
	      'writable': true
	    });
	  } else {
	    object[key] = value;
	  }
	}
	
	module.exports = baseAssignValue;


/***/ }),
/* 133 */,
/* 134 */,
/* 135 */
/***/ (function(module, exports, __webpack_require__) {

	var isArray = __webpack_require__(6),
	    isKey = __webpack_require__(136),
	    stringToPath = __webpack_require__(542),
	    toString = __webpack_require__(561);
	
	/**
	 * Casts `value` to a path array if it's not one.
	 *
	 * @private
	 * @param {*} value The value to inspect.
	 * @param {Object} [object] The object to query keys on.
	 * @returns {Array} Returns the cast property path array.
	 */
	function castPath(value, object) {
	  if (isArray(value)) {
	    return value;
	  }
	  return isKey(value, object) ? [value] : stringToPath(toString(value));
	}
	
	module.exports = castPath;


/***/ }),
/* 136 */
/***/ (function(module, exports, __webpack_require__) {

	var isArray = __webpack_require__(6),
	    isSymbol = __webpack_require__(140);
	
	/** Used to match property names within property paths. */
	var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
	    reIsPlainProp = /^\w*$/;
	
	/**
	 * Checks if `value` is a property name and not a property path.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @param {Object} [object] The object to query keys on.
	 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
	 */
	function isKey(value, object) {
	  if (isArray(value)) {
	    return false;
	  }
	  var type = typeof value;
	  if (type == 'number' || type == 'symbol' || type == 'boolean' ||
	      value == null || isSymbol(value)) {
	    return true;
	  }
	  return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
	    (object != null && value in Object(object));
	}
	
	module.exports = isKey;


/***/ }),
/* 137 */
/***/ (function(module, exports) {

	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/**
	 * Checks if `value` is likely a prototype object.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
	 */
	function isPrototype(value) {
	  var Ctor = value && value.constructor,
	      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;
	
	  return value === proto;
	}
	
	module.exports = isPrototype;


/***/ }),
/* 138 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var root = __webpack_require__(12),
	    stubFalse = __webpack_require__(559);
	
	/** Detect free variable `exports`. */
	var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;
	
	/** Detect free variable `module`. */
	var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;
	
	/** Detect the popular CommonJS extension `module.exports`. */
	var moduleExports = freeModule && freeModule.exports === freeExports;
	
	/** Built-in value references. */
	var Buffer = moduleExports ? root.Buffer : undefined;
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;
	
	/**
	 * Checks if `value` is a buffer.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.3.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
	 * @example
	 *
	 * _.isBuffer(new Buffer(2));
	 * // => true
	 *
	 * _.isBuffer(new Uint8Array(2));
	 * // => false
	 */
	var isBuffer = nativeIsBuffer || stubFalse;
	
	module.exports = isBuffer;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(42)(module)))

/***/ }),
/* 139 */
/***/ (function(module, exports) {

	/** Used as references for various `Number` constants. */
	var MAX_SAFE_INTEGER = 9007199254740991;
	
	/**
	 * Checks if `value` is a valid array-like length.
	 *
	 * **Note:** This method is loosely based on
	 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
	 * @example
	 *
	 * _.isLength(3);
	 * // => true
	 *
	 * _.isLength(Number.MIN_VALUE);
	 * // => false
	 *
	 * _.isLength(Infinity);
	 * // => false
	 *
	 * _.isLength('3');
	 * // => false
	 */
	function isLength(value) {
	  return typeof value == 'number' &&
	    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
	}
	
	module.exports = isLength;


/***/ }),
/* 140 */
/***/ (function(module, exports, __webpack_require__) {

	var baseGetTag = __webpack_require__(19),
	    isObjectLike = __webpack_require__(14);
	
	/** `Object#toString` result references. */
	var symbolTag = '[object Symbol]';
	
	/**
	 * Checks if `value` is classified as a `Symbol` primitive or object.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
	 * @example
	 *
	 * _.isSymbol(Symbol.iterator);
	 * // => true
	 *
	 * _.isSymbol('abc');
	 * // => false
	 */
	function isSymbol(value) {
	  return typeof value == 'symbol' ||
	    (isObjectLike(value) && baseGetTag(value) == symbolTag);
	}
	
	module.exports = isSymbol;


/***/ }),
/* 141 */
/***/ (function(module, exports, __webpack_require__) {

	var baseIsTypedArray = __webpack_require__(466),
	    baseUnary = __webpack_require__(482),
	    nodeUtil = __webpack_require__(530);
	
	/* Node.js helper references. */
	var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;
	
	/**
	 * Checks if `value` is classified as a typed array.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
	 * @example
	 *
	 * _.isTypedArray(new Uint8Array);
	 * // => true
	 *
	 * _.isTypedArray([]);
	 * // => false
	 */
	var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;
	
	module.exports = isTypedArray;


/***/ }),
/* 142 */
/***/ (function(module, exports, __webpack_require__) {

	var arrayLikeKeys = __webpack_require__(187),
	    baseKeys = __webpack_require__(468),
	    isArrayLike = __webpack_require__(59);
	
	/**
	 * Creates an array of the own enumerable property names of `object`.
	 *
	 * **Note:** Non-object values are coerced to objects. See the
	 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
	 * for more details.
	 *
	 * @static
	 * @since 0.1.0
	 * @memberOf _
	 * @category Object
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 *   this.b = 2;
	 * }
	 *
	 * Foo.prototype.c = 3;
	 *
	 * _.keys(new Foo);
	 * // => ['a', 'b'] (iteration order is not guaranteed)
	 *
	 * _.keys('hi');
	 * // => ['0', '1']
	 */
	function keys(object) {
	  return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
	}
	
	module.exports = keys;


/***/ }),
/* 143 */,
/* 144 */,
/* 145 */,
/* 146 */,
/* 147 */
/***/ (function(module, exports, __webpack_require__) {

	(function (global, factory) {
		 true ? factory(exports, __webpack_require__(23), __webpack_require__(79), __webpack_require__(415), __webpack_require__(225)) :
		typeof define === 'function' && define.amd ? define(['exports', 'apollo-utilities', 'graphql/language/printer', 'graphql-anywhere', 'apollo-cache'], factory) :
		(factory((global.apollo = global.apollo || {}, global.apollo.cache = global.apollo.cache || {}, global.apollo.cache.inmemory = {}),global.apollo.utilities,global.printer,global.graphqlAnywhere,global.apolloCache.core));
	}(this, (function (exports,apolloUtilities,printer,graphqlAnywhere,apolloCache) { 'use strict';
	
	graphqlAnywhere = graphqlAnywhere && graphqlAnywhere.hasOwnProperty('default') ? graphqlAnywhere['default'] : graphqlAnywhere;
	
	var haveWarned = false;
	/**
	 * This fragment matcher is very basic and unable to match union or interface type conditions
	 */
	var HeuristicFragmentMatcher = /** @class */ (function () {
	    function HeuristicFragmentMatcher() {
	        // do nothing
	    }
	    HeuristicFragmentMatcher.prototype.ensureReady = function () {
	        return Promise.resolve();
	    };
	    HeuristicFragmentMatcher.prototype.canBypassInit = function () {
	        return true; // we don't need to initialize this fragment matcher.
	    };
	    HeuristicFragmentMatcher.prototype.match = function (idValue, typeCondition, context) {
	        var obj = context.store.get(idValue.id);
	        if (!obj) {
	            return false;
	        }
	        if (!obj.__typename) {
	            if (!haveWarned) {
	                console.warn("You're using fragments in your queries, but either don't have the addTypename:\n  true option set in Apollo Client, or you are trying to write a fragment to the store without the __typename.\n   Please turn on the addTypename option and include __typename when writing fragments so that Apollo Client\n   can accurately match fragments.");
	                console.warn('Could not find __typename on Fragment ', typeCondition, obj);
	                console.warn("DEPRECATION WARNING: using fragments without __typename is unsupported behavior " +
	                    "and will be removed in future versions of Apollo client. You should fix this and set addTypename to true now.");
	                /* istanbul ignore if */
	                if (!apolloUtilities.isTest()) {
	                    // When running tests, we want to print the warning every time
	                    haveWarned = true;
	                }
	            }
	            context.returnPartialData = true;
	            return true;
	        }
	        if (obj.__typename === typeCondition) {
	            return true;
	        }
	        // XXX here we reach an issue - we don't know if this fragment should match or not. It's either:
	        // 1. A fragment on a non-matching concrete type or interface or union
	        // 2. A fragment on a matching interface or union
	        // If it's 1, we don't want to return anything, if it's 2 we want to match. We can't tell the
	        // difference, so we warn the user, but still try to match it (backcompat).
	        apolloUtilities.warnOnceInDevelopment("You are using the simple (heuristic) fragment matcher, but your queries contain union or interface types.\n     Apollo Client will not be able to able to accurately map fragments." +
	            "To make this error go away, use the IntrospectionFragmentMatcher as described in the docs: " +
	            "https://www.apollographql.com/docs/react/recipes/fragment-matching.html", 'error');
	        context.returnPartialData = true;
	        return true;
	    };
	    return HeuristicFragmentMatcher;
	}());
	var IntrospectionFragmentMatcher = /** @class */ (function () {
	    function IntrospectionFragmentMatcher(options) {
	        if (options && options.introspectionQueryResultData) {
	            this.possibleTypesMap = this.parseIntrospectionResult(options.introspectionQueryResultData);
	            this.isReady = true;
	        }
	        else {
	            this.isReady = false;
	        }
	        this.match = this.match.bind(this);
	    }
	    IntrospectionFragmentMatcher.prototype.match = function (idValue, typeCondition, context) {
	        if (!this.isReady) {
	            // this should basically never happen in proper use.
	            throw new Error('FragmentMatcher.match() was called before FragmentMatcher.init()');
	        }
	        var obj = context.store.get(idValue.id);
	        if (!obj) {
	            return false;
	        }
	        if (!obj.__typename) {
	            throw new Error("Cannot match fragment because __typename property is missing: " + JSON.stringify(obj));
	        }
	        if (obj.__typename === typeCondition) {
	            return true;
	        }
	        var implementingTypes = this.possibleTypesMap[typeCondition];
	        if (implementingTypes && implementingTypes.indexOf(obj.__typename) > -1) {
	            return true;
	        }
	        return false;
	    };
	    IntrospectionFragmentMatcher.prototype.parseIntrospectionResult = function (introspectionResultData) {
	        var typeMap = {};
	        introspectionResultData.__schema.types.forEach(function (type) {
	            if (type.kind === 'UNION' || type.kind === 'INTERFACE') {
	                typeMap[type.name] = type.possibleTypes.map(function (implementingType) { return implementingType.name; });
	            }
	        });
	        return typeMap;
	    };
	    return IntrospectionFragmentMatcher;
	}());
	
	var ObjectCache = /** @class */ (function () {
	    function ObjectCache(data) {
	        if (data === void 0) { data = {}; }
	        this.data = data;
	    }
	    ObjectCache.prototype.toObject = function () {
	        return this.data;
	    };
	    ObjectCache.prototype.get = function (dataId) {
	        return this.data[dataId];
	    };
	    ObjectCache.prototype.set = function (dataId, value) {
	        this.data[dataId] = value;
	    };
	    ObjectCache.prototype.delete = function (dataId) {
	        this.data[dataId] = undefined;
	    };
	    ObjectCache.prototype.clear = function () {
	        this.data = {};
	    };
	    ObjectCache.prototype.replace = function (newData) {
	        this.data = newData || {};
	    };
	    return ObjectCache;
	}());
	function defaultNormalizedCacheFactory(seed) {
	    return new ObjectCache(seed);
	}
	
	var __extends = (undefined && undefined.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	var __assign = (undefined && undefined.__assign) || Object.assign || function(t) {
	    for (var s, i = 1, n = arguments.length; i < n; i++) {
	        s = arguments[i];
	        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
	            t[p] = s[p];
	    }
	    return t;
	};
	var WriteError = /** @class */ (function (_super) {
	    __extends(WriteError, _super);
	    function WriteError() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;
	        _this.type = 'WriteError';
	        return _this;
	    }
	    return WriteError;
	}(Error));
	function enhanceErrorWithDocument(error, document) {
	    // XXX A bit hacky maybe ...
	    var enhancedError = new WriteError("Error writing result to store for query:\n " + printer.print(document));
	    enhancedError.message += '\n' + error.message;
	    enhancedError.stack = error.stack;
	    return enhancedError;
	}
	/**
	 * Writes the result of a query to the store.
	 *
	 * @param result The result object returned for the query document.
	 *
	 * @param query The query document whose result we are writing to the store.
	 *
	 * @param store The {@link NormalizedCache} used by Apollo for the `data` portion of the store.
	 *
	 * @param variables A map from the name of a variable to its value. These variables can be
	 * referenced by the query document.
	 *
	 * @param dataIdFromObject A function that returns an object identifier given a particular result
	 * object. See the store documentation for details and an example of this function.
	 *
	 * @param fragmentMap A map from the name of a fragment to its fragment definition. These fragments
	 * can be referenced within the query document.
	 *
	 * @param fragmentMatcherFunction A function to use for matching fragment conditions in GraphQL documents
	 */
	function writeQueryToStore(_a) {
	    var result = _a.result, query = _a.query, _b = _a.storeFactory, storeFactory = _b === void 0 ? defaultNormalizedCacheFactory : _b, _c = _a.store, store = _c === void 0 ? storeFactory() : _c, variables = _a.variables, dataIdFromObject = _a.dataIdFromObject, _d = _a.fragmentMap, fragmentMap = _d === void 0 ? {} : _d, fragmentMatcherFunction = _a.fragmentMatcherFunction;
	    var queryDefinition = apolloUtilities.getQueryDefinition(query);
	    variables = apolloUtilities.assign({}, apolloUtilities.getDefaultValues(queryDefinition), variables);
	    try {
	        return writeSelectionSetToStore({
	            dataId: 'ROOT_QUERY',
	            result: result,
	            selectionSet: queryDefinition.selectionSet,
	            context: {
	                store: store,
	                storeFactory: storeFactory,
	                processedData: {},
	                variables: variables,
	                dataIdFromObject: dataIdFromObject,
	                fragmentMap: fragmentMap,
	                fragmentMatcherFunction: fragmentMatcherFunction,
	            },
	        });
	    }
	    catch (e) {
	        throw enhanceErrorWithDocument(e, query);
	    }
	}
	function writeResultToStore(_a) {
	    var dataId = _a.dataId, result = _a.result, document = _a.document, _b = _a.storeFactory, storeFactory = _b === void 0 ? defaultNormalizedCacheFactory : _b, _c = _a.store, store = _c === void 0 ? storeFactory() : _c, variables = _a.variables, dataIdFromObject = _a.dataIdFromObject, fragmentMatcherFunction = _a.fragmentMatcherFunction;
	    // XXX TODO REFACTOR: this is a temporary workaround until query normalization is made to work with documents.
	    var operationDefinition = apolloUtilities.getOperationDefinition(document);
	    var selectionSet = operationDefinition.selectionSet;
	    var fragmentMap = apolloUtilities.createFragmentMap(apolloUtilities.getFragmentDefinitions(document));
	    variables = apolloUtilities.assign({}, apolloUtilities.getDefaultValues(operationDefinition), variables);
	    try {
	        return writeSelectionSetToStore({
	            result: result,
	            dataId: dataId,
	            selectionSet: selectionSet,
	            context: {
	                store: store,
	                storeFactory: storeFactory,
	                processedData: {},
	                variables: variables,
	                dataIdFromObject: dataIdFromObject,
	                fragmentMap: fragmentMap,
	                fragmentMatcherFunction: fragmentMatcherFunction,
	            },
	        });
	    }
	    catch (e) {
	        throw enhanceErrorWithDocument(e, document);
	    }
	}
	function writeSelectionSetToStore(_a) {
	    var result = _a.result, dataId = _a.dataId, selectionSet = _a.selectionSet, context = _a.context;
	    var variables = context.variables, store = context.store, fragmentMap = context.fragmentMap;
	    selectionSet.selections.forEach(function (selection) {
	        var included = apolloUtilities.shouldInclude(selection, variables);
	        if (apolloUtilities.isField(selection)) {
	            var resultFieldKey = apolloUtilities.resultKeyNameFromField(selection);
	            var value = result[resultFieldKey];
	            if (included) {
	                if (typeof value !== 'undefined') {
	                    writeFieldToStore({
	                        dataId: dataId,
	                        value: value,
	                        field: selection,
	                        context: context,
	                    });
	                }
	                else {
	                    // if this is a defered field we don't need to throw / wanr
	                    var isDefered = selection.directives &&
	                        selection.directives.length &&
	                        selection.directives.some(function (directive) { return directive.name && directive.name.value === 'defer'; });
	                    if (!isDefered && context.fragmentMatcherFunction) {
	                        // XXX We'd like to throw an error, but for backwards compatibility's sake
	                        // we just print a warning for the time being.
	                        //throw new WriteError(`Missing field ${resultFieldKey} in ${JSON.stringify(result, null, 2).substring(0, 100)}`);
	                        if (!apolloUtilities.isProduction()) {
	                            console.warn("Missing field " + resultFieldKey + " in " + JSON.stringify(result, null, 2).substring(0, 100));
	                        }
	                    }
	                }
	            }
	        }
	        else {
	            // This is not a field, so it must be a fragment, either inline or named
	            var fragment = void 0;
	            if (apolloUtilities.isInlineFragment(selection)) {
	                fragment = selection;
	            }
	            else {
	                // Named fragment
	                fragment = (fragmentMap || {})[selection.name.value];
	                if (!fragment) {
	                    throw new Error("No fragment named " + selection.name.value + ".");
	                }
	            }
	            var matches = true;
	            if (context.fragmentMatcherFunction && fragment.typeCondition) {
	                // TODO we need to rewrite the fragment matchers for this to work properly and efficiently
	                // Right now we have to pretend that we're passing in an idValue and that there's a store
	                // on the context.
	                var idValue = apolloUtilities.toIdValue({ id: 'self', typename: undefined });
	                var fakeContext = {
	                    // NOTE: fakeContext always uses ObjectCache
	                    // since this is only to ensure the return value of 'matches'
	                    store: new ObjectCache({ self: result }),
	                    returnPartialData: false,
	                    hasMissingField: false,
	                    cacheRedirects: {},
	                };
	                matches = context.fragmentMatcherFunction(idValue, fragment.typeCondition.name.value, fakeContext);
	                if (!apolloUtilities.isProduction() && fakeContext.returnPartialData) {
	                    console.error('WARNING: heuristic fragment matching going on!');
	                }
	            }
	            if (included && matches) {
	                writeSelectionSetToStore({
	                    result: result,
	                    selectionSet: fragment.selectionSet,
	                    dataId: dataId,
	                    context: context,
	                });
	            }
	        }
	    });
	    return store;
	}
	// Checks if the id given is an id that was generated by Apollo
	// rather than by dataIdFromObject.
	function isGeneratedId(id) {
	    return id[0] === '$';
	}
	function mergeWithGenerated(generatedKey, realKey, cache) {
	    var generated = cache.get(generatedKey);
	    var real = cache.get(realKey);
	    Object.keys(generated).forEach(function (key) {
	        var value = generated[key];
	        var realValue = real[key];
	        if (apolloUtilities.isIdValue(value) && isGeneratedId(value.id) && apolloUtilities.isIdValue(realValue)) {
	            mergeWithGenerated(value.id, realValue.id, cache);
	        }
	        cache.delete(generatedKey);
	        cache.set(realKey, __assign({}, generated, real));
	    });
	}
	function isDataProcessed(dataId, field, processedData) {
	    if (!processedData) {
	        return false;
	    }
	    if (processedData[dataId]) {
	        if (processedData[dataId].indexOf(field) >= 0) {
	            return true;
	        }
	        else {
	            processedData[dataId].push(field);
	        }
	    }
	    else {
	        processedData[dataId] = [field];
	    }
	    return false;
	}
	function writeFieldToStore(_a) {
	    var field = _a.field, value = _a.value, dataId = _a.dataId, context = _a.context;
	    var variables = context.variables, dataIdFromObject = context.dataIdFromObject, store = context.store;
	    var storeValue;
	    var storeObject;
	    var storeFieldName = apolloUtilities.storeKeyNameFromField(field, variables);
	    // specifies if we need to merge existing keys in the store
	    var shouldMerge = false;
	    // If we merge, this will be the generatedKey
	    var generatedKey = '';
	    // If this is a scalar value...
	    if (!field.selectionSet || value === null) {
	        storeValue =
	            value != null && typeof value === 'object'
	                ?
	                    // an id.
	                    { type: 'json', json: value }
	                :
	                    value;
	    }
	    else if (Array.isArray(value)) {
	        var generatedId = dataId + "." + storeFieldName;
	        storeValue = processArrayValue(value, generatedId, field.selectionSet, context);
	    }
	    else {
	        // It's an object
	        var valueDataId = dataId + "." + storeFieldName;
	        var generated = true;
	        // We only prepend the '$' if the valueDataId isn't already a generated
	        // id.
	        if (!isGeneratedId(valueDataId)) {
	            valueDataId = '$' + valueDataId;
	        }
	        if (dataIdFromObject) {
	            var semanticId = dataIdFromObject(value);
	            // We throw an error if the first character of the id is '$. This is
	            // because we use that character to designate an Apollo-generated id
	            // and we use the distinction between user-desiginated and application-provided
	            // ids when managing overwrites.
	            if (semanticId && isGeneratedId(semanticId)) {
	                throw new Error('IDs returned by dataIdFromObject cannot begin with the "$" character.');
	            }
	            if (semanticId) {
	                valueDataId = semanticId;
	                generated = false;
	            }
	        }
	        if (!isDataProcessed(valueDataId, field, context.processedData)) {
	            writeSelectionSetToStore({
	                dataId: valueDataId,
	                result: value,
	                selectionSet: field.selectionSet,
	                context: context,
	            });
	        }
	        // We take the id and escape it (i.e. wrap it with an enclosing object).
	        // This allows us to distinguish IDs from normal scalars.
	        var typename = value.__typename;
	        storeValue = apolloUtilities.toIdValue({ id: valueDataId, typename: typename }, generated);
	        // check if there was a generated id at the location where we're
	        // about to place this new id. If there was, we have to merge the
	        // data from that id with the data we're about to write in the store.
	        storeObject = store.get(dataId);
	        var escapedId = storeObject && storeObject[storeFieldName];
	        if (escapedId !== storeValue && apolloUtilities.isIdValue(escapedId)) {
	            var hadTypename = escapedId.typename !== undefined;
	            var hasTypename = typename !== undefined;
	            var typenameChanged = hadTypename && hasTypename && escapedId.typename !== typename;
	            // If there is already a real id in the store and the current id we
	            // are dealing with is generated, we throw an error.
	            // One exception we allow is when the typename has changed, which occurs
	            // when schema defines a union, both with and without an ID in the same place.
	            // checks if we "lost" the read id
	            if (generated && !escapedId.generated && !typenameChanged) {
	                throw new Error("Store error: the application attempted to write an object with no provided id" +
	                    (" but the store already contains an id of " + escapedId.id + " for this object. The selectionSet") +
	                    " that was trying to be written is:\n" +
	                    printer.print(field));
	            }
	            // checks if we "lost" the typename
	            if (hadTypename && !hasTypename) {
	                throw new Error("Store error: the application attempted to write an object with no provided typename" +
	                    (" but the store already contains an object with typename of " + escapedId.typename + " for the object of id " + escapedId.id + ". The selectionSet") +
	                    " that was trying to be written is:\n" +
	                    printer.print(field));
	            }
	            if (escapedId.generated) {
	                generatedKey = escapedId.id;
	                // we should only merge if it's an object of the same type
	                // otherwise, we should delete the generated object
	                if (typenameChanged) {
	                    store.delete(generatedKey);
	                }
	                else {
	                    shouldMerge = true;
	                }
	            }
	        }
	    }
	    var newStoreObj = __assign({}, store.get(dataId), (_b = {}, _b[storeFieldName] = storeValue, _b));
	    if (shouldMerge) {
	        mergeWithGenerated(generatedKey, storeValue.id, store);
	    }
	    storeObject = store.get(dataId);
	    if (!storeObject || storeValue !== storeObject[storeFieldName]) {
	        store.set(dataId, newStoreObj);
	    }
	    var _b;
	}
	function processArrayValue(value, generatedId, selectionSet, context) {
	    return value.map(function (item, index) {
	        if (item === null) {
	            return null;
	        }
	        var itemDataId = generatedId + "." + index;
	        if (Array.isArray(item)) {
	            return processArrayValue(item, itemDataId, selectionSet, context);
	        }
	        var generated = true;
	        if (context.dataIdFromObject) {
	            var semanticId = context.dataIdFromObject(item);
	            if (semanticId) {
	                itemDataId = semanticId;
	                generated = false;
	            }
	        }
	        if (!isDataProcessed(itemDataId, selectionSet, context.processedData)) {
	            writeSelectionSetToStore({
	                dataId: itemDataId,
	                result: item,
	                selectionSet: selectionSet,
	                context: context,
	            });
	        }
	        return apolloUtilities.toIdValue({ id: itemDataId, typename: item.__typename }, generated);
	    });
	}
	
	var __assign$1 = (undefined && undefined.__assign) || Object.assign || function(t) {
	    for (var s, i = 1, n = arguments.length; i < n; i++) {
	        s = arguments[i];
	        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
	            t[p] = s[p];
	    }
	    return t;
	};
	/**
	 * The key which the cache id for a given value is stored in the result object. This key is private
	 * and should not be used by Apollo client users.
	 *
	 * Uses a symbol if available in the environment.
	 *
	 * @private
	 */
	var ID_KEY = typeof Symbol !== 'undefined' ? Symbol('id') : '@@id';
	/**
	 * Resolves the result of a query solely from the store (i.e. never hits the server).
	 *
	 * @param {Store} store The {@link NormalizedCache} used by Apollo for the `data` portion of the
	 * store.
	 *
	 * @param {DocumentNode} query The query document to resolve from the data available in the store.
	 *
	 * @param {Object} [variables] A map from the name of a variable to its value. These variables can
	 * be referenced by the query document.
	 *
	 * @param {any} previousResult The previous result returned by this function for the same query.
	 * If nothing in the store changed since that previous result then values from the previous result
	 * will be returned to preserve referential equality.
	 */
	function readQueryFromStore(options) {
	    var optsPatch = { returnPartialData: false };
	    return diffQueryAgainstStore(__assign$1({}, options, optsPatch)).result;
	}
	var readStoreResolver = function (fieldName, idValue, args, context, _a) {
	    var resultKey = _a.resultKey, directives = _a.directives;
	    assertIdValue(idValue);
	    var objId = idValue.id;
	    var obj = context.store.get(objId);
	    var storeKeyName = apolloUtilities.getStoreKeyName(fieldName, args, directives);
	    var fieldValue = (obj || {})[storeKeyName];
	    if (typeof fieldValue === 'undefined') {
	        if (context.cacheRedirects &&
	            obj &&
	            (obj.__typename || objId === 'ROOT_QUERY')) {
	            var typename = obj.__typename || 'Query';
	            // Look for the type in the custom resolver map
	            var type = context.cacheRedirects[typename];
	            if (type) {
	                // Look for the field in the custom resolver map
	                var resolver = type[fieldName];
	                if (resolver) {
	                    fieldValue = resolver(obj, args, {
	                        getCacheKey: function (obj) {
	                            return apolloUtilities.toIdValue({
	                                id: context.dataIdFromObject(obj),
	                                typename: obj.__typename,
	                            });
	                        },
	                    });
	                }
	            }
	        }
	    }
	    if (typeof fieldValue === 'undefined') {
	        if (!context.returnPartialData) {
	            throw new Error("Can't find field " + storeKeyName + " on object (" + objId + ") " + JSON.stringify(obj, null, 2) + ".");
	        }
	        context.hasMissingField = true;
	        return fieldValue;
	    }
	    // if this is an object scalar, it must be a json blob and we have to unescape it
	    if (apolloUtilities.isJsonValue(fieldValue)) {
	        // If the JSON blob is the same now as in the previous result, return the previous result to
	        // maintain referential equality.
	        //
	        // `isEqual` will first perform a referential equality check (with `===`) in case the JSON
	        // value has not changed in the store, and then a deep equality check if that fails in case a
	        // new JSON object was returned by the API but that object may still be the same.
	        if (idValue.previousResult &&
	            apolloUtilities.isEqual(idValue.previousResult[resultKey], fieldValue.json)) {
	            return idValue.previousResult[resultKey];
	        }
	        return fieldValue.json;
	    }
	    // If we had a previous result, try adding that previous result value for this field to our field
	    // value. This will create a new value without mutating the old one.
	    if (idValue.previousResult) {
	        fieldValue = addPreviousResultToIdValues(fieldValue, idValue.previousResult[resultKey]);
	    }
	    return fieldValue;
	};
	/**
	 * Given a store and a query, return as much of the result as possible and
	 * identify if any data was missing from the store.
	 * @param  {DocumentNode} query A parsed GraphQL query document
	 * @param  {Store} store The Apollo Client store object
	 * @param  {any} previousResult The previous result returned by this function for the same query
	 * @return {result: Object, complete: [boolean]}
	 */
	function diffQueryAgainstStore(_a) {
	    var store = _a.store, query = _a.query, variables = _a.variables, previousResult = _a.previousResult, _b = _a.returnPartialData, returnPartialData = _b === void 0 ? true : _b, _c = _a.rootId, rootId = _c === void 0 ? 'ROOT_QUERY' : _c, fragmentMatcherFunction = _a.fragmentMatcherFunction, config = _a.config;
	    // Throw the right validation error by trying to find a query in the document
	    var queryDefinition = apolloUtilities.getQueryDefinition(query);
	    variables = apolloUtilities.assign({}, apolloUtilities.getDefaultValues(queryDefinition), variables);
	    var context = {
	        // Global settings
	        store: store,
	        returnPartialData: returnPartialData,
	        dataIdFromObject: (config && config.dataIdFromObject) || null,
	        cacheRedirects: (config && config.cacheRedirects) || {},
	        // Flag set during execution
	        hasMissingField: false,
	    };
	    var rootIdValue = {
	        type: 'id',
	        id: rootId,
	        previousResult: previousResult,
	    };
	    var result = graphqlAnywhere(readStoreResolver, query, rootIdValue, context, variables, {
	        fragmentMatcher: fragmentMatcherFunction,
	        resultMapper: resultMapper,
	    });
	    return {
	        result: result,
	        complete: !context.hasMissingField,
	    };
	}
	function assertIdValue(idValue) {
	    if (!apolloUtilities.isIdValue(idValue)) {
	        throw new Error("Encountered a sub-selection on the query, but the store doesn't have an object reference. This should never happen during normal use unless you have custom code that is directly manipulating the store; please file an issue.");
	    }
	}
	/**
	 * Adds a previous result value to id values in a nested array. For a single id value and a single
	 * previous result then the previous value is added directly.
	 *
	 * For arrays we put all of the ids from the previous result array in a map and add them to id
	 * values with the same id.
	 *
	 * This function does not mutate. Instead it returns new instances of modified values.
	 *
	 * @private
	 */
	function addPreviousResultToIdValues(value, previousResult) {
	    // If the value is an `IdValue`, add the previous result to it whether or not that
	    // `previousResult` is undefined.
	    //
	    // If the value is an array, recurse over each item trying to add the `previousResult` for that
	    // item.
	    if (apolloUtilities.isIdValue(value)) {
	        return __assign$1({}, value, { previousResult: previousResult });
	    }
	    else if (Array.isArray(value)) {
	        var idToPreviousResult_1 = new Map();
	        // If the previous result was an array, we want to build up our map of ids to previous results
	        // using the private `ID_KEY` property that is added in `resultMapper`.
	        if (Array.isArray(previousResult)) {
	            previousResult.forEach(function (item) {
	                // item can be null
	                if (item && item[ID_KEY]) {
	                    idToPreviousResult_1.set(item[ID_KEY], item);
	                    // idToPreviousResult[item[ID_KEY]] = item;
	                }
	            });
	        }
	        // For every value we want to add the previous result.
	        return value.map(function (item, i) {
	            // By default the previous result for this item will be in the same array position as this
	            // item.
	            var itemPreviousResult = previousResult && previousResult[i];
	            // If the item is an id value, we should check to see if there is a previous result for this
	            // specific id. If there is, that will be the value for `itemPreviousResult`.
	            if (apolloUtilities.isIdValue(item)) {
	                itemPreviousResult =
	                    idToPreviousResult_1.get(item.id) || itemPreviousResult;
	            }
	            return addPreviousResultToIdValues(item, itemPreviousResult);
	        });
	    }
	    // Return the value, nothing changed.
	    return value;
	}
	/**
	 * Maps a result from `graphql-anywhere` to a final result value.
	 *
	 * If the result and the previous result from the `idValue` pass a shallow equality test, we just
	 * return the `previousResult` to maintain referential equality.
	 *
	 * We also add a private id property to the result that we can use later on.
	 *
	 * @private
	 */
	function resultMapper(resultFields, idValue) {
	    // If we had a previous result, we may be able to return that and preserve referential equality
	    if (idValue.previousResult) {
	        var currentResultKeys_1 = Object.keys(resultFields);
	        var sameAsPreviousResult = 
	        // Confirm that we have the same keys in both the current result and the previous result.
	        Object.keys(idValue.previousResult).every(function (key) { return currentResultKeys_1.indexOf(key) > -1; }) &&
	            // Perform a shallow comparison of the result fields with the previous result. If all of
	            // the shallow fields are referentially equal to the fields of the previous result we can
	            // just return the previous result.
	            //
	            // While we do a shallow comparison of objects, but we do a deep comparison of arrays.
	            currentResultKeys_1.every(function (key) {
	                return areNestedArrayItemsStrictlyEqual(resultFields[key], idValue.previousResult[key]);
	            });
	        if (sameAsPreviousResult) {
	            return idValue.previousResult;
	        }
	    }
	    // Add the id to the result fields. It should be non-enumerable so users can’t see it without
	    // trying very hard.
	    Object.defineProperty(resultFields, ID_KEY, {
	        enumerable: false,
	        configurable: false,
	        writable: false,
	        value: idValue.id,
	    });
	    return resultFields;
	}
	/**
	 * Compare all the items to see if they are all referentially equal in two arrays no matter how
	 * deeply nested the arrays are.
	 *
	 * @private
	 */
	function areNestedArrayItemsStrictlyEqual(a, b) {
	    // If `a` and `b` are referentially equal, return true.
	    if (a === b) {
	        return true;
	    }
	    // If either `a` or `b` are not an array or not of the same length return false. `a` and `b` are
	    // known to not be equal here, we checked above.
	    if (!Array.isArray(a) || !Array.isArray(b) || a.length !== b.length) {
	        return false;
	    }
	    // Otherwise let us compare all of the array items (which are potentially nested arrays!) to see
	    // if they are equal.
	    return a.every(function (item, i) { return areNestedArrayItemsStrictlyEqual(item, b[i]); });
	}
	
	var __assign$2 = (undefined && undefined.__assign) || Object.assign || function(t) {
	    for (var s, i = 1, n = arguments.length; i < n; i++) {
	        s = arguments[i];
	        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
	            t[p] = s[p];
	    }
	    return t;
	};
	var RecordingCache = /** @class */ (function () {
	    function RecordingCache(data) {
	        if (data === void 0) { data = {}; }
	        this.data = data;
	        this.recordedData = {};
	    }
	    RecordingCache.prototype.record = function (transaction) {
	        transaction(this);
	        var recordedData = this.recordedData;
	        this.recordedData = {};
	        return recordedData;
	    };
	    RecordingCache.prototype.toObject = function () {
	        return __assign$2({}, this.data, this.recordedData);
	    };
	    RecordingCache.prototype.get = function (dataId) {
	        if (this.recordedData.hasOwnProperty(dataId)) {
	            // recording always takes precedence:
	            return this.recordedData[dataId];
	        }
	        return this.data[dataId];
	    };
	    RecordingCache.prototype.set = function (dataId, value) {
	        if (this.get(dataId) !== value) {
	            this.recordedData[dataId] = value;
	        }
	    };
	    RecordingCache.prototype.delete = function (dataId) {
	        this.recordedData[dataId] = undefined;
	    };
	    RecordingCache.prototype.clear = function () {
	        var _this = this;
	        Object.keys(this.data).forEach(function (dataId) { return _this.delete(dataId); });
	        this.recordedData = {};
	    };
	    RecordingCache.prototype.replace = function (newData) {
	        this.clear();
	        this.recordedData = __assign$2({}, newData);
	    };
	    return RecordingCache;
	}());
	function record(startingState, transaction) {
	    var recordingCache = new RecordingCache(startingState);
	    return recordingCache.record(transaction);
	}
	
	var __extends$1 = (undefined && undefined.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	var __assign$3 = (undefined && undefined.__assign) || Object.assign || function(t) {
	    for (var s, i = 1, n = arguments.length; i < n; i++) {
	        s = arguments[i];
	        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
	            t[p] = s[p];
	    }
	    return t;
	};
	var defaultConfig = {
	    fragmentMatcher: new HeuristicFragmentMatcher(),
	    dataIdFromObject: defaultDataIdFromObject,
	    addTypename: true,
	    storeFactory: defaultNormalizedCacheFactory,
	};
	function defaultDataIdFromObject(result) {
	    if (result.__typename) {
	        if (result.id !== undefined) {
	            return result.__typename + ":" + result.id;
	        }
	        if (result._id !== undefined) {
	            return result.__typename + ":" + result._id;
	        }
	    }
	    return null;
	}
	var InMemoryCache = /** @class */ (function (_super) {
	    __extends$1(InMemoryCache, _super);
	    function InMemoryCache(config) {
	        if (config === void 0) { config = {}; }
	        var _this = _super.call(this) || this;
	        _this.optimistic = [];
	        _this.watches = [];
	        // Set this while in a transaction to prevent broadcasts...
	        // don't forget to turn it back on!
	        _this.silenceBroadcast = false;
	        _this.config = __assign$3({}, defaultConfig, config);
	        // backwards compat
	        if (_this.config.customResolvers) {
	            console.warn('customResolvers have been renamed to cacheRedirects. Please update your config as we will be deprecating customResolvers in the next major version.');
	            _this.config.cacheRedirects = _this.config.customResolvers;
	        }
	        if (_this.config.cacheResolvers) {
	            console.warn('cacheResolvers have been renamed to cacheRedirects. Please update your config as we will be deprecating cacheResolvers in the next major version.');
	            _this.config.cacheRedirects = _this.config.cacheResolvers;
	        }
	        _this.addTypename = _this.config.addTypename;
	        _this.data = _this.config.storeFactory();
	        return _this;
	    }
	    InMemoryCache.prototype.restore = function (data) {
	        if (data)
	            this.data.replace(data);
	        return this;
	    };
	    InMemoryCache.prototype.extract = function (optimistic) {
	        if (optimistic === void 0) { optimistic = false; }
	        if (optimistic && this.optimistic.length > 0) {
	            var patches = this.optimistic.map(function (opt) { return opt.data; });
	            return Object.assign.apply(Object, [{}, this.data.toObject()].concat(patches));
	        }
	        return this.data.toObject();
	    };
	    InMemoryCache.prototype.read = function (query) {
	        if (query.rootId && this.data.get(query.rootId) === undefined) {
	            return null;
	        }
	        return readQueryFromStore({
	            store: this.config.storeFactory(this.extract(query.optimistic)),
	            query: this.transformDocument(query.query),
	            variables: query.variables,
	            rootId: query.rootId,
	            fragmentMatcherFunction: this.config.fragmentMatcher.match,
	            previousResult: query.previousResult,
	            config: this.config,
	        });
	    };
	    InMemoryCache.prototype.write = function (write) {
	        writeResultToStore({
	            dataId: write.dataId,
	            result: write.result,
	            variables: write.variables,
	            document: this.transformDocument(write.query),
	            store: this.data,
	            dataIdFromObject: this.config.dataIdFromObject,
	            fragmentMatcherFunction: this.config.fragmentMatcher.match,
	        });
	        this.broadcastWatches();
	    };
	    InMemoryCache.prototype.diff = function (query) {
	        return diffQueryAgainstStore({
	            store: this.config.storeFactory(this.extract(query.optimistic)),
	            query: this.transformDocument(query.query),
	            variables: query.variables,
	            returnPartialData: query.returnPartialData,
	            previousResult: query.previousResult,
	            fragmentMatcherFunction: this.config.fragmentMatcher.match,
	            config: this.config,
	        });
	    };
	    InMemoryCache.prototype.watch = function (watch) {
	        var _this = this;
	        this.watches.push(watch);
	        return function () {
	            _this.watches = _this.watches.filter(function (c) { return c !== watch; });
	        };
	    };
	    InMemoryCache.prototype.evict = function (query) {
	        throw new Error("eviction is not implemented on InMemory Cache");
	    };
	    InMemoryCache.prototype.reset = function () {
	        this.data.clear();
	        this.broadcastWatches();
	        return Promise.resolve();
	    };
	    InMemoryCache.prototype.removeOptimistic = function (id) {
	        var _this = this;
	        // Throw away optimistic changes of that particular mutation
	        var toPerform = this.optimistic.filter(function (item) { return item.id !== id; });
	        this.optimistic = [];
	        // Re-run all of our optimistic data actions on top of one another.
	        toPerform.forEach(function (change) {
	            _this.recordOptimisticTransaction(change.transaction, change.id);
	        });
	        this.broadcastWatches();
	    };
	    InMemoryCache.prototype.performTransaction = function (transaction) {
	        // TODO: does this need to be different, or is this okay for an in-memory cache?
	        var alreadySilenced = this.silenceBroadcast;
	        this.silenceBroadcast = true;
	        transaction(this);
	        if (!alreadySilenced) {
	            // Don't un-silence since this is a nested transaction
	            // (for example, a transaction inside an optimistic record)
	            this.silenceBroadcast = false;
	        }
	        this.broadcastWatches();
	    };
	    InMemoryCache.prototype.recordOptimisticTransaction = function (transaction, id) {
	        var _this = this;
	        this.silenceBroadcast = true;
	        var patch = record(this.extract(true), function (recordingCache) {
	            // swapping data instance on 'this' is currently necessary
	            // because of the current architecture
	            var dataCache = _this.data;
	            _this.data = recordingCache;
	            _this.performTransaction(transaction);
	            _this.data = dataCache;
	        });
	        this.optimistic.push({
	            id: id,
	            transaction: transaction,
	            data: patch,
	        });
	        this.silenceBroadcast = false;
	        this.broadcastWatches();
	    };
	    InMemoryCache.prototype.transformDocument = function (document) {
	        if (this.addTypename)
	            return apolloUtilities.addTypenameToDocument(document);
	        return document;
	    };
	    InMemoryCache.prototype.readQuery = function (options, optimistic) {
	        if (optimistic === void 0) { optimistic = false; }
	        return this.read({
	            query: options.query,
	            variables: options.variables,
	            optimistic: optimistic,
	        });
	    };
	    InMemoryCache.prototype.readFragment = function (options, optimistic) {
	        if (optimistic === void 0) { optimistic = false; }
	        return this.read({
	            query: this.transformDocument(apolloUtilities.getFragmentQueryDocument(options.fragment, options.fragmentName)),
	            variables: options.variables,
	            rootId: options.id,
	            optimistic: optimistic,
	        });
	    };
	    InMemoryCache.prototype.writeQuery = function (options) {
	        this.write({
	            dataId: 'ROOT_QUERY',
	            result: options.data,
	            query: this.transformDocument(options.query),
	            variables: options.variables,
	        });
	    };
	    InMemoryCache.prototype.writeFragment = function (options) {
	        this.write({
	            dataId: options.id,
	            result: options.data,
	            query: this.transformDocument(apolloUtilities.getFragmentQueryDocument(options.fragment, options.fragmentName)),
	            variables: options.variables,
	        });
	    };
	    InMemoryCache.prototype.broadcastWatches = function () {
	        var _this = this;
	        // Skip this when silenced (like inside a transaction)
	        if (this.silenceBroadcast)
	            return;
	        // right now, we invalidate all queries whenever anything changes
	        this.watches.forEach(function (c) {
	            var newData = _this.diff({
	                query: c.query,
	                variables: c.variables,
	                // TODO: previousResult isn't in the types - this will only work
	                // with ObservableQuery which is in a different package
	                previousResult: c.previousResult && c.previousResult(),
	                optimistic: c.optimistic,
	            });
	            c.callback(newData);
	        });
	    };
	    return InMemoryCache;
	}(apolloCache.ApolloCache));
	
	exports.InMemoryCache = InMemoryCache;
	exports.defaultDataIdFromObject = defaultDataIdFromObject;
	exports.ID_KEY = ID_KEY;
	exports.readQueryFromStore = readQueryFromStore;
	exports.diffQueryAgainstStore = diffQueryAgainstStore;
	exports.assertIdValue = assertIdValue;
	exports.WriteError = WriteError;
	exports.enhanceErrorWithDocument = enhanceErrorWithDocument;
	exports.writeQueryToStore = writeQueryToStore;
	exports.writeResultToStore = writeResultToStore;
	exports.writeSelectionSetToStore = writeSelectionSetToStore;
	exports.HeuristicFragmentMatcher = HeuristicFragmentMatcher;
	exports.IntrospectionFragmentMatcher = IntrospectionFragmentMatcher;
	exports.ObjectCache = ObjectCache;
	exports.defaultNormalizedCacheFactory = defaultNormalizedCacheFactory;
	exports.RecordingCache = RecordingCache;
	exports.record = record;
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	})));
	//# sourceMappingURL=bundle.umd.js.map


/***/ }),
/* 148 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {"use strict";
	
	exports.__esModule = true;
	exports.publicLoader = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _findPage = __webpack_require__(234);
	
	var _findPage2 = _interopRequireDefault(_findPage);
	
	var _emitter = __webpack_require__(65);
	
	var _emitter2 = _interopRequireDefault(_emitter);
	
	var _stripPrefix = __webpack_require__(149);
	
	var _stripPrefix2 = _interopRequireDefault(_stripPrefix);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var findPage = void 0;
	
	var syncRequires = {};
	var asyncRequires = {};
	var pathScriptsCache = {};
	var resourceStrCache = {};
	var resourceCache = {};
	var pages = [];
	// Note we're not actively using the path data atm. There
	// could be future optimizations however around trying to ensure
	// we load all resources for likely-to-be-visited paths.
	var pathArray = [];
	var pathCount = {};
	var pathPrefix = "";
	var resourcesArray = [];
	var resourcesCount = {};
	var preferDefault = function preferDefault(m) {
	  return m && m.default || m;
	};
	var prefetcher = void 0;
	var inInitialRender = true;
	var fetchHistory = [];
	var failedPaths = {};
	var failedResources = {};
	var MAX_HISTORY = 5;
	
	// Prefetcher logic
	if (true) {
	  prefetcher = __webpack_require__(237)({
	    getNextQueuedResources: function getNextQueuedResources() {
	      return resourcesArray.slice(-1)[0];
	    },
	    createResourceDownload: function createResourceDownload(resourceName) {
	      fetchResource(resourceName, function () {
	        resourcesArray = resourcesArray.filter(function (r) {
	          return r !== resourceName;
	        });
	        prefetcher.onResourcedFinished(resourceName);
	      });
	    }
	  });
	  _emitter2.default.on("onPreLoadPageResources", function (e) {
	    prefetcher.onPreLoadPageResources(e);
	  });
	  _emitter2.default.on("onPostLoadPageResources", function (e) {
	    prefetcher.onPostLoadPageResources(e);
	  });
	}
	
	var sortResourcesByCount = function sortResourcesByCount(a, b) {
	  if (resourcesCount[a] > resourcesCount[b]) {
	    return 1;
	  } else if (resourcesCount[a] < resourcesCount[b]) {
	    return -1;
	  } else {
	    return 0;
	  }
	};
	
	var sortPagesByCount = function sortPagesByCount(a, b) {
	  if (pathCount[a] > pathCount[b]) {
	    return 1;
	  } else if (pathCount[a] < pathCount[b]) {
	    return -1;
	  } else {
	    return 0;
	  }
	};
	
	var fetchResource = function fetchResource(resourceName) {
	  var cb = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function () {};
	
	  if (resourceStrCache[resourceName]) {
	    process.nextTick(function () {
	      cb(null, resourceStrCache[resourceName]);
	    });
	  } else {
	    // Find resource
	    var resourceFunction = void 0;
	    if (resourceName.slice(0, 12) === "component---") {
	      resourceFunction = asyncRequires.components[resourceName];
	    } else if (resourceName.slice(0, 9) === "layout---") {
	      resourceFunction = asyncRequires.layouts[resourceName];
	    } else {
	      resourceFunction = asyncRequires.json[resourceName];
	    }
	
	    // Download the resource
	    resourceFunction(function (err, executeChunk) {
	      resourceStrCache[resourceName] = executeChunk;
	      fetchHistory.push({
	        resource: resourceName,
	        succeeded: !err
	      });
	
	      if (!failedResources[resourceName]) {
	        failedResources[resourceName] = err;
	      }
	
	      fetchHistory = fetchHistory.slice(-MAX_HISTORY);
	      cb(err, executeChunk);
	    });
	  }
	};
	
	var getResourceModule = function getResourceModule(resourceName, cb) {
	  if (resourceCache[resourceName]) {
	    process.nextTick(function () {
	      cb(null, resourceCache[resourceName]);
	    });
	  } else if (failedResources[resourceName]) {
	    process.nextTick(function () {
	      cb(failedResources[resourceName]);
	    });
	  } else {
	    fetchResource(resourceName, function (err, executeChunk) {
	      if (err) {
	        cb(err);
	      } else {
	        var module = preferDefault(executeChunk());
	        resourceCache[resourceName] = module;
	        cb(err, module);
	      }
	    });
	  }
	};
	
	var appearsOnLine = function appearsOnLine() {
	  var isOnLine = navigator.onLine;
	  if (typeof isOnLine === "boolean") {
	    return isOnLine;
	  }
	
	  // If no navigator.onLine support assume onLine if any of last N fetches succeeded
	  var succeededFetch = fetchHistory.find(function (entry) {
	    return entry.succeeded;
	  });
	  return !!succeededFetch;
	};
	
	var handleResourceLoadError = function handleResourceLoadError(path, message) {
	  console.log(message);
	
	  if (!failedPaths[path]) {
	    failedPaths[path] = message;
	  }
	
	  if (appearsOnLine() && window.location.pathname.replace(/\/$/g, "") !== path.replace(/\/$/g, "")) {
	    window.location.pathname = path;
	  }
	};
	
	var mountOrder = 1;
	var queue = {
	  empty: function empty() {
	    pathArray = [];
	    pathCount = {};
	    resourcesCount = {};
	    resourcesArray = [];
	    pages = [];
	    pathPrefix = "";
	  },
	  addPagesArray: function addPagesArray(newPages) {
	    pages = newPages;
	    if (true) {
	      if (false) pathPrefix = __PATH_PREFIX__;
	    }
	    findPage = (0, _findPage2.default)(newPages, pathPrefix);
	  },
	  addDevRequires: function addDevRequires(devRequires) {
	    syncRequires = devRequires;
	  },
	  addProdRequires: function addProdRequires(prodRequires) {
	    asyncRequires = prodRequires;
	  },
	  dequeue: function dequeue() {
	    return pathArray.pop();
	  },
	  enqueue: function enqueue(rawPath) {
	    // Check page exists.
	    var path = (0, _stripPrefix2.default)(rawPath, pathPrefix);
	    if (!pages.some(function (p) {
	      return p.path === path;
	    })) {
	      return false;
	    }
	
	    var mountOrderBoost = 1 / mountOrder;
	    mountOrder += 1;
	    // console.log(
	    // `enqueue "${path}", mountOrder: "${mountOrder}, mountOrderBoost: ${mountOrderBoost}`
	    // )
	
	    // Add to path counts.
	    if (!pathCount[path]) {
	      pathCount[path] = 1;
	    } else {
	      pathCount[path] += 1;
	    }
	
	    // Add path to queue.
	    if (!queue.has(path)) {
	      pathArray.unshift(path);
	    }
	
	    // Sort pages by pathCount
	    pathArray.sort(sortPagesByCount);
	
	    // Add resources to queue.
	    var page = findPage(path);
	    if (page.jsonName) {
	      if (!resourcesCount[page.jsonName]) {
	        resourcesCount[page.jsonName] = 1 + mountOrderBoost;
	      } else {
	        resourcesCount[page.jsonName] += 1 + mountOrderBoost;
	      }
	
	      // Before adding, checking that the JSON resource isn't either
	      // already queued or been downloading.
	      if (resourcesArray.indexOf(page.jsonName) === -1 && !resourceStrCache[page.jsonName]) {
	        resourcesArray.unshift(page.jsonName);
	      }
	    }
	    if (page.componentChunkName) {
	      if (!resourcesCount[page.componentChunkName]) {
	        resourcesCount[page.componentChunkName] = 1 + mountOrderBoost;
	      } else {
	        resourcesCount[page.componentChunkName] += 1 + mountOrderBoost;
	      }
	
	      // Before adding, checking that the component resource isn't either
	      // already queued or been downloading.
	      if (resourcesArray.indexOf(page.componentChunkName) === -1 && !resourceStrCache[page.jsonName]) {
	        resourcesArray.unshift(page.componentChunkName);
	      }
	    }
	
	    // Sort resources by resourcesCount.
	    resourcesArray.sort(sortResourcesByCount);
	    if (true) {
	      prefetcher.onNewResourcesAdded();
	    }
	
	    return true;
	  },
	  getResources: function getResources() {
	    return {
	      resourcesArray: resourcesArray,
	      resourcesCount: resourcesCount
	    };
	  },
	  getPages: function getPages() {
	    return {
	      pathArray: pathArray,
	      pathCount: pathCount
	    };
	  },
	  getPage: function getPage(pathname) {
	    return findPage(pathname);
	  },
	  has: function has(path) {
	    return pathArray.some(function (p) {
	      return p === path;
	    });
	  },
	  getResourcesForPathname: function getResourcesForPathname(path) {
	    var cb = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function () {};
	
	    if (inInitialRender && navigator && navigator.serviceWorker && navigator.serviceWorker.controller && navigator.serviceWorker.controller.state === "activated") {
	      // If we're loading from a service worker (it's already activated on
	      // this initial render) and we can't find a page, there's a good chance
	      // we're on a new page that this (now old) service worker doesn't know
	      // about so we'll unregister it and reload.
	      if (!findPage(path)) {
	        navigator.serviceWorker.getRegistrations().then(function (registrations) {
	          // We would probably need this to
	          // prevent unnecessary reloading of the page
	          // while unregistering of ServiceWorker is not happening
	          if (registrations.length) {
	            for (var _iterator = registrations, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;) {
	              var _ref;
	
	              if (_isArray) {
	                if (_i >= _iterator.length) break;
	                _ref = _iterator[_i++];
	              } else {
	                _i = _iterator.next();
	                if (_i.done) break;
	                _ref = _i.value;
	              }
	
	              var registration = _ref;
	
	              registration.unregister();
	            }
	            window.location.reload();
	          }
	        });
	      }
	    }
	    inInitialRender = false;
	    // In development we know the code is loaded already
	    // so we just return with it immediately.
	    if (false) {
	      var page = findPage(path);
	      if (!page) return cb();
	      var pageResources = {
	        component: syncRequires.components[page.componentChunkName],
	        json: syncRequires.json[page.jsonName],
	        layout: syncRequires.layouts[page.layout],
	        page: page
	      };
	      cb(pageResources);
	      return pageResources;
	      // Production code path
	    } else {
	      if (failedPaths[path]) {
	        handleResourceLoadError(path, "Previously detected load failure for \"" + path + "\"");
	
	        return cb();
	      }
	
	      var _page = findPage(path);
	
	      if (!_page) {
	        handleResourceLoadError(path, "A page wasn't found for \"" + path + "\"");
	
	        return cb();
	      }
	
	      // Use the path from the page so the pathScriptsCache uses
	      // the normalized path.
	      path = _page.path;
	
	      // Check if it's in the cache already.
	      if (pathScriptsCache[path]) {
	        process.nextTick(function () {
	          cb(pathScriptsCache[path]);
	          _emitter2.default.emit("onPostLoadPageResources", {
	            page: _page,
	            pageResources: pathScriptsCache[path]
	          });
	        });
	        return pathScriptsCache[path];
	      }
	
	      _emitter2.default.emit("onPreLoadPageResources", { path: path });
	      // Nope, we need to load resource(s)
	      var component = void 0;
	      var json = void 0;
	      var layout = void 0;
	      // Load the component/json/layout and parallel and call this
	      // function when they're done loading. When both are loaded,
	      // we move on.
	      var done = function done() {
	        if (component && json && (!_page.layoutComponentChunkName || layout)) {
	          pathScriptsCache[path] = { component: component, json: json, layout: layout, page: _page };
	          var _pageResources = { component: component, json: json, layout: layout, page: _page };
	          cb(_pageResources);
	          _emitter2.default.emit("onPostLoadPageResources", {
	            page: _page,
	            pageResources: _pageResources
	          });
	        }
	      };
	      getResourceModule(_page.componentChunkName, function (err, c) {
	        if (err) {
	          handleResourceLoadError(_page.path, "Loading the component for " + _page.path + " failed");
	        }
	        component = c;
	        done();
	      });
	      getResourceModule(_page.jsonName, function (err, j) {
	        if (err) {
	          handleResourceLoadError(_page.path, "Loading the JSON for " + _page.path + " failed");
	        }
	        json = j;
	        done();
	      });
	
	      _page.layoutComponentChunkName && getResourceModule(_page.layout, function (err, l) {
	        if (err) {
	          handleResourceLoadError(_page.path, "Loading the Layout for " + _page.path + " failed");
	        }
	        layout = l;
	        done();
	      });
	
	      return undefined;
	    }
	  },
	  peek: function peek(path) {
	    return pathArray.slice(-1)[0];
	  },
	  length: function length() {
	    return pathArray.length;
	  },
	  indexOf: function indexOf(path) {
	    return pathArray.length - pathArray.indexOf(path) - 1;
	  }
	};
	
	var publicLoader = exports.publicLoader = {
	  getResourcesForPathname: queue.getResourcesForPathname
	};
	
	exports.default = queue;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(213)))

/***/ }),
/* 149 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	
	/**
	 * Remove a prefix from a string. Return the input string if the given prefix
	 * isn't found.
	 */
	
	exports.default = function (str) {
	  var prefix = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "";
	
	  if (str.substr(0, prefix.length) === prefix) return str.slice(prefix.length);
	  return str;
	};
	
	module.exports = exports["default"];

/***/ }),
/* 150 */,
/* 151 */,
/* 152 */,
/* 153 */,
/* 154 */,
/* 155 */,
/* 156 */,
/* 157 */,
/* 158 */,
/* 159 */,
/* 160 */,
/* 161 */,
/* 162 */,
/* 163 */,
/* 164 */,
/* 165 */,
/* 166 */,
/* 167 */,
/* 168 */,
/* 169 */,
/* 170 */,
/* 171 */,
/* 172 */,
/* 173 */,
/* 174 */,
/* 175 */,
/* 176 */,
/* 177 */,
/* 178 */,
/* 179 */,
/* 180 */,
/* 181 */,
/* 182 */,
/* 183 */,
/* 184 */,
/* 185 */
/***/ (function(module, exports, __webpack_require__) {

	var root = __webpack_require__(12);
	
	/** Built-in value references. */
	var Uint8Array = root.Uint8Array;
	
	module.exports = Uint8Array;


/***/ }),
/* 186 */,
/* 187 */
/***/ (function(module, exports, __webpack_require__) {

	var baseTimes = __webpack_require__(480),
	    isArguments = __webpack_require__(87),
	    isArray = __webpack_require__(6),
	    isBuffer = __webpack_require__(138),
	    isIndex = __webpack_require__(84),
	    isTypedArray = __webpack_require__(141);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Creates an array of the enumerable property names of the array-like `value`.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @param {boolean} inherited Specify returning inherited property names.
	 * @returns {Array} Returns the array of property names.
	 */
	function arrayLikeKeys(value, inherited) {
	  var isArr = isArray(value),
	      isArg = !isArr && isArguments(value),
	      isBuff = !isArr && !isArg && isBuffer(value),
	      isType = !isArr && !isArg && !isBuff && isTypedArray(value),
	      skipIndexes = isArr || isArg || isBuff || isType,
	      result = skipIndexes ? baseTimes(value.length, String) : [],
	      length = result.length;
	
	  for (var key in value) {
	    if ((inherited || hasOwnProperty.call(value, key)) &&
	        !(skipIndexes && (
	           // Safari 9 has enumerable `arguments.length` in strict mode.
	           key == 'length' ||
	           // Node.js 0.10 has enumerable non-index properties on buffers.
	           (isBuff && (key == 'offset' || key == 'parent')) ||
	           // PhantomJS 2 has enumerable non-index properties on typed arrays.
	           (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
	           // Skip index properties.
	           isIndex(key, length)
	        ))) {
	      result.push(key);
	    }
	  }
	  return result;
	}
	
	module.exports = arrayLikeKeys;


/***/ }),
/* 188 */,
/* 189 */
/***/ (function(module, exports, __webpack_require__) {

	var baseAssignValue = __webpack_require__(132),
	    eq = __webpack_require__(58);
	
	/**
	 * This function is like `assignValue` except that it doesn't assign
	 * `undefined` values.
	 *
	 * @private
	 * @param {Object} object The object to modify.
	 * @param {string} key The key of the property to assign.
	 * @param {*} value The value to assign.
	 */
	function assignMergeValue(object, key, value) {
	  if ((value !== undefined && !eq(object[key], value)) ||
	      (value === undefined && !(key in object))) {
	    baseAssignValue(object, key, value);
	  }
	}
	
	module.exports = assignMergeValue;


/***/ }),
/* 190 */
/***/ (function(module, exports, __webpack_require__) {

	var baseAssignValue = __webpack_require__(132),
	    eq = __webpack_require__(58);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Assigns `value` to `key` of `object` if the existing value is not equivalent
	 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	 * for equality comparisons.
	 *
	 * @private
	 * @param {Object} object The object to modify.
	 * @param {string} key The key of the property to assign.
	 * @param {*} value The value to assign.
	 */
	function assignValue(object, key, value) {
	  var objValue = object[key];
	  if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) ||
	      (value === undefined && !(key in object))) {
	    baseAssignValue(object, key, value);
	  }
	}
	
	module.exports = assignValue;


/***/ }),
/* 191 */
/***/ (function(module, exports, __webpack_require__) {

	var baseForOwn = __webpack_require__(459),
	    createBaseEach = __webpack_require__(491);
	
	/**
	 * The base implementation of `_.forEach` without support for iteratee shorthands.
	 *
	 * @private
	 * @param {Array|Object} collection The collection to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Array|Object} Returns `collection`.
	 */
	var baseEach = createBaseEach(baseForOwn);
	
	module.exports = baseEach;


/***/ }),
/* 192 */
/***/ (function(module, exports, __webpack_require__) {

	var createBaseFor = __webpack_require__(492);
	
	/**
	 * The base implementation of `baseForOwn` which iterates over `object`
	 * properties returned by `keysFunc` and invokes `iteratee` for each property.
	 * Iteratee functions may exit iteration early by explicitly returning `false`.
	 *
	 * @private
	 * @param {Object} object The object to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @param {Function} keysFunc The function to get the keys of `object`.
	 * @returns {Object} Returns `object`.
	 */
	var baseFor = createBaseFor();
	
	module.exports = baseFor;


/***/ }),
/* 193 */
/***/ (function(module, exports, __webpack_require__) {

	var castPath = __webpack_require__(135),
	    toKey = __webpack_require__(57);
	
	/**
	 * The base implementation of `_.get` without support for default values.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {Array|string} path The path of the property to get.
	 * @returns {*} Returns the resolved value.
	 */
	function baseGet(object, path) {
	  path = castPath(path, object);
	
	  var index = 0,
	      length = path.length;
	
	  while (object != null && index < length) {
	    object = object[toKey(path[index++])];
	  }
	  return (index && index == length) ? object : undefined;
	}
	
	module.exports = baseGet;


/***/ }),
/* 194 */
/***/ (function(module, exports, __webpack_require__) {

	var baseIsEqualDeep = __webpack_require__(463),
	    isObjectLike = __webpack_require__(14);
	
	/**
	 * The base implementation of `_.isEqual` which supports partial comparisons
	 * and tracks traversed objects.
	 *
	 * @private
	 * @param {*} value The value to compare.
	 * @param {*} other The other value to compare.
	 * @param {boolean} bitmask The bitmask flags.
	 *  1 - Unordered comparison
	 *  2 - Partial comparison
	 * @param {Function} [customizer] The function to customize comparisons.
	 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
	 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	 */
	function baseIsEqual(value, other, bitmask, customizer, stack) {
	  if (value === other) {
	    return true;
	  }
	  if (value == null || other == null || (!isObjectLike(value) && !isObjectLike(other))) {
	    return value !== value && other !== other;
	  }
	  return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
	}
	
	module.exports = baseIsEqual;


/***/ }),
/* 195 */,
/* 196 */,
/* 197 */
/***/ (function(module, exports, __webpack_require__) {

	var SetCache = __webpack_require__(451),
	    arraySome = __webpack_require__(457),
	    cacheHas = __webpack_require__(483);
	
	/** Used to compose bitmasks for value comparisons. */
	var COMPARE_PARTIAL_FLAG = 1,
	    COMPARE_UNORDERED_FLAG = 2;
	
	/**
	 * A specialized version of `baseIsEqualDeep` for arrays with support for
	 * partial deep comparisons.
	 *
	 * @private
	 * @param {Array} array The array to compare.
	 * @param {Array} other The other array to compare.
	 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	 * @param {Function} customizer The function to customize comparisons.
	 * @param {Function} equalFunc The function to determine equivalents of values.
	 * @param {Object} stack Tracks traversed `array` and `other` objects.
	 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
	 */
	function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
	  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
	      arrLength = array.length,
	      othLength = other.length;
	
	  if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
	    return false;
	  }
	  // Assume cyclic values are equal.
	  var stacked = stack.get(array);
	  if (stacked && stack.get(other)) {
	    return stacked == other;
	  }
	  var index = -1,
	      result = true,
	      seen = (bitmask & COMPARE_UNORDERED_FLAG) ? new SetCache : undefined;
	
	  stack.set(array, other);
	  stack.set(other, array);
	
	  // Ignore non-index properties.
	  while (++index < arrLength) {
	    var arrValue = array[index],
	        othValue = other[index];
	
	    if (customizer) {
	      var compared = isPartial
	        ? customizer(othValue, arrValue, index, other, array, stack)
	        : customizer(arrValue, othValue, index, array, other, stack);
	    }
	    if (compared !== undefined) {
	      if (compared) {
	        continue;
	      }
	      result = false;
	      break;
	    }
	    // Recursively compare arrays (susceptible to call stack limits).
	    if (seen) {
	      if (!arraySome(other, function(othValue, othIndex) {
	            if (!cacheHas(seen, othIndex) &&
	                (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
	              return seen.push(othIndex);
	            }
	          })) {
	        result = false;
	        break;
	      }
	    } else if (!(
	          arrValue === othValue ||
	            equalFunc(arrValue, othValue, bitmask, customizer, stack)
	        )) {
	      result = false;
	      break;
	    }
	  }
	  stack['delete'](array);
	  stack['delete'](other);
	  return result;
	}
	
	module.exports = equalArrays;


/***/ }),
/* 198 */,
/* 199 */,
/* 200 */,
/* 201 */
/***/ (function(module, exports, __webpack_require__) {

	var overArg = __webpack_require__(204);
	
	/** Built-in value references. */
	var getPrototype = overArg(Object.getPrototypeOf, Object);
	
	module.exports = getPrototype;


/***/ }),
/* 202 */
/***/ (function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(13);
	
	/**
	 * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` if suitable for strict
	 *  equality comparisons, else `false`.
	 */
	function isStrictComparable(value) {
	  return value === value && !isObject(value);
	}
	
	module.exports = isStrictComparable;


/***/ }),
/* 203 */
/***/ (function(module, exports) {

	/**
	 * A specialized version of `matchesProperty` for source values suitable
	 * for strict equality comparisons, i.e. `===`.
	 *
	 * @private
	 * @param {string} key The key of the property to get.
	 * @param {*} srcValue The value to match.
	 * @returns {Function} Returns the new spec function.
	 */
	function matchesStrictComparable(key, srcValue) {
	  return function(object) {
	    if (object == null) {
	      return false;
	    }
	    return object[key] === srcValue &&
	      (srcValue !== undefined || (key in Object(object)));
	  };
	}
	
	module.exports = matchesStrictComparable;


/***/ }),
/* 204 */
/***/ (function(module, exports) {

	/**
	 * Creates a unary function that invokes `func` with its argument transformed.
	 *
	 * @private
	 * @param {Function} func The function to wrap.
	 * @param {Function} transform The argument transform.
	 * @returns {Function} Returns the new function.
	 */
	function overArg(func, transform) {
	  return function(arg) {
	    return func(transform(arg));
	  };
	}
	
	module.exports = overArg;


/***/ }),
/* 205 */,
/* 206 */
/***/ (function(module, exports) {

	/**
	 * Gets the value at `key`, unless `key` is "__proto__".
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {string} key The key of the property to get.
	 * @returns {*} Returns the property value.
	 */
	function safeGet(object, key) {
	  return key == '__proto__'
	    ? undefined
	    : object[key];
	}
	
	module.exports = safeGet;


/***/ }),
/* 207 */,
/* 208 */,
/* 209 */
/***/ (function(module, exports, __webpack_require__) {

	var arrayEach = __webpack_require__(453),
	    baseEach = __webpack_require__(191),
	    castFunction = __webpack_require__(484),
	    isArray = __webpack_require__(6);
	
	/**
	 * Iterates over elements of `collection` and invokes `iteratee` for each element.
	 * The iteratee is invoked with three arguments: (value, index|key, collection).
	 * Iteratee functions may exit iteration early by explicitly returning `false`.
	 *
	 * **Note:** As with other "Collections" methods, objects with a "length"
	 * property are iterated like arrays. To avoid this behavior use `_.forIn`
	 * or `_.forOwn` for object iteration.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @alias each
	 * @category Collection
	 * @param {Array|Object} collection The collection to iterate over.
	 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	 * @returns {Array|Object} Returns `collection`.
	 * @see _.forEachRight
	 * @example
	 *
	 * _.forEach([1, 2], function(value) {
	 *   console.log(value);
	 * });
	 * // => Logs `1` then `2`.
	 *
	 * _.forEach({ 'a': 1, 'b': 2 }, function(value, key) {
	 *   console.log(key);
	 * });
	 * // => Logs 'a' then 'b' (iteration order is not guaranteed).
	 */
	function forEach(collection, iteratee) {
	  var func = isArray(collection) ? arrayEach : baseEach;
	  return func(collection, castFunction(iteratee));
	}
	
	module.exports = forEach;


/***/ }),
/* 210 */
/***/ (function(module, exports, __webpack_require__) {

	var arrayLikeKeys = __webpack_require__(187),
	    baseKeysIn = __webpack_require__(469),
	    isArrayLike = __webpack_require__(59);
	
	/**
	 * Creates an array of the own and inherited enumerable property names of `object`.
	 *
	 * **Note:** Non-object values are coerced to objects.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.0.0
	 * @category Object
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 *   this.b = 2;
	 * }
	 *
	 * Foo.prototype.c = 3;
	 *
	 * _.keysIn(new Foo);
	 * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
	 */
	function keysIn(object) {
	  return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
	}
	
	module.exports = keysIn;


/***/ }),
/* 211 */
/***/ (function(module, exports, __webpack_require__) {

	var arrayReduce = __webpack_require__(456),
	    baseEach = __webpack_require__(191),
	    baseIteratee = __webpack_require__(467),
	    baseReduce = __webpack_require__(476),
	    isArray = __webpack_require__(6);
	
	/**
	 * Reduces `collection` to a value which is the accumulated result of running
	 * each element in `collection` thru `iteratee`, where each successive
	 * invocation is supplied the return value of the previous. If `accumulator`
	 * is not given, the first element of `collection` is used as the initial
	 * value. The iteratee is invoked with four arguments:
	 * (accumulator, value, index|key, collection).
	 *
	 * Many lodash methods are guarded to work as iteratees for methods like
	 * `_.reduce`, `_.reduceRight`, and `_.transform`.
	 *
	 * The guarded methods are:
	 * `assign`, `defaults`, `defaultsDeep`, `includes`, `merge`, `orderBy`,
	 * and `sortBy`
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Collection
	 * @param {Array|Object} collection The collection to iterate over.
	 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	 * @param {*} [accumulator] The initial value.
	 * @returns {*} Returns the accumulated value.
	 * @see _.reduceRight
	 * @example
	 *
	 * _.reduce([1, 2], function(sum, n) {
	 *   return sum + n;
	 * }, 0);
	 * // => 3
	 *
	 * _.reduce({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
	 *   (result[value] || (result[value] = [])).push(key);
	 *   return result;
	 * }, {});
	 * // => { '1': ['a', 'c'], '2': ['b'] } (iteration order is not guaranteed)
	 */
	function reduce(collection, iteratee, accumulator) {
	  var func = isArray(collection) ? arrayReduce : baseReduce,
	      initAccum = arguments.length < 3;
	
	  return func(collection, baseIteratee(iteratee, 4), accumulator, initAccum, baseEach);
	}
	
	module.exports = reduce;


/***/ }),
/* 212 */
/***/ (function(module, exports) {

	module.exports = function parseUnit(str, out) {
	    if (!out)
	        out = [ 0, '' ]
	
	    str = String(str)
	    var num = parseFloat(str, 10)
	    out[0] = num
	    out[1] = str.match(/[\d.\-\+]*\s*(.*)/)[1] || ''
	    return out
	}

/***/ }),
/* 213 */,
/* 214 */,
/* 215 */,
/* 216 */,
/* 217 */,
/* 218 */,
/* 219 */,
/* 220 */,
/* 221 */,
/* 222 */,
/* 223 */,
/* 224 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	var __assign = (this && this.__assign) || Object.assign || function(t) {
	    for (var s, i = 1, n = arguments.length; i < n; i++) {
	        s = arguments[i];
	        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
	            t[p] = s[p];
	    }
	    return t;
	};
	function __export(m) {
	    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
	}
	Object.defineProperty(exports, "__esModule", { value: true });
	__export(__webpack_require__(90));
	__export(__webpack_require__(22));
	__export(__webpack_require__(147));
	var apollo_link_1 = __webpack_require__(22);
	var apollo_link_http_1 = __webpack_require__(229);
	exports.HttpLink = apollo_link_http_1.HttpLink;
	var apollo_link_state_1 = __webpack_require__(230);
	var apollo_link_error_1 = __webpack_require__(227);
	var apollo_cache_inmemory_1 = __webpack_require__(147);
	exports.InMemoryCache = apollo_cache_inmemory_1.InMemoryCache;
	var graphql_tag_1 = __webpack_require__(78);
	exports.gql = graphql_tag_1.default;
	var apollo_client_1 = __webpack_require__(90);
	var DefaultClient = (function (_super) {
	    __extends(DefaultClient, _super);
	    function DefaultClient(config) {
	        var _this = this;
	        var cache = config && config.cacheRedirects
	            ? new apollo_cache_inmemory_1.InMemoryCache({ cacheRedirects: config.cacheRedirects })
	            : new apollo_cache_inmemory_1.InMemoryCache();
	        var stateLink = config && config.clientState
	            ? apollo_link_state_1.withClientState(__assign({}, config.clientState, { cache: cache }))
	            : false;
	        var errorLink = config && config.onError
	            ? apollo_link_error_1.onError(config.onError)
	            : apollo_link_error_1.onError(function (_a) {
	                var graphQLErrors = _a.graphQLErrors, networkError = _a.networkError;
	                if (graphQLErrors)
	                    graphQLErrors.map(function (_a) {
	                        var message = _a.message, locations = _a.locations, path = _a.path;
	                        return console.log("[GraphQL error]: Message: " + message + ", Location: " + locations + ", Path: " + path);
	                    });
	                if (networkError)
	                    console.log("[Network error]: " + networkError);
	            });
	        var requestHandler = config && config.request
	            ? new apollo_link_1.ApolloLink(function (operation, forward) {
	                return new apollo_link_1.Observable(function (observer) {
	                    var handle;
	                    Promise.resolve(operation)
	                        .then(function (oper) { return config.request(oper); })
	                        .then(function () {
	                        handle = forward(operation).subscribe({
	                            next: observer.next.bind(observer),
	                            error: observer.error.bind(observer),
	                            complete: observer.complete.bind(observer),
	                        });
	                    })
	                        .catch(observer.error.bind(observer));
	                    return function () {
	                        if (handle)
	                            handle.unsubscribe;
	                    };
	                });
	            })
	            : false;
	        var httpLink = new apollo_link_http_1.HttpLink({
	            uri: (config && config.uri) || '/graphql',
	            fetchOptions: (config && config.fetchOptions) || {},
	            credentials: 'same-origin',
	        });
	        var link = apollo_link_1.ApolloLink.from([
	            errorLink,
	            requestHandler,
	            stateLink,
	            httpLink,
	        ].filter(function (x) { return !!x; }));
	        _this = _super.call(this, { cache: cache, link: link }) || this;
	        return _this;
	    }
	    return DefaultClient;
	}(apollo_client_1.default));
	exports.default = DefaultClient;
	//# sourceMappingURL=index.js.map

/***/ }),
/* 225 */
/***/ (function(module, exports, __webpack_require__) {

	(function (global, factory) {
		 true ? factory(exports, __webpack_require__(23)) :
		typeof define === 'function' && define.amd ? define(['exports', 'apollo-utilities'], factory) :
		(factory((global.apollo = global.apollo || {}, global.apollo.cache = global.apollo.cache || {}, global.apollo.cache.core = {}),global.apollo.utilities));
	}(this, (function (exports,apolloUtilities) { 'use strict';
	
	function queryFromPojo(obj) {
	    var op = {
	        kind: 'OperationDefinition',
	        operation: 'query',
	        name: {
	            kind: 'Name',
	            value: 'GeneratedClientQuery',
	        },
	        selectionSet: selectionSetFromObj(obj),
	    };
	    var out = {
	        kind: 'Document',
	        definitions: [op],
	    };
	    return out;
	}
	function fragmentFromPojo(obj, typename) {
	    var frag = {
	        kind: 'FragmentDefinition',
	        typeCondition: {
	            kind: 'NamedType',
	            name: {
	                kind: 'Name',
	                value: typename || '__FakeType',
	            },
	        },
	        name: {
	            kind: 'Name',
	            value: 'GeneratedClientQuery',
	        },
	        selectionSet: selectionSetFromObj(obj),
	    };
	    var out = {
	        kind: 'Document',
	        definitions: [frag],
	    };
	    return out;
	}
	function selectionSetFromObj(obj) {
	    if (typeof obj === 'number' ||
	        typeof obj === 'boolean' ||
	        typeof obj === 'string' ||
	        typeof obj === 'undefined' ||
	        obj === null) {
	        // No selection set here
	        return null;
	    }
	    if (Array.isArray(obj)) {
	        // GraphQL queries don't include arrays
	        return selectionSetFromObj(obj[0]);
	    }
	    // Now we know it's an object
	    var selections = [];
	    Object.keys(obj).forEach(function (key) {
	        var field = {
	            kind: 'Field',
	            name: {
	                kind: 'Name',
	                value: key,
	            },
	        };
	        // Recurse
	        var nestedSelSet = selectionSetFromObj(obj[key]);
	        if (nestedSelSet) {
	            field.selectionSet = nestedSelSet;
	        }
	        selections.push(field);
	    });
	    var selectionSet = {
	        kind: 'SelectionSet',
	        selections: selections,
	    };
	    return selectionSet;
	}
	var justTypenameQuery = {
	    kind: 'Document',
	    definitions: [
	        {
	            kind: 'OperationDefinition',
	            operation: 'query',
	            name: null,
	            variableDefinitions: null,
	            directives: [],
	            selectionSet: {
	                kind: 'SelectionSet',
	                selections: [
	                    {
	                        kind: 'Field',
	                        alias: null,
	                        name: {
	                            kind: 'Name',
	                            value: '__typename',
	                        },
	                        arguments: [],
	                        directives: [],
	                        selectionSet: null,
	                    },
	                ],
	            },
	        },
	    ],
	};
	
	var __assign = (undefined && undefined.__assign) || Object.assign || function(t) {
	    for (var s, i = 1, n = arguments.length; i < n; i++) {
	        s = arguments[i];
	        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
	            t[p] = s[p];
	    }
	    return t;
	};
	var ApolloCache = /** @class */ (function () {
	    function ApolloCache() {
	    }
	    // optional API
	    ApolloCache.prototype.transformDocument = function (document) {
	        return document;
	    };
	    // experimental
	    ApolloCache.prototype.transformForLink = function (document) {
	        return document;
	    };
	    // DataProxy API
	    /**
	     *
	     * @param options
	     * @param optimistic
	     */
	    ApolloCache.prototype.readQuery = function (options, optimistic) {
	        if (optimistic === void 0) { optimistic = false; }
	        return this.read({
	            query: options.query,
	            variables: options.variables,
	            optimistic: optimistic,
	        });
	    };
	    ApolloCache.prototype.readFragment = function (options, optimistic) {
	        if (optimistic === void 0) { optimistic = false; }
	        return this.read({
	            query: apolloUtilities.getFragmentQueryDocument(options.fragment, options.fragmentName),
	            variables: options.variables,
	            rootId: options.id,
	            optimistic: optimistic,
	        });
	    };
	    ApolloCache.prototype.writeQuery = function (options) {
	        this.write({
	            dataId: 'ROOT_QUERY',
	            result: options.data,
	            query: options.query,
	            variables: options.variables,
	        });
	    };
	    ApolloCache.prototype.writeFragment = function (options) {
	        this.write({
	            dataId: options.id,
	            result: options.data,
	            variables: options.variables,
	            query: apolloUtilities.getFragmentQueryDocument(options.fragment, options.fragmentName),
	        });
	    };
	    ApolloCache.prototype.writeData = function (_a) {
	        var id = _a.id, data = _a.data;
	        if (typeof id !== 'undefined') {
	            var typenameResult = null;
	            // Since we can't use fragments without having a typename in the store,
	            // we need to make sure we have one.
	            // To avoid overwriting an existing typename, we need to read it out first
	            // and generate a fake one if none exists.
	            try {
	                typenameResult = this.read({
	                    rootId: id,
	                    optimistic: false,
	                    query: justTypenameQuery,
	                });
	            }
	            catch (e) {
	                // Do nothing, since an error just means no typename exists
	            }
	            // tslint:disable-next-line
	            var __typename = (typenameResult && typenameResult.__typename) || '__ClientData';
	            // Add a type here to satisfy the inmemory cache
	            var dataToWrite = __assign({ __typename: __typename }, data);
	            this.writeFragment({
	                id: id,
	                fragment: fragmentFromPojo(dataToWrite, __typename),
	                data: dataToWrite,
	            });
	        }
	        else {
	            this.writeQuery({ query: queryFromPojo(data), data: data });
	        }
	    };
	    return ApolloCache;
	}());
	
	(function (Cache) {
	})(exports.Cache || (exports.Cache = {}));
	
	exports.ApolloCache = ApolloCache;
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	})));
	//# sourceMappingURL=bundle.umd.js.map


/***/ }),
/* 226 */,
/* 227 */
/***/ (function(module, exports, __webpack_require__) {

	(function (global, factory) {
		 true ? factory(exports, __webpack_require__(22)) :
		typeof define === 'function' && define.amd ? define(['exports', 'apollo-link'], factory) :
		(factory((global.apolloLink = global.apolloLink || {}, global.apolloLink.error = {}),global.apolloLink.core));
	}(this, (function (exports,apolloLink) { 'use strict';
	
	var __extends = (undefined && undefined.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	var onError = function (errorHandler) {
	    return new apolloLink.ApolloLink(function (operation, forward) {
	        return new apolloLink.Observable(function (observer) {
	            var sub;
	            try {
	                sub = forward(operation).subscribe({
	                    next: function (result) {
	                        if (result.errors) {
	                            errorHandler({
	                                graphQLErrors: result.errors,
	                                response: result,
	                                operation: operation,
	                            });
	                        }
	                        observer.next(result);
	                    },
	                    error: function (networkError) {
	                        errorHandler({
	                            operation: operation,
	                            networkError: networkError,
	                            graphQLErrors: networkError.result && networkError.result.errors,
	                        });
	                        observer.error(networkError);
	                    },
	                    complete: observer.complete.bind(observer),
	                });
	            }
	            catch (e) {
	                errorHandler({ networkError: e, operation: operation });
	                observer.error(e);
	            }
	            return function () {
	                if (sub)
	                    sub.unsubscribe();
	            };
	        });
	    });
	};
	var ErrorLink = (function (_super) {
	    __extends(ErrorLink, _super);
	    function ErrorLink(errorHandler) {
	        var _this = _super.call(this) || this;
	        _this.link = onError(errorHandler);
	        return _this;
	    }
	    ErrorLink.prototype.request = function (operation, forward) {
	        return this.link.request(operation, forward);
	    };
	    return ErrorLink;
	}(apolloLink.ApolloLink));
	
	exports.onError = onError;
	exports.ErrorLink = ErrorLink;
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	})));
	//# sourceMappingURL=bundle.umd.js.map


/***/ }),
/* 228 */
/***/ (function(module, exports, __webpack_require__) {

	(function (global, factory) {
		 true ? factory(exports, __webpack_require__(79)) :
		typeof define === 'function' && define.amd ? define(['exports', 'graphql/language/printer'], factory) :
		(factory((global.apolloLink = global.apolloLink || {}, global.apolloLink.httpCommon = {}),global.printer));
	}(this, (function (exports,printer) { 'use strict';
	
	var __assign = (undefined && undefined.__assign) || Object.assign || function(t) {
	    for (var s, i = 1, n = arguments.length; i < n; i++) {
	        s = arguments[i];
	        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
	            t[p] = s[p];
	    }
	    return t;
	};
	var defaultHttpOptions = {
	    includeQuery: true,
	    includeExtensions: false,
	};
	var defaultHeaders = {
	    accept: '*/*',
	    'content-type': 'application/json',
	};
	var defaultOptions = {
	    method: 'POST',
	};
	var fallbackHttpConfig = {
	    http: defaultHttpOptions,
	    headers: defaultHeaders,
	    options: defaultOptions,
	};
	var throwServerError = function (response, result, message) {
	    var error = new Error(message);
	    error.response = response;
	    error.statusCode = response.status;
	    error.result = result;
	    throw error;
	};
	var parseAndCheckHttpResponse = function (operations) { return function (response) {
	    return (response
	        .text()
	        .then(function (bodyText) {
	        try {
	            return JSON.parse(bodyText);
	        }
	        catch (err) {
	            var parseError = err;
	            parseError.response = response;
	            parseError.statusCode = response.status;
	            parseError.bodyText = bodyText;
	            return Promise.reject(parseError);
	        }
	    })
	        .then(function (result) {
	        if (response.status >= 300) {
	            throwServerError(response, result, "Response not successful: Received status code " + response.status);
	        }
	        if (!Array.isArray(result) &&
	            !result.hasOwnProperty('data') &&
	            !result.hasOwnProperty('errors')) {
	            throwServerError(response, result, "Server response was missing for query '" + (Array.isArray(operations)
	                ? operations.map(function (op) { return op.operationName; })
	                : operations.operationName) + "'.");
	        }
	        return result;
	    }));
	}; };
	var checkFetcher = function (fetcher) {
	    if (!fetcher && typeof fetch === 'undefined') {
	        var library = 'unfetch';
	        if (typeof window === 'undefined')
	            library = 'node-fetch';
	        throw new Error("\nfetch is not found globally and no fetcher passed, to fix pass a fetch for\nyour environment like https://www.npmjs.com/package/" + library + ".\n\nFor example:\nimport fetch from '" + library + "';\nimport { createHttpLink } from 'apollo-link-http';\n\nconst link = createHttpLink({ uri: '/graphql', fetch: fetch });");
	    }
	};
	var createSignalIfSupported = function () {
	    if (typeof AbortController === 'undefined')
	        return { controller: false, signal: false };
	    var controller = new AbortController();
	    var signal = controller.signal;
	    return { controller: controller, signal: signal };
	};
	var selectHttpOptionsAndBody = function (operation, fallbackConfig) {
	    var configs = [];
	    for (var _i = 2; _i < arguments.length; _i++) {
	        configs[_i - 2] = arguments[_i];
	    }
	    var options = __assign({}, fallbackConfig.options, { headers: fallbackConfig.headers, credentials: fallbackConfig.credentials });
	    var http = fallbackConfig.http;
	    configs.forEach(function (config) {
	        options = __assign({}, options, config.options, { headers: __assign({}, options.headers, config.headers) });
	        if (config.credentials)
	            options.credentials = config.credentials;
	        http = __assign({}, http, config.http);
	    });
	    var operationName = operation.operationName, extensions = operation.extensions, variables = operation.variables, query = operation.query;
	    var body = { operationName: operationName, variables: variables };
	    if (http.includeExtensions)
	        body.extensions = extensions;
	    if (http.includeQuery)
	        body.query = printer.print(query);
	    return {
	        options: options,
	        body: body,
	    };
	};
	var serializeFetchParameter = function (p, label) {
	    var serialized;
	    try {
	        serialized = JSON.stringify(p);
	    }
	    catch (e) {
	        var parseError = new Error("Network request failed. " + label + " is not serializable: " + e.message);
	        parseError.parseError = e;
	        throw parseError;
	    }
	    return serialized;
	};
	var selectURI = function (operation, fallbackURI) {
	    var context = operation.getContext();
	    var contextURI = context.uri;
	    if (contextURI) {
	        return contextURI;
	    }
	    else if (typeof fallbackURI === 'function') {
	        return fallbackURI(operation);
	    }
	    else {
	        return fallbackURI || '/graphql';
	    }
	};
	
	exports.fallbackHttpConfig = fallbackHttpConfig;
	exports.throwServerError = throwServerError;
	exports.parseAndCheckHttpResponse = parseAndCheckHttpResponse;
	exports.checkFetcher = checkFetcher;
	exports.createSignalIfSupported = createSignalIfSupported;
	exports.selectHttpOptionsAndBody = selectHttpOptionsAndBody;
	exports.serializeFetchParameter = serializeFetchParameter;
	exports.selectURI = selectURI;
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	})));
	//# sourceMappingURL=bundle.umd.js.map


/***/ }),
/* 229 */
/***/ (function(module, exports, __webpack_require__) {

	(function (global, factory) {
		 true ? factory(exports, __webpack_require__(22), __webpack_require__(228)) :
		typeof define === 'function' && define.amd ? define(['exports', 'apollo-link', 'apollo-link-http-common'], factory) :
		(factory((global.apolloLink = global.apolloLink || {}, global.apolloLink.http = {}),global.apolloLink.core,global.apolloLink.httpCommon));
	}(this, (function (exports,apolloLink,apolloLinkHttpCommon) { 'use strict';
	
	var __extends = (undefined && undefined.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	var __rest = (undefined && undefined.__rest) || function (s, e) {
	    var t = {};
	    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
	        t[p] = s[p];
	    if (s != null && typeof Object.getOwnPropertySymbols === "function")
	        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
	            t[p[i]] = s[p[i]];
	    return t;
	};
	var createHttpLink = function (linkOptions) {
	    if (linkOptions === void 0) { linkOptions = {}; }
	    var _a = linkOptions.uri, uri = _a === void 0 ? '/graphql' : _a, fetcher = linkOptions.fetch, includeExtensions = linkOptions.includeExtensions, useGETForQueries = linkOptions.useGETForQueries, requestOptions = __rest(linkOptions, ["uri", "fetch", "includeExtensions", "useGETForQueries"]);
	    apolloLinkHttpCommon.checkFetcher(fetcher);
	    if (!fetcher) {
	        fetcher = fetch;
	    }
	    var linkConfig = {
	        http: { includeExtensions: includeExtensions },
	        options: requestOptions.fetchOptions,
	        credentials: requestOptions.credentials,
	        headers: requestOptions.headers,
	    };
	    return new apolloLink.ApolloLink(function (operation) {
	        var chosenURI = apolloLinkHttpCommon.selectURI(operation, uri);
	        var context = operation.getContext();
	        var contextConfig = {
	            http: context.http,
	            options: context.fetchOptions,
	            credentials: context.credentials,
	            headers: context.headers,
	        };
	        var _a = apolloLinkHttpCommon.selectHttpOptionsAndBody(operation, apolloLinkHttpCommon.fallbackHttpConfig, linkConfig, contextConfig), options = _a.options, body = _a.body;
	        var _b = apolloLinkHttpCommon.createSignalIfSupported(), controller = _b.controller, signal = _b.signal;
	        if (controller)
	            options.signal = signal;
	        var definitionIsMutation = function (d) {
	            return d.kind === 'OperationDefinition' && d.operation === 'mutation';
	        };
	        if (useGETForQueries &&
	            !operation.query.definitions.some(definitionIsMutation)) {
	            options.method = 'GET';
	        }
	        if (options.method === 'GET') {
	            var _c = rewriteURIForGET(chosenURI, body), newURI = _c.newURI, parseError = _c.parseError;
	            if (parseError) {
	                return apolloLink.fromError(parseError);
	            }
	            chosenURI = newURI;
	        }
	        else {
	            try {
	                options.body = apolloLinkHttpCommon.serializeFetchParameter(body, 'Payload');
	            }
	            catch (parseError) {
	                return apolloLink.fromError(parseError);
	            }
	        }
	        return new apolloLink.Observable(function (observer) {
	            fetcher(chosenURI, options)
	                .then(function (response) {
	                operation.setContext({ response: response });
	                return response;
	            })
	                .then(apolloLinkHttpCommon.parseAndCheckHttpResponse(operation))
	                .then(function (result) {
	                observer.next(result);
	                observer.complete();
	                return result;
	            })
	                .catch(function (err) {
	                if (err.name === 'AbortError')
	                    return;
	                if (err.result && err.result.errors && err.result.data) {
	                    observer.next(err.result);
	                }
	                observer.error(err);
	            });
	            return function () {
	                if (controller)
	                    controller.abort();
	            };
	        });
	    });
	};
	function rewriteURIForGET(chosenURI, body) {
	    var queryParams = [];
	    var addQueryParam = function (key, value) {
	        queryParams.push(key + "=" + encodeURIComponent(value));
	    };
	    if ('query' in body) {
	        addQueryParam('query', body.query);
	    }
	    if (body.operationName) {
	        addQueryParam('operationName', body.operationName);
	    }
	    if (body.variables) {
	        var serializedVariables = void 0;
	        try {
	            serializedVariables = apolloLinkHttpCommon.serializeFetchParameter(body.variables, 'Variables map');
	        }
	        catch (parseError) {
	            return { parseError: parseError };
	        }
	        addQueryParam('variables', serializedVariables);
	    }
	    if (body.extensions) {
	        var serializedExtensions = void 0;
	        try {
	            serializedExtensions = apolloLinkHttpCommon.serializeFetchParameter(body.extensions, 'Extensions map');
	        }
	        catch (parseError) {
	            return { parseError: parseError };
	        }
	        addQueryParam('extensions', serializedExtensions);
	    }
	    var fragment = '', preFragment = chosenURI;
	    var fragmentStart = chosenURI.indexOf('#');
	    if (fragmentStart !== -1) {
	        fragment = chosenURI.substr(fragmentStart);
	        preFragment = chosenURI.substr(0, fragmentStart);
	    }
	    var queryParamsPrefix = preFragment.indexOf('?') === -1 ? '?' : '&';
	    var newURI = preFragment + queryParamsPrefix + queryParams.join('&') + fragment;
	    return { newURI: newURI };
	}
	var HttpLink = (function (_super) {
	    __extends(HttpLink, _super);
	    function HttpLink(opts) {
	        return _super.call(this, createHttpLink(opts).request) || this;
	    }
	    return HttpLink;
	}(apolloLink.ApolloLink));
	
	exports.createHttpLink = createHttpLink;
	exports.HttpLink = HttpLink;
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	})));
	//# sourceMappingURL=bundle.umd.js.map


/***/ }),
/* 230 */
/***/ (function(module, exports, __webpack_require__) {

	(function (global, factory) {
		 true ? factory(exports, __webpack_require__(23), __webpack_require__(22), __webpack_require__(414)) :
		typeof define === 'function' && define.amd ? define(['exports', 'apollo-utilities', 'apollo-link', 'graphql-anywhere/lib/async'], factory) :
		(factory((global.apolloLink = global.apolloLink || {}, global.apolloLink.state = {}),global.apollo.utilities,global.apolloLink.core,global.graphqlAnywhere.async));
	}(this, (function (exports,apolloUtilities,apolloLink,async) { 'use strict';
	
	var connectionRemoveConfig = {
	    test: function (directive) { return directive.name.value === 'client'; },
	    remove: true,
	};
	var removed = new Map();
	function removeClientSetsFromDocument(query) {
	    var cached = removed.get(query);
	    if (cached)
	        return cached;
	    apolloUtilities.checkDocument(query);
	    var docClone = apolloUtilities.removeDirectivesFromDocument([connectionRemoveConfig], query);
	    removed.set(query, docClone);
	    return docClone;
	}
	
	var __extends = (undefined && undefined.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	var capitalizeFirstLetter = function (str) { return str.charAt(0).toUpperCase() + str.slice(1); };
	var withClientState = function (clientStateConfig) {
	    if (clientStateConfig === void 0) { clientStateConfig = { resolvers: {}, defaults: {} }; }
	    var resolvers = clientStateConfig.resolvers, defaults = clientStateConfig.defaults, cache = clientStateConfig.cache, typeDefs = clientStateConfig.typeDefs;
	    if (cache && defaults) {
	        cache.writeData({ data: defaults });
	    }
	    return new (function (_super) {
	        __extends(StateLink, _super);
	        function StateLink() {
	            return _super !== null && _super.apply(this, arguments) || this;
	        }
	        StateLink.prototype.writeDefaults = function () {
	            if (cache && defaults) {
	                cache.writeData({ data: defaults });
	            }
	        };
	        StateLink.prototype.request = function (operation, forward) {
	            if (forward === void 0) { forward = function () { return apolloLink.Observable.of({ data: {} }); }; }
	            if (typeDefs) {
	                var directives_1 = 'directive @client on FIELD';
	                var definition_1 = typeof typeDefs === 'string'
	                    ? typeDefs
	                    : typeDefs.map(function (typeDef) { return typeDef.trim(); }).join('\n');
	                operation.setContext(function (_a) {
	                    var _b = _a.schemas, schemas = _b === void 0 ? [] : _b;
	                    return ({
	                        schemas: schemas.concat([{ definition: definition_1, directives: directives_1 }]),
	                    });
	                });
	            }
	            var isClient = apolloUtilities.hasDirectives(['client'], operation.query);
	            if (!isClient)
	                return forward(operation);
	            var server = removeClientSetsFromDocument(operation.query);
	            var query = operation.query;
	            var type = capitalizeFirstLetter((apolloUtilities.getMainDefinition(query) || {}).operation) || 'Query';
	            var resolver = function (fieldName, rootValue, args, context, info) {
	                if (rootValue === void 0) { rootValue = {}; }
	                var fieldValue = rootValue[info.resultKey];
	                if (fieldValue !== undefined)
	                    return fieldValue;
	                var resolverMap = resolvers[rootValue.__typename || type];
	                if (resolverMap) {
	                    var resolve = resolverMap[fieldName];
	                    if (resolve)
	                        return resolve(rootValue, args, context, info);
	                }
	                return defaults[fieldName];
	            };
	            return new apolloLink.Observable(function (observer) {
	                if (server)
	                    operation.query = server;
	                var obs = server && forward
	                    ? forward(operation)
	                    : apolloLink.Observable.of({
	                        data: {},
	                    });
	                var observerErrorHandler = observer.error.bind(observer);
	                var sub = obs.subscribe({
	                    next: function (_a) {
	                        var data = _a.data, errors = _a.errors;
	                        var context = operation.getContext();
	                        async.graphql(resolver, query, data, context, operation.variables)
	                            .then(function (nextData) {
	                            observer.next({
	                                data: nextData,
	                                errors: errors,
	                            });
	                            observer.complete();
	                        })
	                            .catch(observerErrorHandler);
	                    },
	                    error: observerErrorHandler,
	                });
	                return function () {
	                    if (sub)
	                        sub.unsubscribe();
	                };
	            });
	        };
	        return StateLink;
	    }(apolloLink.ApolloLink))();
	};
	
	exports.withClientState = withClientState;
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	})));
	//# sourceMappingURL=bundle.umd.js.map


/***/ }),
/* 231 */,
/* 232 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	// prefer default export if available
	var preferDefault = function preferDefault(m) {
	  return m && m.default || m;
	};
	
	exports.components = {
	  "component---src-templates-proposal-js": __webpack_require__(385),
	  "component---src-pages-404-js": __webpack_require__(380),
	  "component---src-pages-closed-js": __webpack_require__(381),
	  "component---src-pages-index-js": __webpack_require__(382),
	  "component---src-pages-new-js": __webpack_require__(383),
	  "component---src-pages-proposal-js": __webpack_require__(384)
	};
	
	exports.json = {
	  "layout-index.json": __webpack_require__(386),
	  "proposal-mdu-6-sx-nzd-w-uz-nda-0-nz-u-3-mj-i.json": __webpack_require__(404),
	  "proposal-mdu-6-sx-nzd-w-uz-m-tkz-nz-qx-mj-u.json": __webpack_require__(402),
	  "proposal-mdu-6-sx-nzd-w-uz-m-tg-3-ntq-4-odu.json": __webpack_require__(401),
	  "proposal-mdu-6-sx-nzd-w-uz-md-ey-nd-ux-mtq.json": __webpack_require__(403),
	  "proposal-mdu-6-sx-nzd-w-uy-oty-5-nzc-5-mz-u.json": __webpack_require__(400),
	  "proposal-mdu-6-sx-nzd-w-uy-odu-2-o-tgy-mz-m.json": __webpack_require__(399),
	  "proposal-mdu-6-sx-nzd-w-uy-nz-u-2-m-dc-0-n-dg.json": __webpack_require__(398),
	  "proposal-mdu-6-sx-nzd-w-uy-nz-qy-nz-uw-mz-u.json": __webpack_require__(397),
	  "proposal-mdu-6-sx-nzd-w-uy-nz-qy-nj-az-m-tk.json": __webpack_require__(395),
	  "proposal-mdu-6-sx-nzd-w-uy-nz-qy-nta-3-nti.json": __webpack_require__(396),
	  "proposal-mdu-6-sx-nzd-w-uy-nz-qy-mz-uw-nty.json": __webpack_require__(394),
	  "proposal-mdu-6-sx-nzd-w-uy-nz-qy-mz-e-5-mzg.json": __webpack_require__(393),
	  "404.json": __webpack_require__(387),
	  "closed.json": __webpack_require__(389),
	  "index.json": __webpack_require__(390),
	  "new.json": __webpack_require__(391),
	  "proposal.json": __webpack_require__(392),
	  "404-html.json": __webpack_require__(388)
	};
	
	exports.layouts = {
	  "layout---index": __webpack_require__(379)
	};

/***/ }),
/* 233 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _loader = __webpack_require__(148);
	
	var _loader2 = _interopRequireDefault(_loader);
	
	var _emitter = __webpack_require__(65);
	
	var _emitter2 = _interopRequireDefault(_emitter);
	
	var _apiRunnerBrowser = __webpack_require__(91);
	
	var _shallowCompare = __webpack_require__(609);
	
	var _shallowCompare2 = _interopRequireDefault(_shallowCompare);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var DefaultLayout = function DefaultLayout(_ref) {
	  var children = _ref.children;
	  return _react2.default.createElement(
	    "div",
	    null,
	    children()
	  );
	};
	
	// Pass pathname in as prop.
	// component will try fetching resources. If they exist,
	// will just render, else will render null.
	
	var ComponentRenderer = function (_React$Component) {
	  _inherits(ComponentRenderer, _React$Component);
	
	  function ComponentRenderer(props) {
	    _classCallCheck(this, ComponentRenderer);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this));
	
	    var location = props.location;
	
	    // Set the pathname for 404 pages.
	    if (!_loader2.default.getPage(location.pathname)) {
	      location = _extends({}, location, {
	        pathname: "/404.html"
	      });
	    }
	
	    _this.state = {
	      location: location,
	      pageResources: _loader2.default.getResourcesForPathname(location.pathname)
	    };
	    return _this;
	  }
	
	  ComponentRenderer.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	    var _this2 = this;
	
	    // During development, always pass a component's JSON through so graphql
	    // updates go through.
	    if (false) {
	      if (nextProps && nextProps.pageResources && nextProps.pageResources.json) {
	        this.setState({ pageResources: nextProps.pageResources });
	      }
	    }
	    if (this.state.location.pathname !== nextProps.location.pathname) {
	      var pageResources = _loader2.default.getResourcesForPathname(nextProps.location.pathname);
	      if (!pageResources) {
	        var location = nextProps.location;
	
	        // Set the pathname for 404 pages.
	        if (!_loader2.default.getPage(location.pathname)) {
	          location = _extends({}, location, {
	            pathname: "/404.html"
	          });
	        }
	
	        // Page resources won't be set in cases where the browser back button
	        // or forward button is pushed as we can't wait as normal for resources
	        // to load before changing the page.
	        _loader2.default.getResourcesForPathname(location.pathname, function (pageResources) {
	          _this2.setState({
	            location: location,
	            pageResources: pageResources
	          });
	        });
	      } else {
	        this.setState({
	          location: nextProps.location,
	          pageResources: pageResources
	        });
	      }
	    }
	  };
	
	  ComponentRenderer.prototype.componentDidMount = function componentDidMount() {
	    var _this3 = this;
	
	    // Listen to events so when our page gets updated, we can transition.
	    // This is only useful on delayed transitions as the page will get rendered
	    // without the necessary page resources and then re-render once those come in.
	    _emitter2.default.on("onPostLoadPageResources", function (e) {
	      if (_loader2.default.getPage(_this3.state.location.pathname) && e.page.path === _loader2.default.getPage(_this3.state.location.pathname).path) {
	        _this3.setState({ pageResources: e.pageResources });
	      }
	    });
	  };
	
	  ComponentRenderer.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps, nextState) {
	    // 404
	    if (!nextState.pageResources) {
	      return true;
	    }
	    // Check if the component or json have changed.
	    if (!this.state.pageResources && nextState.pageResources) {
	      return true;
	    }
	    if (this.state.pageResources.component !== nextState.pageResources.component) {
	      return true;
	    }
	
	    if (this.state.pageResources.json !== nextState.pageResources.json) {
	      return true;
	    }
	
	    // Check if location has changed on a page using internal routing
	    // via matchPath configuration.
	    if (this.state.location.key !== nextState.location.key && nextState.pageResources.page && (nextState.pageResources.page.matchPath || nextState.pageResources.page.path)) {
	      return true;
	    }
	
	    return (0, _shallowCompare2.default)(this, nextProps, nextState);
	  };
	
	  ComponentRenderer.prototype.render = function render() {
	    var pluginResponses = (0, _apiRunnerBrowser.apiRunner)("replaceComponentRenderer", {
	      props: _extends({}, this.props, { pageResources: this.state.pageResources }),
	      loader: _loader.publicLoader
	    });
	    var replacementComponent = pluginResponses[0];
	    // If page.
	    if (this.props.page) {
	      if (this.state.pageResources) {
	        return replacementComponent || (0, _react.createElement)(this.state.pageResources.component, _extends({
	          key: this.props.location.pathname
	        }, this.props, this.state.pageResources.json));
	      } else {
	        return null;
	      }
	      // If layout.
	    } else if (this.props.layout) {
	      return replacementComponent || (0, _react.createElement)(this.state.pageResources && this.state.pageResources.layout ? this.state.pageResources.layout : DefaultLayout, _extends({
	        key: this.state.pageResources && this.state.pageResources.layout ? this.state.pageResources.layout : "DefaultLayout"
	      }, this.props));
	    } else {
	      return null;
	    }
	  };
	
	  return ComponentRenderer;
	}(_react2.default.Component);
	
	ComponentRenderer.propTypes = {
	  page: _propTypes2.default.bool,
	  layout: _propTypes2.default.bool,
	  location: _propTypes2.default.object
	};
	
	exports.default = ComponentRenderer;
	module.exports = exports["default"];

/***/ }),
/* 234 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _reactRouterDom = __webpack_require__(62);
	
	var _stripPrefix = __webpack_require__(149);
	
	var _stripPrefix2 = _interopRequireDefault(_stripPrefix);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// TODO add tests especially for handling prefixed links.
	var pageCache = {};
	
	module.exports = function (pages) {
	  var pathPrefix = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "";
	  return function (rawPathname) {
	    var pathname = decodeURIComponent(rawPathname);
	
	    // Remove the pathPrefix from the pathname.
	    var trimmedPathname = (0, _stripPrefix2.default)(pathname, pathPrefix);
	
	    // Remove any hashfragment
	    if (trimmedPathname.split("#").length > 1) {
	      trimmedPathname = trimmedPathname.split("#").slice(0, -1).join("");
	    }
	
	    // Remove search query
	    if (trimmedPathname.split("?").length > 1) {
	      trimmedPathname = trimmedPathname.split("?").slice(0, -1).join("");
	    }
	
	    if (pageCache[trimmedPathname]) {
	      return pageCache[trimmedPathname];
	    }
	
	    var foundPage = void 0;
	    // Array.prototype.find is not supported in IE so we use this somewhat odd
	    // work around.
	    pages.some(function (page) {
	      if (page.matchPath) {
	        // Try both the path and matchPath
	        if ((0, _reactRouterDom.matchPath)(trimmedPathname, { path: page.path }) || (0, _reactRouterDom.matchPath)(trimmedPathname, {
	          path: page.matchPath
	        })) {
	          foundPage = page;
	          pageCache[trimmedPathname] = page;
	          return true;
	        }
	      } else {
	        if ((0, _reactRouterDom.matchPath)(trimmedPathname, {
	          path: page.path,
	          exact: true
	        })) {
	          foundPage = page;
	          pageCache[trimmedPathname] = page;
	          return true;
	        }
	
	        // Finally, try and match request with default document.
	        if ((0, _reactRouterDom.matchPath)(trimmedPathname, {
	          path: page.path + "index.html"
	        })) {
	          foundPage = page;
	          pageCache[trimmedPathname] = page;
	          return true;
	        }
	      }
	
	      return false;
	    });
	
	    return foundPage;
	  };
	};

/***/ }),
/* 235 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _createBrowserHistory = __webpack_require__(123);
	
	var _createBrowserHistory2 = _interopRequireDefault(_createBrowserHistory);
	
	var _apiRunnerBrowser = __webpack_require__(91);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var pluginResponses = (0, _apiRunnerBrowser.apiRunner)("replaceHistory");
	var replacementHistory = pluginResponses[0];
	var history = replacementHistory || (0, _createBrowserHistory2.default)();
	module.exports = history;

/***/ }),
/* 236 */,
/* 237 */
/***/ (function(module, exports) {

	"use strict";
	
	module.exports = function (_ref) {
	  var getNextQueuedResources = _ref.getNextQueuedResources,
	      createResourceDownload = _ref.createResourceDownload;
	
	  var pagesLoading = [];
	  var resourcesDownloading = [];
	
	  // Do things
	  var startResourceDownloading = function startResourceDownloading() {
	    var nextResource = getNextQueuedResources();
	    if (nextResource) {
	      resourcesDownloading.push(nextResource);
	      createResourceDownload(nextResource);
	    }
	  };
	
	  var reducer = function reducer(action) {
	    switch (action.type) {
	      case "RESOURCE_FINISHED":
	        resourcesDownloading = resourcesDownloading.filter(function (r) {
	          return r !== action.payload;
	        });
	        break;
	      case "ON_PRE_LOAD_PAGE_RESOURCES":
	        pagesLoading.push(action.payload.path);
	        break;
	      case "ON_POST_LOAD_PAGE_RESOURCES":
	        pagesLoading = pagesLoading.filter(function (p) {
	          return p !== action.payload.page.path;
	        });
	        break;
	      case "ON_NEW_RESOURCES_ADDED":
	        break;
	    }
	
	    // Take actions.
	    // Wait for event loop queue to finish.
	    setTimeout(function () {
	      if (resourcesDownloading.length === 0 && pagesLoading.length === 0) {
	        // Start another resource downloading.
	        startResourceDownloading();
	      }
	    }, 0);
	  };
	
	  return {
	    onResourcedFinished: function onResourcedFinished(event) {
	      // Tell prefetcher that the resource finished downloading
	      // so it can grab the next one.
	      reducer({ type: "RESOURCE_FINISHED", payload: event });
	    },
	    onPreLoadPageResources: function onPreLoadPageResources(event) {
	      // Tell prefetcher a page load has started so it should stop
	      // loading anything new
	      reducer({ type: "ON_PRE_LOAD_PAGE_RESOURCES", payload: event });
	    },
	    onPostLoadPageResources: function onPostLoadPageResources(event) {
	      // Tell prefetcher a page load has finished so it should start
	      // loading resources again.
	      reducer({ type: "ON_POST_LOAD_PAGE_RESOURCES", payload: event });
	    },
	    onNewResourcesAdded: function onNewResourcesAdded() {
	      // Tell prefetcher that more resources to be downloaded have
	      // been added.
	      reducer({ type: "ON_NEW_RESOURCES_ADDED" });
	    },
	    getState: function getState() {
	      return { pagesLoading: pagesLoading, resourcesDownloading: resourcesDownloading };
	    },
	    empty: function empty() {
	      pagesLoading = [];
	      resourcesDownloading = [];
	    }
	  };
	};

/***/ }),
/* 238 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _emitter = __webpack_require__(65);
	
	var _emitter2 = _interopRequireDefault(_emitter);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var pathPrefix = "/";
	if (false) {
	  pathPrefix = __PATH_PREFIX__ + "/";
	}
	
	if ("serviceWorker" in navigator) {
	  navigator.serviceWorker.register(pathPrefix + "sw.js").then(function (reg) {
	    reg.addEventListener("updatefound", function () {
	      // The updatefound event implies that reg.installing is set; see
	      // https://w3c.github.io/ServiceWorker/#service-worker-registration-updatefound-event
	      var installingWorker = reg.installing;
	      console.log("installingWorker", installingWorker);
	      installingWorker.addEventListener("statechange", function () {
	        switch (installingWorker.state) {
	          case "installed":
	            if (navigator.serviceWorker.controller) {
	              // At this point, the old content will have been purged and the fresh content will
	              // have been added to the cache.
	              // We reload immediately so the user sees the new content.
	              // This could/should be made configurable in the future.
	              window.location.reload();
	            } else {
	              // At this point, everything has been precached.
	              // It's the perfect time to display a "Content is cached for offline use." message.
	              console.log("Content is now available offline!");
	              _emitter2.default.emit("sw:installed");
	            }
	            break;
	
	          case "redundant":
	            console.error("The installing service worker became redundant.");
	            break;
	        }
	      });
	    });
	  }).catch(function (e) {
	    console.error("Error during service worker registration:", e);
	  });
	}

/***/ }),
/* 239 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouterDom = __webpack_require__(62);
	
	var _gatsbyBrowser = __webpack_require__(407);
	
	var _client = __webpack_require__(240);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.onClientEntry = _gatsbyBrowser.onClientEntry;
	
	exports.replaceRouterComponent = function (_ref) {
	  var history = _ref.history;
	
	  var App = function App(_ref2) {
	    var children = _ref2.children;
	    return _react2.default.createElement(
	      _client.ApolloAuthenticationProvider,
	      null,
	      _react2.default.createElement(
	        _reactRouterDom.Router,
	        { history: history },
	        children
	      )
	    );
	  };
	
	  return App;
	};

/***/ }),
/* 240 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.ApolloAuthenticationProvider = exports.getClient = exports.CLIENT_OPTIONS = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _apolloBoost = __webpack_require__(224);
	
	var _apolloBoost2 = _interopRequireDefault(_apolloBoost);
	
	var _reactApollo = __webpack_require__(40);
	
	var _components = __webpack_require__(7);
	
	var _util = __webpack_require__(43);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CLIENT_OPTIONS = exports.CLIENT_OPTIONS = {
	  uri: 'https://api.github.com/graphql',
	  ssrMode: true
	};
	
	var getClient = exports.getClient = function getClient() {
	  var token = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (0, _util.getItem)(_components.AUTHENTICATION_KEY);
	
	  return new _apolloBoost2.default(_extends({}, CLIENT_OPTIONS, {
	    request: function request(operation) {
	      operation.setContext({
	        headers: {
	          authorization: 'Bearer ' + token
	        }
	      });
	    }
	  }));
	};
	
	var ApolloAuthenticationProvider = exports.ApolloAuthenticationProvider = function ApolloAuthenticationProvider(_ref) {
	  var children = _ref.children;
	  return _react2.default.createElement(
	    _components.AuthenticationProvider,
	    null,
	    _react2.default.createElement(
	      _components.Authentication,
	      null,
	      function (_ref2) {
	        var token = _ref2.token;
	
	        return _react2.default.createElement(
	          _reactApollo.ApolloProvider,
	          { client: getClient(token) },
	          children
	        );
	      }
	    )
	  );
	};

/***/ }),
/* 241 */,
/* 242 */,
/* 243 */,
/* 244 */,
/* 245 */,
/* 246 */,
/* 247 */,
/* 248 */,
/* 249 */,
/* 250 */,
/* 251 */,
/* 252 */,
/* 253 */,
/* 254 */,
/* 255 */,
/* 256 */,
/* 257 */,
/* 258 */,
/* 259 */,
/* 260 */,
/* 261 */,
/* 262 */,
/* 263 */,
/* 264 */,
/* 265 */,
/* 266 */,
/* 267 */,
/* 268 */,
/* 269 */,
/* 270 */,
/* 271 */,
/* 272 */,
/* 273 */,
/* 274 */,
/* 275 */,
/* 276 */,
/* 277 */,
/* 278 */,
/* 279 */,
/* 280 */,
/* 281 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _typography = __webpack_require__(616);
	
	var _typography2 = _interopRequireDefault(_typography);
	
	var _typographyThemeNoriega = __webpack_require__(615);
	
	var _typographyThemeNoriega2 = _interopRequireDefault(_typographyThemeNoriega);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var latoIndex = _typographyThemeNoriega2.default.googleFonts.findIndex(function (font) {
	  return font.name === 'Lato';
	});
	var lato = _typographyThemeNoriega2.default.googleFonts[latoIndex];
	
	_typographyThemeNoriega2.default.googleFonts[latoIndex] = lato;
	_typographyThemeNoriega2.default.headerWeight = 700;
	
	exports.default = new _typography2.default(_typographyThemeNoriega2.default);
	module.exports = exports['default'];

/***/ }),
/* 282 */,
/* 283 */,
/* 284 */,
/* 285 */,
/* 286 */,
/* 287 */,
/* 288 */,
/* 289 */,
/* 290 */,
/* 291 */
/***/ (function(module, exports, __webpack_require__) {

	// Generated by CoffeeScript 1.9.0
	var adjustFontSizeTo, convertLength, defaults, establishBaseline, linesForFontSize, objectAssign, parseUnit, rhythm, unit, unitLess;
	
	objectAssign = __webpack_require__(11);
	
	convertLength = __webpack_require__(293);
	
	parseUnit = __webpack_require__(212);
	
	unit = function(length) {
	  return parseUnit(length)[1];
	};
	
	unitLess = function(length) {
	  return parseUnit(length)[0];
	};
	
	defaults = {
	  baseFontSize: '16px',
	  baseLineHeight: 1.5,
	  rhythmUnit: 'rem',
	  defaultRhythmBorderWidth: '1px',
	  defaultRhythmBorderStyle: 'solid',
	  roundToNearestHalfLine: true,
	  minLinePadding: '2px'
	};
	
	linesForFontSize = function(fontSize, options) {
	  var convert, fontSizeInPx, lineHeightInPx, lines, minLinePadding;
	  convert = convertLength(options.baseFontSize);
	  fontSizeInPx = unitLess(convert(fontSize, 'px'));
	  lineHeightInPx = unitLess(options.baseLineHeightInPx);
	  minLinePadding = unitLess(convert(options.minLinePadding, 'px'));
	  if (options.roundToNearestHalfLine) {
	    lines = Math.ceil(2 * fontSizeInPx / lineHeightInPx) / 2;
	  } else {
	    lines = Math.ceil(fontSizeInPx / lineHeightInPx);
	  }
	  if ((lines * lineHeightInPx - fontSizeInPx) < (minLinePadding * 2)) {
	    if (options.roundToNearestHalfLine) {
	      lines += 0.5;
	    } else {
	      lines += 1;
	    }
	  }
	  return lines;
	};
	
	rhythm = function(options) {
	  var convert;
	  convert = convertLength(options.baseFontSize);
	  return function(lines, fontSize, offset) {
	    var length, rhythmLength;
	    if (lines == null) {
	      lines = 1;
	    }
	    if (fontSize == null) {
	      fontSize = options.baseFontSize;
	    }
	    if (offset == null) {
	      offset = 0;
	    }
	    length = ((lines * unitLess(options.baseLineHeightInPx)) - offset) + "px";
	    rhythmLength = convert(length, options.rhythmUnit, fontSize);
	    if (unit(rhythmLength) === "px") {
	      rhythmLength = Math.floor(unitLess(rhythmLength)) + unit(rhythmLength);
	    }
	    return parseFloat(unitLess(rhythmLength).toFixed(5)) + unit(rhythmLength);
	  };
	};
	
	establishBaseline = function(options) {
	  var convert;
	  convert = convertLength(options.baseFontSize);
	  return {
	    fontSize: (unitLess(options.baseFontSize) / 16) * 100 + "%",
	    lineHeight: options.baseLineHeight.toString()
	  };
	};
	
	adjustFontSizeTo = function(toSize, lines, fromSize, options) {
	  var convert, r;
	  if (fromSize == null) {
	    fromSize = options.baseFontSize;
	  }
	  if (unit(toSize) === "%") {
	    toSize = unitLess(options.baseFontSize) * (unitLess(toSize) / 100) + "px";
	  }
	  convert = convertLength(options.baseFontSize);
	  fromSize = convert(fromSize, 'px');
	  toSize = convert(toSize, 'px', fromSize);
	  r = rhythm(options);
	  if (lines === "auto") {
	    lines = linesForFontSize(toSize, options);
	  }
	  return {
	    fontSize: convert(toSize, options.rhythmUnit, fromSize),
	    lineHeight: r(lines, fromSize)
	  };
	};
	
	module.exports = function(options) {
	  var convert, defaultsCopy, fontSizeInPx, lineHeight;
	  defaultsCopy = JSON.parse(JSON.stringify(defaults));
	  options = objectAssign(defaultsCopy, options);
	  convert = convertLength(options.baseFontSize);
	  if (unit(options.baseLineHeight)) {
	    fontSizeInPx = unitLess(convert(options.baseFontSize, 'px'));
	    lineHeight = convert(options.baseLineHeight, 'px');
	    options.baseLineHeightInPx = lineHeight;
	    options.baseLineHeight = unitLess(lineHeight) / fontSizeInPx;
	  } else {
	    options.baseLineHeightInPx = (unitLess(options.baseFontSize) * options.baseLineHeight) + "px";
	  }
	  return {
	    rhythm: rhythm(options),
	    establishBaseline: function() {
	      return establishBaseline(options);
	    },
	    linesForFontSize: function(fontSize) {
	      return linesForFontSize(fontSize, options);
	    },
	    adjustFontSizeTo: function(toSize, lines, fromSize) {
	      if (lines == null) {
	        lines = "auto";
	      }
	      return adjustFontSizeTo(toSize, lines, fromSize, options);
	    }
	  };
	};


/***/ }),
/* 292 */
/***/ (function(module, exports) {

	// Console-polyfill. MIT license.
	// https://github.com/paulmillr/console-polyfill
	// Make it safe to do console.log() always.
	(function(con) {
	  'use strict';
	  var prop, method;
	  var empty = {};
	  var dummy = function() {};
	  var properties = 'memory'.split(',');
	  var methods = ('assert,clear,count,debug,dir,dirxml,error,exception,group,' +
	     'groupCollapsed,groupEnd,info,log,markTimeline,profile,profiles,profileEnd,' +
	     'show,table,time,timeEnd,timeline,timelineEnd,timeStamp,trace,warn').split(',');
	  while (prop = properties.pop()) con[prop] = con[prop] || empty;
	  while (method = methods.pop()) con[method] = con[method] || dummy;
	})(this.console = this.console || {}); // Using `this` for web workers.


/***/ }),
/* 293 */
/***/ (function(module, exports, __webpack_require__) {

	// Generated by CoffeeScript 1.9.0
	var baseFontSize, parseUnit, unit, unitLess;
	
	parseUnit = __webpack_require__(212);
	
	__webpack_require__(292);
	
	baseFontSize = "16px";
	
	unit = function(length) {
	  return parseUnit(length)[1];
	};
	
	unitLess = function(length) {
	  return parseUnit(length)[0];
	};
	
	module.exports = function(baseFontSize) {
	  if (baseFontSize == null) {
	    baseFontSize = baseFontSize;
	  }
	  return function(length, toUnit, fromContext, toContext) {
	    var fromUnit, outputLength, pxLength;
	    if (fromContext == null) {
	      fromContext = baseFontSize;
	    }
	    if (toContext == null) {
	      toContext = fromContext;
	    }
	    fromUnit = unit(length);
	    if (fromUnit === toUnit) {
	      return length;
	    }
	    pxLength = unitLess(length);
	    if (unit(fromContext) !== "px") {
	      console.warn("Parameter fromContext must resolve to a value in pixel units.");
	    }
	    if (unit(toContext) !== "px") {
	      console.warn("Parameter toContext must resolve to a value in pixel units.");
	    }
	    if (fromUnit !== "px") {
	      if (fromUnit === "em") {
	        pxLength = unitLess(length) * unitLess(fromContext);
	      } else if (fromUnit === "rem") {
	        pxLength = unitLess(length) * unitLess(baseFontSize);
	      } else if (fromUnit === "ex") {
	        pxLength = unitLess(length) * unitLess(fromContext) * 2;
	      } else if (fromUnit === "ch" || fromUnit === "vw" || fromUnit === "vh" || fromUnit === "vmin") {
	        console.warn(fromUnit + " units can't be reliably converted; Returning original value.");
	        return length;
	      } else {
	        console.warn(fromUnit + " is an unknown or unsupported length unit; Returning original value.");
	        return length;
	      }
	    }
	    outputLength = pxLength;
	    if (toUnit !== "px") {
	      if (toUnit === "em") {
	        outputLength = pxLength / unitLess(toContext);
	      } else if (toUnit === "rem") {
	        outputLength = pxLength / unitLess(baseFontSize);
	      } else if (toUnit === "ex") {
	        outputLength = pxLength / unitLess(toContext) / 2;
	      } else if (toUnit === "ch" || toUnit === "vw" || toUnit === "vh" || toUnit === "vmin") {
	        console.warn(toUnit + " units can't be reliably converted; Returning original value.");
	        return length;
	      } else {
	        console.warn(toUnit + " is an unknown or unsupported length unit; Returning original value.");
	        return length;
	      }
	    }
	    return parseFloat(outputLength.toFixed(5)) + toUnit;
	  };
	};


/***/ }),
/* 294 */,
/* 295 */,
/* 296 */,
/* 297 */,
/* 298 */,
/* 299 */,
/* 300 */,
/* 301 */,
/* 302 */,
/* 303 */,
/* 304 */,
/* 305 */,
/* 306 */,
/* 307 */,
/* 308 */,
/* 309 */,
/* 310 */,
/* 311 */,
/* 312 */,
/* 313 */,
/* 314 */,
/* 315 */,
/* 316 */,
/* 317 */,
/* 318 */,
/* 319 */,
/* 320 */,
/* 321 */,
/* 322 */,
/* 323 */,
/* 324 */,
/* 325 */,
/* 326 */,
/* 327 */,
/* 328 */,
/* 329 */,
/* 330 */,
/* 331 */,
/* 332 */,
/* 333 */,
/* 334 */,
/* 335 */,
/* 336 */,
/* 337 */,
/* 338 */,
/* 339 */,
/* 340 */,
/* 341 */,
/* 342 */,
/* 343 */,
/* 344 */,
/* 345 */,
/* 346 */,
/* 347 */,
/* 348 */,
/* 349 */,
/* 350 */,
/* 351 */,
/* 352 */,
/* 353 */,
/* 354 */,
/* 355 */,
/* 356 */,
/* 357 */,
/* 358 */,
/* 359 */,
/* 360 */,
/* 361 */,
/* 362 */,
/* 363 */,
/* 364 */,
/* 365 */
/***/ (function(module, exports) {

	'use strict';
	module.exports = function (str, sep) {
		if (typeof str !== 'string') {
			throw new TypeError('Expected a string');
		}
	
		sep = typeof sep === 'undefined' ? '_' : sep;
	
		return str
			.replace(/([a-z\d])([A-Z])/g, '$1' + sep + '$2')
			.replace(/([A-Z]+)([A-Z][a-z\d]+)/g, '$1' + sep + '$2')
			.toLowerCase();
	};


/***/ }),
/* 366 */,
/* 367 */,
/* 368 */,
/* 369 */,
/* 370 */,
/* 371 */
/***/ (function(module, exports, __webpack_require__) {

	/*!
	  * domready (c) Dustin Diaz 2014 - License MIT
	  */
	!function (name, definition) {
	
	  if (true) module.exports = definition()
	  else if (typeof define == 'function' && typeof define.amd == 'object') define(definition)
	  else this[name] = definition()
	
	}('domready', function () {
	
	  var fns = [], listener
	    , doc = document
	    , hack = doc.documentElement.doScroll
	    , domContentLoaded = 'DOMContentLoaded'
	    , loaded = (hack ? /^loaded|^c/ : /^loaded|^i|^c/).test(doc.readyState)
	
	
	  if (!loaded)
	  doc.addEventListener(domContentLoaded, listener = function () {
	    doc.removeEventListener(domContentLoaded, listener)
	    loaded = 1
	    while (listener = fns.shift()) listener()
	  })
	
	  return function (fn) {
	    loaded ? setTimeout(fn, 0) : fns.push(fn)
	  }
	
	});


/***/ }),
/* 372 */,
/* 373 */,
/* 374 */,
/* 375 */,
/* 376 */,
/* 377 */,
/* 378 */,
/* 379 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(
	      2
	    );
	    module.exports = function(cb) { return __webpack_require__.e/* nsure */(114276838955818, function(_, error) {
	        if (error) {
	          console.log('bundle loading error', error)
	          cb(true)
	        } else {
	          cb(null, function() { return __webpack_require__(236) })
	        }
	      });
	     }
	    

/***/ }),
/* 380 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(
	      2
	    );
	    module.exports = function(cb) { return __webpack_require__.e/* nsure */(162898551421021, function(_, error) {
	        if (error) {
	          console.log('bundle loading error', error)
	          cb(true)
	        } else {
	          cb(null, function() { return __webpack_require__(274) })
	        }
	      });
	     }
	    

/***/ }),
/* 381 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(
	      2
	    );
	    module.exports = function(cb) { return __webpack_require__.e/* nsure */(141269926629767, function(_, error) {
	        if (error) {
	          console.log('bundle loading error', error)
	          cb(true)
	        } else {
	          cb(null, function() { return __webpack_require__(275) })
	        }
	      });
	     }
	    

/***/ }),
/* 382 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(
	      2
	    );
	    module.exports = function(cb) { return __webpack_require__.e/* nsure */(35783957827783, function(_, error) {
	        if (error) {
	          console.log('bundle loading error', error)
	          cb(true)
	        } else {
	          cb(null, function() { return __webpack_require__(276) })
	        }
	      });
	     }
	    

/***/ }),
/* 383 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(
	      2
	    );
	    module.exports = function(cb) { return __webpack_require__.e/* nsure */(170434399708630, function(_, error) {
	        if (error) {
	          console.log('bundle loading error', error)
	          cb(true)
	        } else {
	          cb(null, function() { return __webpack_require__(277) })
	        }
	      });
	     }
	    

/***/ }),
/* 384 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(
	      2
	    );
	    module.exports = function(cb) { return __webpack_require__.e/* nsure */(91034255955811, function(_, error) {
	        if (error) {
	          console.log('bundle loading error', error)
	          cb(true)
	        } else {
	          cb(null, function() { return __webpack_require__(278) })
	        }
	      });
	     }
	    

/***/ }),
/* 385 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(
	      2
	    );
	    module.exports = function(cb) { return __webpack_require__.e/* nsure */(275411625707331, function(_, error) {
	        if (error) {
	          console.log('bundle loading error', error)
	          cb(true)
	        } else {
	          cb(null, function() { return __webpack_require__(95) })
	        }
	      });
	     }
	    

/***/ }),
/* 386 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(
	      2
	    );
	    module.exports = function(cb) { return __webpack_require__.e/* nsure */(60335399758886, function(_, error) {
	        if (error) {
	          console.log('bundle loading error', error)
	          cb(true)
	        } else {
	          cb(null, function() { return __webpack_require__(126) })
	        }
	      });
	     }
	    

/***/ }),
/* 387 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(
	      2
	    );
	    module.exports = function(cb) { return __webpack_require__.e/* nsure */(254022195166212, function(_, error) {
	        if (error) {
	          console.log('bundle loading error', error)
	          cb(true)
	        } else {
	          cb(null, function() { return __webpack_require__(427) })
	        }
	      });
	     }
	    

/***/ }),
/* 388 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(
	      2
	    );
	    module.exports = function(cb) { return __webpack_require__.e/* nsure */(178698757827068, function(_, error) {
	        if (error) {
	          console.log('bundle loading error', error)
	          cb(true)
	        } else {
	          cb(null, function() { return __webpack_require__(426) })
	        }
	      });
	     }
	    

/***/ }),
/* 389 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(
	      2
	    );
	    module.exports = function(cb) { return __webpack_require__.e/* nsure */(239100308417157, function(_, error) {
	        if (error) {
	          console.log('bundle loading error', error)
	          cb(true)
	        } else {
	          cb(null, function() { return __webpack_require__(428) })
	        }
	      });
	     }
	    

/***/ }),
/* 390 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(
	      2
	    );
	    module.exports = function(cb) { return __webpack_require__.e/* nsure */(142629428675168, function(_, error) {
	        if (error) {
	          console.log('bundle loading error', error)
	          cb(true)
	        } else {
	          cb(null, function() { return __webpack_require__(429) })
	        }
	      });
	     }
	    

/***/ }),
/* 391 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(
	      2
	    );
	    module.exports = function(cb) { return __webpack_require__.e/* nsure */(108414645950442, function(_, error) {
	        if (error) {
	          console.log('bundle loading error', error)
	          cb(true)
	        } else {
	          cb(null, function() { return __webpack_require__(430) })
	        }
	      });
	     }
	    

/***/ }),
/* 392 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(
	      2
	    );
	    module.exports = function(cb) { return __webpack_require__.e/* nsure */(158834927214438, function(_, error) {
	        if (error) {
	          console.log('bundle loading error', error)
	          cb(true)
	        } else {
	          cb(null, function() { return __webpack_require__(443) })
	        }
	      });
	     }
	    

/***/ }),
/* 393 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(
	      2
	    );
	    module.exports = function(cb) { return __webpack_require__.e/* nsure */(163083261337670, function(_, error) {
	        if (error) {
	          console.log('bundle loading error', error)
	          cb(true)
	        } else {
	          cb(null, function() { return __webpack_require__(431) })
	        }
	      });
	     }
	    

/***/ }),
/* 394 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(
	      2
	    );
	    module.exports = function(cb) { return __webpack_require__.e/* nsure */(148982617426318, function(_, error) {
	        if (error) {
	          console.log('bundle loading error', error)
	          cb(true)
	        } else {
	          cb(null, function() { return __webpack_require__(432) })
	        }
	      });
	     }
	    

/***/ }),
/* 395 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(
	      2
	    );
	    module.exports = function(cb) { return __webpack_require__.e/* nsure */(220497462039108, function(_, error) {
	        if (error) {
	          console.log('bundle loading error', error)
	          cb(true)
	        } else {
	          cb(null, function() { return __webpack_require__(433) })
	        }
	      });
	     }
	    

/***/ }),
/* 396 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(
	      2
	    );
	    module.exports = function(cb) { return __webpack_require__.e/* nsure */(102576504716532, function(_, error) {
	        if (error) {
	          console.log('bundle loading error', error)
	          cb(true)
	        } else {
	          cb(null, function() { return __webpack_require__(434) })
	        }
	      });
	     }
	    

/***/ }),
/* 397 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(
	      2
	    );
	    module.exports = function(cb) { return __webpack_require__.e/* nsure */(20589118094640, function(_, error) {
	        if (error) {
	          console.log('bundle loading error', error)
	          cb(true)
	        } else {
	          cb(null, function() { return __webpack_require__(435) })
	        }
	      });
	     }
	    

/***/ }),
/* 398 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(
	      2
	    );
	    module.exports = function(cb) { return __webpack_require__.e/* nsure */(67704185367205, function(_, error) {
	        if (error) {
	          console.log('bundle loading error', error)
	          cb(true)
	        } else {
	          cb(null, function() { return __webpack_require__(436) })
	        }
	      });
	     }
	    

/***/ }),
/* 399 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(
	      2
	    );
	    module.exports = function(cb) { return __webpack_require__.e/* nsure */(60107668171883, function(_, error) {
	        if (error) {
	          console.log('bundle loading error', error)
	          cb(true)
	        } else {
	          cb(null, function() { return __webpack_require__(437) })
	        }
	      });
	     }
	    

/***/ }),
/* 400 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(
	      2
	    );
	    module.exports = function(cb) { return __webpack_require__.e/* nsure */(80986344550028, function(_, error) {
	        if (error) {
	          console.log('bundle loading error', error)
	          cb(true)
	        } else {
	          cb(null, function() { return __webpack_require__(438) })
	        }
	      });
	     }
	    

/***/ }),
/* 401 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(
	      2
	    );
	    module.exports = function(cb) { return __webpack_require__.e/* nsure */(182718855271568, function(_, error) {
	        if (error) {
	          console.log('bundle loading error', error)
	          cb(true)
	        } else {
	          cb(null, function() { return __webpack_require__(439) })
	        }
	      });
	     }
	    

/***/ }),
/* 402 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(
	      2
	    );
	    module.exports = function(cb) { return __webpack_require__.e/* nsure */(146767705471827, function(_, error) {
	        if (error) {
	          console.log('bundle loading error', error)
	          cb(true)
	        } else {
	          cb(null, function() { return __webpack_require__(440) })
	        }
	      });
	     }
	    

/***/ }),
/* 403 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(
	      2
	    );
	    module.exports = function(cb) { return __webpack_require__.e/* nsure */(125599322066452, function(_, error) {
	        if (error) {
	          console.log('bundle loading error', error)
	          cb(true)
	        } else {
	          cb(null, function() { return __webpack_require__(441) })
	        }
	      });
	     }
	    

/***/ }),
/* 404 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(
	      2
	    );
	    module.exports = function(cb) { return __webpack_require__.e/* nsure */(29251300633642, function(_, error) {
	        if (error) {
	          console.log('bundle loading error', error)
	          cb(true)
	        } else {
	          cb(null, function() { return __webpack_require__(442) })
	        }
	      });
	     }
	    

/***/ }),
/* 405 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _gatsbyLink = __webpack_require__(38);
	
	module.exports = function (root, cb) {
	  root.addEventListener("click", function (ev) {
	    if (ev.button !== 0 || ev.altKey || ev.ctrlKey || ev.metaKey || ev.shiftKey || ev.defaultPrevented) {
	      return true;
	    }
	
	    var anchor = null;
	    for (var n = ev.target; n.parentNode; n = n.parentNode) {
	      if (n.nodeName === "A") {
	        anchor = n;
	        break;
	      }
	    }
	    if (!anchor) return true;
	
	    // Don't catch links where a target (other than self) is set
	    // e.g. _blank.
	    if (anchor.target && anchor.target.toLowerCase() !== "_self") return true;
	
	    // Don't catch links pointed to the same page but with a hash.
	    if (anchor.pathname === window.location.pathname && anchor.hash !== "") {
	      return true;
	    }
	
	    // Dynamically created anchor links (href="#my-anchor") do not always have pathname on IE
	    if (anchor.pathname === "") {
	      return true;
	    }
	
	    // Don't catch links pointed at what look like file extensions (other than
	    // .htm/html extensions).
	    if (anchor.pathname.search(/^.*\.((?!htm)[a-z0-9]{1,5})$/i) !== -1) {
	      return true;
	    }
	
	    // IE clears the host value if the anchor href changed after creation, e.g.
	    // in React. Creating a new anchor element to ensure host value is present
	    var a1 = document.createElement("a");
	    a1.href = anchor.href;
	
	    // In IE, the default port is included in the anchor host but excluded from
	    // the location host.  This affects the ability to directly compare
	    // location host to anchor host.  For example: http://example.com would
	    // have a location.host of 'example.com' and an anchor.host of
	    // 'example.com:80' Creating anchor from the location.href to normalize the
	    // host value.
	    var a2 = document.createElement("a");
	    a2.href = window.location.href;
	
	    if (a1.host !== a2.host) return true;
	
	    // For when pathPrefix is used in an app and there happens to be a link
	    // pointing to the same domain but outside of the app's pathPrefix. For
	    // example, a Gatsby app lives at https://example.com/myapp/, with the
	    // pathPrefix set to `/myapp`. When adding an absolute link to the same
	    // domain but outside of the /myapp path, for example, <a
	    // href="https://example.com/not-my-app"> the plugin won't catch it and
	    // will navigate to an external link instead of doing a pushState resulting
	    // in `https://example.com/myapp/https://example.com/not-my-app`
	    var re = new RegExp("^" + a2.host + (0, _gatsbyLink.withPrefix)("/"));
	    if (!re.test("" + a1.host + a1.pathname)) return true;
	
	    // TODO: add a check for absolute internal links in a callback or here,
	    // or always pass only `${a1.pathname}${a1.hash}`
	    // to avoid `https://example.com/myapp/https://example.com/myapp/here` navigation
	
	    ev.preventDefault();
	
	    cb(anchor.getAttribute("href"));
	    return false;
	  });
	};

/***/ }),
/* 406 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _gatsbyLink = __webpack_require__(38);
	
	var _catchLinks = __webpack_require__(405);
	
	var _catchLinks2 = _interopRequireDefault(_catchLinks);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.onClientEntry = function () {
	  (0, _catchLinks2.default)(window, function (href) {
	    (0, _gatsbyLink.navigateTo)(href);
	  });
	};

/***/ }),
/* 407 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _emotion = __webpack_require__(16);
	
	exports.onClientEntry = function () {
	  if (typeof window !== "undefined" && typeof window.__EMOTION_CRITICAL_CSS_IDS__ !== "undefined") {
	    (0, _emotion.hydrate)(window.__EMOTION_CRITICAL_CSS_IDS__);
	  }
	}; /* globals window */

/***/ }),
/* 408 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(281)

/***/ }),
/* 409 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _typography = __webpack_require__(408);
	
	var _typography2 = _interopRequireDefault(_typography);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.onClientEntry = function () {
	  // Hot reload typography in development.
	  if (false) {
	    _typography2.default.injectStyles();
	  }
	};

/***/ }),
/* 410 */,
/* 411 */,
/* 412 */,
/* 413 */,
/* 414 */
/***/ (function(module, exports, __webpack_require__) {

	(function (global, factory) {
		 true ? factory(exports, __webpack_require__(23)) :
		typeof define === 'function' && define.amd ? define(['exports', 'apollo-utilities'], factory) :
		(factory((global.graphqlAnywhereAsync = {}),global.apollo.utilities));
	}(this, (function (exports,apolloUtilities) { 'use strict';
	
	function merge(dest, src) {
	    if (src === null || typeof src !== 'object') {
	        // These types just override whatever was in dest
	        return src;
	    }
	    // Merge sub-objects
	    Object.keys(dest).forEach(function (destKey) {
	        if (src.hasOwnProperty(destKey)) {
	            merge(dest[destKey], src[destKey]);
	        }
	    });
	    // Add props only on src
	    Object.keys(src).forEach(function (srcKey) {
	        if (!dest.hasOwnProperty(srcKey)) {
	            dest[srcKey] = src[srcKey];
	        }
	    });
	}
	
	var __awaiter = (undefined && undefined.__awaiter) || function (thisArg, _arguments, P, generator) {
	    return new (P || (P = Promise))(function (resolve, reject) {
	        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
	        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
	        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
	        step((generator = generator.apply(thisArg, _arguments || [])).next());
	    });
	};
	var __generator = (undefined && undefined.__generator) || function (thisArg, body) {
	    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
	    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
	    function verb(n) { return function (v) { return step([n, v]); }; }
	    function step(op) {
	        if (f) throw new TypeError("Generator is already executing.");
	        while (_) try {
	            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
	            if (y = 0, t) op = [0, t.value];
	            switch (op[0]) {
	                case 0: case 1: t = op; break;
	                case 4: _.label++; return { value: op[1], done: false };
	                case 5: _.label++; y = op[1]; op = [0]; continue;
	                case 7: op = _.ops.pop(); _.trys.pop(); continue;
	                default:
	                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
	                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
	                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
	                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
	                    if (t[2]) _.ops.pop();
	                    _.trys.pop(); continue;
	            }
	            op = body.call(thisArg, _);
	        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
	        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
	    }
	};
	/* Based on graphql function from graphql-js:
	 *
	 * graphql(
	 *   schema: GraphQLSchema,
	 *   requestString: string,
	 *   rootValue?: ?any,
	 *   contextValue?: ?any,
	 *   variableValues?: ?{[key: string]: any},
	 *   operationName?: ?string
	 * ): Promise<GraphQLResult>
	 *
	 * The default export as of graphql-anywhere is sync as of 4.0,
	 * but below is an exported alternative that is async.
	 * In the 5.0 version, this will be the only export again
	 * and it will be async
	 *
	 */
	function graphql$1(resolver, document, rootValue, contextValue, variableValues, execOptions) {
	    if (execOptions === void 0) { execOptions = {}; }
	    var mainDefinition = apolloUtilities.getMainDefinition(document);
	    var fragments = apolloUtilities.getFragmentDefinitions(document);
	    var fragmentMap = apolloUtilities.createFragmentMap(fragments);
	    var resultMapper = execOptions.resultMapper;
	    // Default matcher always matches all fragments
	    var fragmentMatcher = execOptions.fragmentMatcher || (function () { return true; });
	    var execContext = {
	        fragmentMap: fragmentMap,
	        contextValue: contextValue,
	        variableValues: variableValues,
	        resultMapper: resultMapper,
	        resolver: resolver,
	        fragmentMatcher: fragmentMatcher,
	    };
	    return executeSelectionSet$1(mainDefinition.selectionSet, rootValue, execContext);
	}
	function executeSelectionSet$1(selectionSet, rootValue, execContext) {
	    return __awaiter(this, void 0, void 0, function () {
	        var _this = this;
	        var fragmentMap, contextValue, variables, result, execute;
	        return __generator(this, function (_a) {
	            switch (_a.label) {
	                case 0:
	                    fragmentMap = execContext.fragmentMap, contextValue = execContext.contextValue, variables = execContext.variableValues;
	                    result = {};
	                    execute = function (selection) { return __awaiter(_this, void 0, void 0, function () {
	                        var fieldResult, resultFieldKey, fragment, typeCondition, fragmentResult;
	                        return __generator(this, function (_a) {
	                            switch (_a.label) {
	                                case 0:
	                                    if (!apolloUtilities.shouldInclude(selection, variables)) {
	                                        // Skip this entirely
	                                        return [2 /*return*/];
	                                    }
	                                    if (!apolloUtilities.isField(selection)) return [3 /*break*/, 2];
	                                    return [4 /*yield*/, executeField$1(selection, rootValue, execContext)];
	                                case 1:
	                                    fieldResult = _a.sent();
	                                    resultFieldKey = apolloUtilities.resultKeyNameFromField(selection);
	                                    if (fieldResult !== undefined) {
	                                        if (result[resultFieldKey] === undefined) {
	                                            result[resultFieldKey] = fieldResult;
	                                        }
	                                        else {
	                                            merge(result[resultFieldKey], fieldResult);
	                                        }
	                                    }
	                                    return [2 /*return*/];
	                                case 2:
	                                    if (apolloUtilities.isInlineFragment(selection)) {
	                                        fragment = selection;
	                                    }
	                                    else {
	                                        // This is a named fragment
	                                        fragment = fragmentMap[selection.name.value];
	                                        if (!fragment) {
	                                            throw new Error("No fragment named " + selection.name.value);
	                                        }
	                                    }
	                                    typeCondition = fragment.typeCondition.name.value;
	                                    if (!execContext.fragmentMatcher(rootValue, typeCondition, contextValue)) return [3 /*break*/, 4];
	                                    return [4 /*yield*/, executeSelectionSet$1(fragment.selectionSet, rootValue, execContext)];
	                                case 3:
	                                    fragmentResult = _a.sent();
	                                    merge(result, fragmentResult);
	                                    _a.label = 4;
	                                case 4: return [2 /*return*/];
	                            }
	                        });
	                    }); };
	                    return [4 /*yield*/, Promise.all(selectionSet.selections.map(execute))];
	                case 1:
	                    _a.sent();
	                    if (execContext.resultMapper) {
	                        return [2 /*return*/, execContext.resultMapper(result, rootValue)];
	                    }
	                    return [2 /*return*/, result];
	            }
	        });
	    });
	}
	function executeField$1(field, rootValue, execContext) {
	    return __awaiter(this, void 0, void 0, function () {
	        var variables, contextValue, resolver, fieldName, args, info, result;
	        return __generator(this, function (_a) {
	            switch (_a.label) {
	                case 0:
	                    variables = execContext.variableValues, contextValue = execContext.contextValue, resolver = execContext.resolver;
	                    fieldName = field.name.value;
	                    args = apolloUtilities.argumentsObjectFromField(field, variables);
	                    info = {
	                        isLeaf: !field.selectionSet,
	                        resultKey: apolloUtilities.resultKeyNameFromField(field),
	                        directives: apolloUtilities.getDirectiveInfoFromField(field, variables),
	                    };
	                    return [4 /*yield*/, resolver(fieldName, rootValue, args, contextValue, info)];
	                case 1:
	                    result = _a.sent();
	                    // Handle all scalar types here
	                    if (!field.selectionSet) {
	                        return [2 /*return*/, result];
	                    }
	                    // From here down, the field has a selection set, which means it's trying to
	                    // query a GraphQLObjectType
	                    if (result == null) {
	                        // Basically any field in a GraphQL response can be null, or missing
	                        return [2 /*return*/, result];
	                    }
	                    if (Array.isArray(result)) {
	                        return [2 /*return*/, executeSubSelectedArray$1(field, result, execContext)];
	                    }
	                    // Returned value is an object, and the query has a sub-selection. Recurse.
	                    return [2 /*return*/, executeSelectionSet$1(field.selectionSet, result, execContext)];
	            }
	        });
	    });
	}
	function executeSubSelectedArray$1(field, result, execContext) {
	    return Promise.all(result.map(function (item) {
	        // null value in array
	        if (item === null) {
	            return null;
	        }
	        // This is a nested array, recurse
	        if (Array.isArray(item)) {
	            return executeSubSelectedArray$1(field, item, execContext);
	        }
	        // This is an object, run the selection set on it
	        return executeSelectionSet$1(field.selectionSet, item, execContext);
	    }));
	}
	
	exports.graphql = graphql$1;
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	})));
	//# sourceMappingURL=async.js.map


/***/ }),
/* 415 */
/***/ (function(module, exports, __webpack_require__) {

	(function (global, factory) {
		 true ? factory(exports, __webpack_require__(23)) :
		typeof define === 'function' && define.amd ? define(['exports', 'apollo-utilities'], factory) :
		(factory((global.graphqlAnywhere = {}),global.apollo.utilities));
	}(this, (function (exports,apolloUtilities) { 'use strict';
	
	/* Based on graphql function from graphql-js:
	 *
	 * graphql(
	 *   schema: GraphQLSchema,
	 *   requestString: string,
	 *   rootValue?: ?any,
	 *   contextValue?: ?any,
	 *   variableValues?: ?{[key: string]: any},
	 *   operationName?: ?string
	 * ): Promise<GraphQLResult>
	 *
	 * The default export as of graphql-anywhere is sync as of 4.0,
	 * but below is an exported alternative that is async.
	 * In the 5.0 version, this will be the only export again
	 * and it will be async
	 *
	 */
	function graphql(resolver, document, rootValue, contextValue, variableValues, execOptions) {
	    if (execOptions === void 0) { execOptions = {}; }
	    var mainDefinition = apolloUtilities.getMainDefinition(document);
	    var fragments = apolloUtilities.getFragmentDefinitions(document);
	    var fragmentMap = apolloUtilities.createFragmentMap(fragments);
	    var resultMapper = execOptions.resultMapper;
	    // Default matcher always matches all fragments
	    var fragmentMatcher = execOptions.fragmentMatcher || (function () { return true; });
	    var execContext = {
	        fragmentMap: fragmentMap,
	        contextValue: contextValue,
	        variableValues: variableValues,
	        resultMapper: resultMapper,
	        resolver: resolver,
	        fragmentMatcher: fragmentMatcher,
	    };
	    return executeSelectionSet(mainDefinition.selectionSet, rootValue, execContext);
	}
	function executeSelectionSet(selectionSet, rootValue, execContext) {
	    var fragmentMap = execContext.fragmentMap, contextValue = execContext.contextValue, variables = execContext.variableValues;
	    var result = {};
	    selectionSet.selections.forEach(function (selection) {
	        if (!apolloUtilities.shouldInclude(selection, variables)) {
	            // Skip this entirely
	            return;
	        }
	        if (apolloUtilities.isField(selection)) {
	            var fieldResult = executeField(selection, rootValue, execContext);
	            var resultFieldKey = apolloUtilities.resultKeyNameFromField(selection);
	            if (fieldResult !== undefined) {
	                if (result[resultFieldKey] === undefined) {
	                    result[resultFieldKey] = fieldResult;
	                }
	                else {
	                    merge(result[resultFieldKey], fieldResult);
	                }
	            }
	        }
	        else {
	            var fragment = void 0;
	            if (apolloUtilities.isInlineFragment(selection)) {
	                fragment = selection;
	            }
	            else {
	                // This is a named fragment
	                fragment = fragmentMap[selection.name.value];
	                if (!fragment) {
	                    throw new Error("No fragment named " + selection.name.value);
	                }
	            }
	            var typeCondition = fragment.typeCondition.name.value;
	            if (execContext.fragmentMatcher(rootValue, typeCondition, contextValue)) {
	                var fragmentResult = executeSelectionSet(fragment.selectionSet, rootValue, execContext);
	                merge(result, fragmentResult);
	            }
	        }
	    });
	    if (execContext.resultMapper) {
	        return execContext.resultMapper(result, rootValue);
	    }
	    return result;
	}
	function executeField(field, rootValue, execContext) {
	    var variables = execContext.variableValues, contextValue = execContext.contextValue, resolver = execContext.resolver;
	    var fieldName = field.name.value;
	    var args = apolloUtilities.argumentsObjectFromField(field, variables);
	    var info = {
	        isLeaf: !field.selectionSet,
	        resultKey: apolloUtilities.resultKeyNameFromField(field),
	        directives: apolloUtilities.getDirectiveInfoFromField(field, variables),
	    };
	    var result = resolver(fieldName, rootValue, args, contextValue, info);
	    // Handle all scalar types here
	    if (!field.selectionSet) {
	        return result;
	    }
	    // From here down, the field has a selection set, which means it's trying to
	    // query a GraphQLObjectType
	    if (result == null) {
	        // Basically any field in a GraphQL response can be null, or missing
	        return result;
	    }
	    if (Array.isArray(result)) {
	        return executeSubSelectedArray(field, result, execContext);
	    }
	    // Returned value is an object, and the query has a sub-selection. Recurse.
	    return executeSelectionSet(field.selectionSet, result, execContext);
	}
	function executeSubSelectedArray(field, result, execContext) {
	    return result.map(function (item) {
	        // null value in array
	        if (item === null) {
	            return null;
	        }
	        // This is a nested array, recurse
	        if (Array.isArray(item)) {
	            return executeSubSelectedArray(field, item, execContext);
	        }
	        // This is an object, run the selection set on it
	        return executeSelectionSet(field.selectionSet, item, execContext);
	    });
	}
	function merge(dest, src) {
	    if (src === null || typeof src !== 'object') {
	        // These types just override whatever was in dest
	        return src;
	    }
	    // Merge sub-objects
	    Object.keys(dest).forEach(function (destKey) {
	        if (src.hasOwnProperty(destKey)) {
	            merge(dest[destKey], src[destKey]);
	        }
	    });
	    // Add props only on src
	    Object.keys(src).forEach(function (srcKey) {
	        if (!dest.hasOwnProperty(srcKey)) {
	            dest[srcKey] = src[srcKey];
	        }
	    });
	}
	
	function filter(doc, data) {
	    var resolver = function (fieldName, root, args, context, info) {
	        return root[info.resultKey];
	    };
	    return graphql(resolver, doc, data);
	}
	// TODO: we should probably make check call propType and then throw,
	// rather than the other way round, to avoid constructing stack traces
	// for things like oneOf uses in React. At this stage I doubt many people
	// are using this like that, but in the future, who knows?
	function check(doc, data) {
	    var resolver = function (fieldName, root, args, context, info) {
	        if (!{}.hasOwnProperty.call(root, info.resultKey)) {
	            throw new Error(info.resultKey + " missing on " + root);
	        }
	        return root[info.resultKey];
	    };
	    graphql(resolver, doc, data, {}, {}, {
	        fragmentMatcher: function () { return false; },
	    });
	}
	// Lifted/adapted from
	//   https://github.com/facebook/react/blob/master/src/isomorphic/classic/types/ReactPropTypes.js
	var ANONYMOUS = '<<anonymous>>';
	function PropTypeError(message) {
	    this.message = message;
	    this.stack = '';
	}
	// Make `instanceof Error` still work for returned errors.
	PropTypeError.prototype = Error.prototype;
	var reactPropTypeLocationNames = {
	    prop: 'prop',
	    context: 'context',
	    childContext: 'child context',
	};
	function createChainableTypeChecker(validate) {
	    function checkType(isRequired, props, propName, componentName, location, propFullName) {
	        componentName = componentName || ANONYMOUS;
	        propFullName = propFullName || propName;
	        if (props[propName] == null) {
	            var locationName = reactPropTypeLocationNames[location];
	            if (isRequired) {
	                if (props[propName] === null) {
	                    return new PropTypeError("The " + locationName + " `" + propFullName + "` is marked as required " +
	                        ("in `" + componentName + "`, but its value is `null`."));
	                }
	                return new PropTypeError("The " + locationName + " `" + propFullName + "` is marked as required in " +
	                    ("`" + componentName + "`, but its value is `undefined`."));
	            }
	            return null;
	        }
	        else {
	            return validate(props, propName, componentName, location, propFullName);
	        }
	    }
	    var chainedCheckType = checkType.bind(null, false);
	    chainedCheckType.isRequired = checkType.bind(null, true);
	    return chainedCheckType;
	}
	function propType(doc) {
	    return createChainableTypeChecker(function (props, propName) {
	        var prop = props[propName];
	        try {
	            if (!prop.loading) {
	                check(doc, prop);
	            }
	            return null;
	        }
	        catch (e) {
	            // Need a much better error.
	            // Also we aren't checking for extra fields
	            return e;
	        }
	    });
	}
	
	exports.default = graphql;
	exports.filter = filter;
	exports.check = check;
	exports.propType = propType;
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	})));
	//# sourceMappingURL=bundle.umd.js.map


/***/ }),
/* 416 */,
/* 417 */,
/* 418 */,
/* 419 */,
/* 420 */,
/* 421 */,
/* 422 */,
/* 423 */,
/* 424 */
/***/ (function(module, exports) {

	function isNumeric(n) {
	  return !isNaN(parseFloat(n)) && isFinite(n);
	}
	
	
	module.exports = function(lightness, hue, darkBackground) {
	  if (typeof hue === "undefined") {
	    hue = 0;
	  }
	  if (typeof darkBackground === "undefined") {
	    darkBackground = false;
	  }
	
	  // Convert named hues into numeric lightness value.
	  if (hue === "cool") {
	    hue = 237;
	  }
	  else if (hue === "slate") {
	    hue = 122;
	  }
	  else if (hue === "warm") {
	    hue = 69;
	  }
	
	  if (!isNumeric(hue)) {
	    throw new Error("Hue is not a number");
	  }
	
	  if (!isNumeric(lightness)) {
	    throw new Error("Lightness is not a number");
	  }
	
	  if (lightness > 100) {
	    lightness = 100;
	  }
	  if (lightness < 0) {
	    lightness = 0;
	  }
	
	  var saturation = 0;
	  if (hue !== 0) {
	    var a = 19.92978;
	    var b = -0.3651759;
	    var c = 0.001737214;
	    saturation = a + b * lightness + c * Math.pow(lightness, 2);
	  }
	
	  var opacity = 0
	  if (darkBackground) {
	    opacity = lightness / 100
	    lightness = '100%,'
	  } else {
	    opacity = (100 - lightness) / 100
	    lightness = '0%,'
	  }
	
	  return "hsla(" + hue + "," + saturation + "%," + lightness + opacity + ")";
	};


/***/ }),
/* 425 */,
/* 426 */,
/* 427 */,
/* 428 */,
/* 429 */,
/* 430 */,
/* 431 */,
/* 432 */,
/* 433 */,
/* 434 */,
/* 435 */,
/* 436 */,
/* 437 */,
/* 438 */,
/* 439 */,
/* 440 */,
/* 441 */,
/* 442 */,
/* 443 */,
/* 444 */
/***/ (function(module, exports) {

	module.exports = [{"componentChunkName":"component---src-templates-proposal-js","layout":"layout---index","layoutComponentChunkName":"component---src-layouts-index-js","jsonName":"proposal-mdu-6-sx-nzd-w-uz-nda-0-nz-u-3-mj-i.json","path":"/proposal/MDU6SXNzdWUzNDA0NzU3MjI"},{"componentChunkName":"component---src-templates-proposal-js","layout":"layout---index","layoutComponentChunkName":"component---src-layouts-index-js","jsonName":"proposal-mdu-6-sx-nzd-w-uz-m-tkz-nz-qx-mj-u.json","path":"/proposal/MDU6SXNzdWUzMTkzNzQxMjU"},{"componentChunkName":"component---src-templates-proposal-js","layout":"layout---index","layoutComponentChunkName":"component---src-layouts-index-js","jsonName":"proposal-mdu-6-sx-nzd-w-uz-m-tg-3-ntq-4-odu.json","path":"/proposal/MDU6SXNzdWUzMTg3NTQ4ODU"},{"componentChunkName":"component---src-templates-proposal-js","layout":"layout---index","layoutComponentChunkName":"component---src-layouts-index-js","jsonName":"proposal-mdu-6-sx-nzd-w-uz-md-ey-nd-ux-mtq.json","path":"/proposal/MDU6SXNzdWUzMDEyNDUxMTQ"},{"componentChunkName":"component---src-templates-proposal-js","layout":"layout---index","layoutComponentChunkName":"component---src-layouts-index-js","jsonName":"proposal-mdu-6-sx-nzd-w-uy-oty-5-nzc-5-mz-u.json","path":"/proposal/MDU6SXNzdWUyOTY5Nzc5MzU"},{"componentChunkName":"component---src-templates-proposal-js","layout":"layout---index","layoutComponentChunkName":"component---src-layouts-index-js","jsonName":"proposal-mdu-6-sx-nzd-w-uy-odu-2-o-tgy-mz-m.json","path":"/proposal/MDU6SXNzdWUyODU2OTgyMzM"},{"componentChunkName":"component---src-templates-proposal-js","layout":"layout---index","layoutComponentChunkName":"component---src-layouts-index-js","jsonName":"proposal-mdu-6-sx-nzd-w-uy-nz-u-2-m-dc-0-n-dg.json","path":"/proposal/MDU6SXNzdWUyNzU2MDc0NDg"},{"componentChunkName":"component---src-templates-proposal-js","layout":"layout---index","layoutComponentChunkName":"component---src-layouts-index-js","jsonName":"proposal-mdu-6-sx-nzd-w-uy-nz-qy-nz-uw-mz-u.json","path":"/proposal/MDU6SXNzdWUyNzQyNzUwMzU"},{"componentChunkName":"component---src-templates-proposal-js","layout":"layout---index","layoutComponentChunkName":"component---src-layouts-index-js","jsonName":"proposal-mdu-6-sx-nzd-w-uy-nz-qy-nj-az-m-tk.json","path":"/proposal/MDU6SXNzdWUyNzQyNjAzMTk"},{"componentChunkName":"component---src-templates-proposal-js","layout":"layout---index","layoutComponentChunkName":"component---src-layouts-index-js","jsonName":"proposal-mdu-6-sx-nzd-w-uy-nz-qy-nta-3-nti.json","path":"/proposal/MDU6SXNzdWUyNzQyNTA3NTI"},{"componentChunkName":"component---src-templates-proposal-js","layout":"layout---index","layoutComponentChunkName":"component---src-layouts-index-js","jsonName":"proposal-mdu-6-sx-nzd-w-uy-nz-qy-mz-uw-nty.json","path":"/proposal/MDU6SXNzdWUyNzQyMzUwNTY"},{"componentChunkName":"component---src-templates-proposal-js","layout":"layout---index","layoutComponentChunkName":"component---src-layouts-index-js","jsonName":"proposal-mdu-6-sx-nzd-w-uy-nz-qy-mz-e-5-mzg.json","path":"/proposal/MDU6SXNzdWUyNzQyMzE5Mzg"},{"componentChunkName":"component---src-pages-404-js","layout":"layout---index","layoutComponentChunkName":"component---src-layouts-index-js","jsonName":"404.json","path":"/404/"},{"componentChunkName":"component---src-pages-closed-js","layout":"layout---index","layoutComponentChunkName":"component---src-layouts-index-js","jsonName":"closed.json","path":"/closed/"},{"componentChunkName":"component---src-pages-index-js","layout":"layout---index","layoutComponentChunkName":"component---src-layouts-index-js","jsonName":"index.json","path":"/"},{"componentChunkName":"component---src-pages-new-js","layout":"layout---index","layoutComponentChunkName":"component---src-layouts-index-js","jsonName":"new.json","path":"/new/"},{"componentChunkName":"component---src-pages-proposal-js","layout":"layout---index","layoutComponentChunkName":"component---src-layouts-index-js","jsonName":"proposal.json","path":"/proposal/","matchPath":"/proposal/:path"},{"componentChunkName":"component---src-pages-404-js","layout":"layout---index","layoutComponentChunkName":"component---src-layouts-index-js","jsonName":"404-html.json","path":"/404.html"}]

/***/ }),
/* 445 */
/***/ (function(module, exports) {

	module.exports = []

/***/ }),
/* 446 */
/***/ (function(module, exports) {

	/**
	 * lodash 3.0.3 (Custom Build) <https://lodash.com/>
	 * Build: `lodash modularize exports="npm" -o ./`
	 * Copyright 2012-2016 The Dojo Foundation <http://dojofoundation.org/>
	 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
	 * Copyright 2009-2016 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
	 * Available under MIT license <https://lodash.com/license>
	 */
	
	/** `Object#toString` result references. */
	var numberTag = '[object Number]';
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/**
	 * Used to resolve the [`toStringTag`](http://ecma-international.org/ecma-262/6.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var objectToString = objectProto.toString;
	
	/**
	 * Checks if `value` is object-like. A value is object-like if it's not `null`
	 * and has a `typeof` result of "object".
	 *
	 * @static
	 * @memberOf _
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
	 * @example
	 *
	 * _.isObjectLike({});
	 * // => true
	 *
	 * _.isObjectLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isObjectLike(_.noop);
	 * // => false
	 *
	 * _.isObjectLike(null);
	 * // => false
	 */
	function isObjectLike(value) {
	  return !!value && typeof value == 'object';
	}
	
	/**
	 * Checks if `value` is classified as a `Number` primitive or object.
	 *
	 * **Note:** To exclude `Infinity`, `-Infinity`, and `NaN`, which are classified
	 * as numbers, use the `_.isFinite` method.
	 *
	 * @static
	 * @memberOf _
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
	 * @example
	 *
	 * _.isNumber(3);
	 * // => true
	 *
	 * _.isNumber(Number.MIN_VALUE);
	 * // => true
	 *
	 * _.isNumber(Infinity);
	 * // => true
	 *
	 * _.isNumber('3');
	 * // => false
	 */
	function isNumber(value) {
	  return typeof value == 'number' ||
	    (isObjectLike(value) && objectToString.call(value) == numberTag);
	}
	
	module.exports = isNumber;


/***/ }),
/* 447 */
/***/ (function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(26),
	    root = __webpack_require__(12);
	
	/* Built-in method references that are verified to be native. */
	var DataView = getNative(root, 'DataView');
	
	module.exports = DataView;


/***/ }),
/* 448 */
/***/ (function(module, exports, __webpack_require__) {

	var hashClear = __webpack_require__(504),
	    hashDelete = __webpack_require__(505),
	    hashGet = __webpack_require__(506),
	    hashHas = __webpack_require__(507),
	    hashSet = __webpack_require__(508);
	
	/**
	 * Creates a hash object.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function Hash(entries) {
	  var index = -1,
	      length = entries == null ? 0 : entries.length;
	
	  this.clear();
	  while (++index < length) {
	    var entry = entries[index];
	    this.set(entry[0], entry[1]);
	  }
	}
	
	// Add methods to `Hash`.
	Hash.prototype.clear = hashClear;
	Hash.prototype['delete'] = hashDelete;
	Hash.prototype.get = hashGet;
	Hash.prototype.has = hashHas;
	Hash.prototype.set = hashSet;
	
	module.exports = Hash;


/***/ }),
/* 449 */
/***/ (function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(26),
	    root = __webpack_require__(12);
	
	/* Built-in method references that are verified to be native. */
	var Promise = getNative(root, 'Promise');
	
	module.exports = Promise;


/***/ }),
/* 450 */
/***/ (function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(26),
	    root = __webpack_require__(12);
	
	/* Built-in method references that are verified to be native. */
	var Set = getNative(root, 'Set');
	
	module.exports = Set;


/***/ }),
/* 451 */
/***/ (function(module, exports, __webpack_require__) {

	var MapCache = __webpack_require__(130),
	    setCacheAdd = __webpack_require__(533),
	    setCacheHas = __webpack_require__(534);
	
	/**
	 *
	 * Creates an array cache object to store unique values.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [values] The values to cache.
	 */
	function SetCache(values) {
	  var index = -1,
	      length = values == null ? 0 : values.length;
	
	  this.__data__ = new MapCache;
	  while (++index < length) {
	    this.add(values[index]);
	  }
	}
	
	// Add methods to `SetCache`.
	SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
	SetCache.prototype.has = setCacheHas;
	
	module.exports = SetCache;


/***/ }),
/* 452 */,
/* 453 */
/***/ (function(module, exports) {

	/**
	 * A specialized version of `_.forEach` for arrays without support for
	 * iteratee shorthands.
	 *
	 * @private
	 * @param {Array} [array] The array to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Array} Returns `array`.
	 */
	function arrayEach(array, iteratee) {
	  var index = -1,
	      length = array == null ? 0 : array.length;
	
	  while (++index < length) {
	    if (iteratee(array[index], index, array) === false) {
	      break;
	    }
	  }
	  return array;
	}
	
	module.exports = arrayEach;


/***/ }),
/* 454 */
/***/ (function(module, exports) {

	/**
	 * A specialized version of `_.filter` for arrays without support for
	 * iteratee shorthands.
	 *
	 * @private
	 * @param {Array} [array] The array to iterate over.
	 * @param {Function} predicate The function invoked per iteration.
	 * @returns {Array} Returns the new filtered array.
	 */
	function arrayFilter(array, predicate) {
	  var index = -1,
	      length = array == null ? 0 : array.length,
	      resIndex = 0,
	      result = [];
	
	  while (++index < length) {
	    var value = array[index];
	    if (predicate(value, index, array)) {
	      result[resIndex++] = value;
	    }
	  }
	  return result;
	}
	
	module.exports = arrayFilter;


/***/ }),
/* 455 */
/***/ (function(module, exports) {

	/**
	 * A specialized version of `_.map` for arrays without support for iteratee
	 * shorthands.
	 *
	 * @private
	 * @param {Array} [array] The array to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Array} Returns the new mapped array.
	 */
	function arrayMap(array, iteratee) {
	  var index = -1,
	      length = array == null ? 0 : array.length,
	      result = Array(length);
	
	  while (++index < length) {
	    result[index] = iteratee(array[index], index, array);
	  }
	  return result;
	}
	
	module.exports = arrayMap;


/***/ }),
/* 456 */
/***/ (function(module, exports) {

	/**
	 * A specialized version of `_.reduce` for arrays without support for
	 * iteratee shorthands.
	 *
	 * @private
	 * @param {Array} [array] The array to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @param {*} [accumulator] The initial value.
	 * @param {boolean} [initAccum] Specify using the first element of `array` as
	 *  the initial value.
	 * @returns {*} Returns the accumulated value.
	 */
	function arrayReduce(array, iteratee, accumulator, initAccum) {
	  var index = -1,
	      length = array == null ? 0 : array.length;
	
	  if (initAccum && length) {
	    accumulator = array[++index];
	  }
	  while (++index < length) {
	    accumulator = iteratee(accumulator, array[index], index, array);
	  }
	  return accumulator;
	}
	
	module.exports = arrayReduce;


/***/ }),
/* 457 */
/***/ (function(module, exports) {

	/**
	 * A specialized version of `_.some` for arrays without support for iteratee
	 * shorthands.
	 *
	 * @private
	 * @param {Array} [array] The array to iterate over.
	 * @param {Function} predicate The function invoked per iteration.
	 * @returns {boolean} Returns `true` if any element passes the predicate check,
	 *  else `false`.
	 */
	function arraySome(array, predicate) {
	  var index = -1,
	      length = array == null ? 0 : array.length;
	
	  while (++index < length) {
	    if (predicate(array[index], index, array)) {
	      return true;
	    }
	  }
	  return false;
	}
	
	module.exports = arraySome;


/***/ }),
/* 458 */,
/* 459 */
/***/ (function(module, exports, __webpack_require__) {

	var baseFor = __webpack_require__(192),
	    keys = __webpack_require__(142);
	
	/**
	 * The base implementation of `_.forOwn` without support for iteratee shorthands.
	 *
	 * @private
	 * @param {Object} object The object to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Object} Returns `object`.
	 */
	function baseForOwn(object, iteratee) {
	  return object && baseFor(object, iteratee, keys);
	}
	
	module.exports = baseForOwn;


/***/ }),
/* 460 */
/***/ (function(module, exports, __webpack_require__) {

	var arrayPush = __webpack_require__(188),
	    isArray = __webpack_require__(6);
	
	/**
	 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
	 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
	 * symbols of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {Function} keysFunc The function to get the keys of `object`.
	 * @param {Function} symbolsFunc The function to get the symbols of `object`.
	 * @returns {Array} Returns the array of property names and symbols.
	 */
	function baseGetAllKeys(object, keysFunc, symbolsFunc) {
	  var result = keysFunc(object);
	  return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
	}
	
	module.exports = baseGetAllKeys;


/***/ }),
/* 461 */
/***/ (function(module, exports) {

	/**
	 * The base implementation of `_.hasIn` without support for deep paths.
	 *
	 * @private
	 * @param {Object} [object] The object to query.
	 * @param {Array|string} key The key to check.
	 * @returns {boolean} Returns `true` if `key` exists, else `false`.
	 */
	function baseHasIn(object, key) {
	  return object != null && key in Object(object);
	}
	
	module.exports = baseHasIn;


/***/ }),
/* 462 */,
/* 463 */
/***/ (function(module, exports, __webpack_require__) {

	var Stack = __webpack_require__(131),
	    equalArrays = __webpack_require__(197),
	    equalByTag = __webpack_require__(494),
	    equalObjects = __webpack_require__(495),
	    getTag = __webpack_require__(501),
	    isArray = __webpack_require__(6),
	    isBuffer = __webpack_require__(138),
	    isTypedArray = __webpack_require__(141);
	
	/** Used to compose bitmasks for value comparisons. */
	var COMPARE_PARTIAL_FLAG = 1;
	
	/** `Object#toString` result references. */
	var argsTag = '[object Arguments]',
	    arrayTag = '[object Array]',
	    objectTag = '[object Object]';
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * A specialized version of `baseIsEqual` for arrays and objects which performs
	 * deep comparisons and tracks traversed objects enabling objects with circular
	 * references to be compared.
	 *
	 * @private
	 * @param {Object} object The object to compare.
	 * @param {Object} other The other object to compare.
	 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	 * @param {Function} customizer The function to customize comparisons.
	 * @param {Function} equalFunc The function to determine equivalents of values.
	 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
	 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	 */
	function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
	  var objIsArr = isArray(object),
	      othIsArr = isArray(other),
	      objTag = objIsArr ? arrayTag : getTag(object),
	      othTag = othIsArr ? arrayTag : getTag(other);
	
	  objTag = objTag == argsTag ? objectTag : objTag;
	  othTag = othTag == argsTag ? objectTag : othTag;
	
	  var objIsObj = objTag == objectTag,
	      othIsObj = othTag == objectTag,
	      isSameTag = objTag == othTag;
	
	  if (isSameTag && isBuffer(object)) {
	    if (!isBuffer(other)) {
	      return false;
	    }
	    objIsArr = true;
	    objIsObj = false;
	  }
	  if (isSameTag && !objIsObj) {
	    stack || (stack = new Stack);
	    return (objIsArr || isTypedArray(object))
	      ? equalArrays(object, other, bitmask, customizer, equalFunc, stack)
	      : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
	  }
	  if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
	    var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
	        othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');
	
	    if (objIsWrapped || othIsWrapped) {
	      var objUnwrapped = objIsWrapped ? object.value() : object,
	          othUnwrapped = othIsWrapped ? other.value() : other;
	
	      stack || (stack = new Stack);
	      return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
	    }
	  }
	  if (!isSameTag) {
	    return false;
	  }
	  stack || (stack = new Stack);
	  return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
	}
	
	module.exports = baseIsEqualDeep;


/***/ }),
/* 464 */
/***/ (function(module, exports, __webpack_require__) {

	var Stack = __webpack_require__(131),
	    baseIsEqual = __webpack_require__(194);
	
	/** Used to compose bitmasks for value comparisons. */
	var COMPARE_PARTIAL_FLAG = 1,
	    COMPARE_UNORDERED_FLAG = 2;
	
	/**
	 * The base implementation of `_.isMatch` without support for iteratee shorthands.
	 *
	 * @private
	 * @param {Object} object The object to inspect.
	 * @param {Object} source The object of property values to match.
	 * @param {Array} matchData The property names, values, and compare flags to match.
	 * @param {Function} [customizer] The function to customize comparisons.
	 * @returns {boolean} Returns `true` if `object` is a match, else `false`.
	 */
	function baseIsMatch(object, source, matchData, customizer) {
	  var index = matchData.length,
	      length = index,
	      noCustomizer = !customizer;
	
	  if (object == null) {
	    return !length;
	  }
	  object = Object(object);
	  while (index--) {
	    var data = matchData[index];
	    if ((noCustomizer && data[2])
	          ? data[1] !== object[data[0]]
	          : !(data[0] in object)
	        ) {
	      return false;
	    }
	  }
	  while (++index < length) {
	    data = matchData[index];
	    var key = data[0],
	        objValue = object[key],
	        srcValue = data[1];
	
	    if (noCustomizer && data[2]) {
	      if (objValue === undefined && !(key in object)) {
	        return false;
	      }
	    } else {
	      var stack = new Stack;
	      if (customizer) {
	        var result = customizer(objValue, srcValue, key, object, source, stack);
	      }
	      if (!(result === undefined
	            ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack)
	            : result
	          )) {
	        return false;
	      }
	    }
	  }
	  return true;
	}
	
	module.exports = baseIsMatch;


/***/ }),
/* 465 */,
/* 466 */
/***/ (function(module, exports, __webpack_require__) {

	var baseGetTag = __webpack_require__(19),
	    isLength = __webpack_require__(139),
	    isObjectLike = __webpack_require__(14);
	
	/** `Object#toString` result references. */
	var argsTag = '[object Arguments]',
	    arrayTag = '[object Array]',
	    boolTag = '[object Boolean]',
	    dateTag = '[object Date]',
	    errorTag = '[object Error]',
	    funcTag = '[object Function]',
	    mapTag = '[object Map]',
	    numberTag = '[object Number]',
	    objectTag = '[object Object]',
	    regexpTag = '[object RegExp]',
	    setTag = '[object Set]',
	    stringTag = '[object String]',
	    weakMapTag = '[object WeakMap]';
	
	var arrayBufferTag = '[object ArrayBuffer]',
	    dataViewTag = '[object DataView]',
	    float32Tag = '[object Float32Array]',
	    float64Tag = '[object Float64Array]',
	    int8Tag = '[object Int8Array]',
	    int16Tag = '[object Int16Array]',
	    int32Tag = '[object Int32Array]',
	    uint8Tag = '[object Uint8Array]',
	    uint8ClampedTag = '[object Uint8ClampedArray]',
	    uint16Tag = '[object Uint16Array]',
	    uint32Tag = '[object Uint32Array]';
	
	/** Used to identify `toStringTag` values of typed arrays. */
	var typedArrayTags = {};
	typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
	typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
	typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
	typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
	typedArrayTags[uint32Tag] = true;
	typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
	typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
	typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
	typedArrayTags[errorTag] = typedArrayTags[funcTag] =
	typedArrayTags[mapTag] = typedArrayTags[numberTag] =
	typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
	typedArrayTags[setTag] = typedArrayTags[stringTag] =
	typedArrayTags[weakMapTag] = false;
	
	/**
	 * The base implementation of `_.isTypedArray` without Node.js optimizations.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
	 */
	function baseIsTypedArray(value) {
	  return isObjectLike(value) &&
	    isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
	}
	
	module.exports = baseIsTypedArray;


/***/ }),
/* 467 */
/***/ (function(module, exports, __webpack_require__) {

	var baseMatches = __webpack_require__(470),
	    baseMatchesProperty = __webpack_require__(471),
	    identity = __webpack_require__(86),
	    isArray = __webpack_require__(6),
	    property = __webpack_require__(556);
	
	/**
	 * The base implementation of `_.iteratee`.
	 *
	 * @private
	 * @param {*} [value=_.identity] The value to convert to an iteratee.
	 * @returns {Function} Returns the iteratee.
	 */
	function baseIteratee(value) {
	  // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
	  // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
	  if (typeof value == 'function') {
	    return value;
	  }
	  if (value == null) {
	    return identity;
	  }
	  if (typeof value == 'object') {
	    return isArray(value)
	      ? baseMatchesProperty(value[0], value[1])
	      : baseMatches(value);
	  }
	  return property(value);
	}
	
	module.exports = baseIteratee;


/***/ }),
/* 468 */
/***/ (function(module, exports, __webpack_require__) {

	var isPrototype = __webpack_require__(137),
	    nativeKeys = __webpack_require__(528);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 */
	function baseKeys(object) {
	  if (!isPrototype(object)) {
	    return nativeKeys(object);
	  }
	  var result = [];
	  for (var key in Object(object)) {
	    if (hasOwnProperty.call(object, key) && key != 'constructor') {
	      result.push(key);
	    }
	  }
	  return result;
	}
	
	module.exports = baseKeys;


/***/ }),
/* 469 */
/***/ (function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(13),
	    isPrototype = __webpack_require__(137),
	    nativeKeysIn = __webpack_require__(529);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 */
	function baseKeysIn(object) {
	  if (!isObject(object)) {
	    return nativeKeysIn(object);
	  }
	  var isProto = isPrototype(object),
	      result = [];
	
	  for (var key in object) {
	    if (!(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
	      result.push(key);
	    }
	  }
	  return result;
	}
	
	module.exports = baseKeysIn;


/***/ }),
/* 470 */
/***/ (function(module, exports, __webpack_require__) {

	var baseIsMatch = __webpack_require__(464),
	    getMatchData = __webpack_require__(498),
	    matchesStrictComparable = __webpack_require__(203);
	
	/**
	 * The base implementation of `_.matches` which doesn't clone `source`.
	 *
	 * @private
	 * @param {Object} source The object of property values to match.
	 * @returns {Function} Returns the new spec function.
	 */
	function baseMatches(source) {
	  var matchData = getMatchData(source);
	  if (matchData.length == 1 && matchData[0][2]) {
	    return matchesStrictComparable(matchData[0][0], matchData[0][1]);
	  }
	  return function(object) {
	    return object === source || baseIsMatch(object, source, matchData);
	  };
	}
	
	module.exports = baseMatches;


/***/ }),
/* 471 */
/***/ (function(module, exports, __webpack_require__) {

	var baseIsEqual = __webpack_require__(194),
	    get = __webpack_require__(547),
	    hasIn = __webpack_require__(548),
	    isKey = __webpack_require__(136),
	    isStrictComparable = __webpack_require__(202),
	    matchesStrictComparable = __webpack_require__(203),
	    toKey = __webpack_require__(57);
	
	/** Used to compose bitmasks for value comparisons. */
	var COMPARE_PARTIAL_FLAG = 1,
	    COMPARE_UNORDERED_FLAG = 2;
	
	/**
	 * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
	 *
	 * @private
	 * @param {string} path The path of the property to get.
	 * @param {*} srcValue The value to match.
	 * @returns {Function} Returns the new spec function.
	 */
	function baseMatchesProperty(path, srcValue) {
	  if (isKey(path) && isStrictComparable(srcValue)) {
	    return matchesStrictComparable(toKey(path), srcValue);
	  }
	  return function(object) {
	    var objValue = get(object, path);
	    return (objValue === undefined && objValue === srcValue)
	      ? hasIn(object, path)
	      : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
	  };
	}
	
	module.exports = baseMatchesProperty;


/***/ }),
/* 472 */
/***/ (function(module, exports, __webpack_require__) {

	var Stack = __webpack_require__(131),
	    assignMergeValue = __webpack_require__(189),
	    baseFor = __webpack_require__(192),
	    baseMergeDeep = __webpack_require__(473),
	    isObject = __webpack_require__(13),
	    keysIn = __webpack_require__(210),
	    safeGet = __webpack_require__(206);
	
	/**
	 * The base implementation of `_.merge` without support for multiple sources.
	 *
	 * @private
	 * @param {Object} object The destination object.
	 * @param {Object} source The source object.
	 * @param {number} srcIndex The index of `source`.
	 * @param {Function} [customizer] The function to customize merged values.
	 * @param {Object} [stack] Tracks traversed source values and their merged
	 *  counterparts.
	 */
	function baseMerge(object, source, srcIndex, customizer, stack) {
	  if (object === source) {
	    return;
	  }
	  baseFor(source, function(srcValue, key) {
	    if (isObject(srcValue)) {
	      stack || (stack = new Stack);
	      baseMergeDeep(object, source, key, srcIndex, baseMerge, customizer, stack);
	    }
	    else {
	      var newValue = customizer
	        ? customizer(safeGet(object, key), srcValue, (key + ''), object, source, stack)
	        : undefined;
	
	      if (newValue === undefined) {
	        newValue = srcValue;
	      }
	      assignMergeValue(object, key, newValue);
	    }
	  }, keysIn);
	}
	
	module.exports = baseMerge;


/***/ }),
/* 473 */
/***/ (function(module, exports, __webpack_require__) {

	var assignMergeValue = __webpack_require__(189),
	    cloneBuffer = __webpack_require__(486),
	    cloneTypedArray = __webpack_require__(487),
	    copyArray = __webpack_require__(195),
	    initCloneObject = __webpack_require__(509),
	    isArguments = __webpack_require__(87),
	    isArray = __webpack_require__(6),
	    isArrayLikeObject = __webpack_require__(549),
	    isBuffer = __webpack_require__(138),
	    isFunction = __webpack_require__(88),
	    isObject = __webpack_require__(13),
	    isPlainObject = __webpack_require__(551),
	    isTypedArray = __webpack_require__(141),
	    safeGet = __webpack_require__(206),
	    toPlainObject = __webpack_require__(560);
	
	/**
	 * A specialized version of `baseMerge` for arrays and objects which performs
	 * deep merges and tracks traversed objects enabling objects with circular
	 * references to be merged.
	 *
	 * @private
	 * @param {Object} object The destination object.
	 * @param {Object} source The source object.
	 * @param {string} key The key of the value to merge.
	 * @param {number} srcIndex The index of `source`.
	 * @param {Function} mergeFunc The function to merge values.
	 * @param {Function} [customizer] The function to customize assigned values.
	 * @param {Object} [stack] Tracks traversed source values and their merged
	 *  counterparts.
	 */
	function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
	  var objValue = safeGet(object, key),
	      srcValue = safeGet(source, key),
	      stacked = stack.get(srcValue);
	
	  if (stacked) {
	    assignMergeValue(object, key, stacked);
	    return;
	  }
	  var newValue = customizer
	    ? customizer(objValue, srcValue, (key + ''), object, source, stack)
	    : undefined;
	
	  var isCommon = newValue === undefined;
	
	  if (isCommon) {
	    var isArr = isArray(srcValue),
	        isBuff = !isArr && isBuffer(srcValue),
	        isTyped = !isArr && !isBuff && isTypedArray(srcValue);
	
	    newValue = srcValue;
	    if (isArr || isBuff || isTyped) {
	      if (isArray(objValue)) {
	        newValue = objValue;
	      }
	      else if (isArrayLikeObject(objValue)) {
	        newValue = copyArray(objValue);
	      }
	      else if (isBuff) {
	        isCommon = false;
	        newValue = cloneBuffer(srcValue, true);
	      }
	      else if (isTyped) {
	        isCommon = false;
	        newValue = cloneTypedArray(srcValue, true);
	      }
	      else {
	        newValue = [];
	      }
	    }
	    else if (isPlainObject(srcValue) || isArguments(srcValue)) {
	      newValue = objValue;
	      if (isArguments(objValue)) {
	        newValue = toPlainObject(objValue);
	      }
	      else if (!isObject(objValue) || (srcIndex && isFunction(objValue))) {
	        newValue = initCloneObject(srcValue);
	      }
	    }
	    else {
	      isCommon = false;
	    }
	  }
	  if (isCommon) {
	    // Recursively merge objects and arrays (susceptible to call stack limits).
	    stack.set(srcValue, newValue);
	    mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
	    stack['delete'](srcValue);
	  }
	  assignMergeValue(object, key, newValue);
	}
	
	module.exports = baseMergeDeep;


/***/ }),
/* 474 */
/***/ (function(module, exports) {

	/**
	 * The base implementation of `_.property` without support for deep paths.
	 *
	 * @private
	 * @param {string} key The key of the property to get.
	 * @returns {Function} Returns the new accessor function.
	 */
	function baseProperty(key) {
	  return function(object) {
	    return object == null ? undefined : object[key];
	  };
	}
	
	module.exports = baseProperty;


/***/ }),
/* 475 */
/***/ (function(module, exports, __webpack_require__) {

	var baseGet = __webpack_require__(193);
	
	/**
	 * A specialized version of `baseProperty` which supports deep paths.
	 *
	 * @private
	 * @param {Array|string} path The path of the property to get.
	 * @returns {Function} Returns the new accessor function.
	 */
	function basePropertyDeep(path) {
	  return function(object) {
	    return baseGet(object, path);
	  };
	}
	
	module.exports = basePropertyDeep;


/***/ }),
/* 476 */
/***/ (function(module, exports) {

	/**
	 * The base implementation of `_.reduce` and `_.reduceRight`, without support
	 * for iteratee shorthands, which iterates over `collection` using `eachFunc`.
	 *
	 * @private
	 * @param {Array|Object} collection The collection to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @param {*} accumulator The initial value.
	 * @param {boolean} initAccum Specify using the first or last element of
	 *  `collection` as the initial value.
	 * @param {Function} eachFunc The function to iterate over `collection`.
	 * @returns {*} Returns the accumulated value.
	 */
	function baseReduce(collection, iteratee, accumulator, initAccum, eachFunc) {
	  eachFunc(collection, function(value, index, collection) {
	    accumulator = initAccum
	      ? (initAccum = false, value)
	      : iteratee(accumulator, value, index, collection);
	  });
	  return accumulator;
	}
	
	module.exports = baseReduce;


/***/ }),
/* 477 */
/***/ (function(module, exports, __webpack_require__) {

	var identity = __webpack_require__(86),
	    overRest = __webpack_require__(205),
	    setToString = __webpack_require__(207);
	
	/**
	 * The base implementation of `_.rest` which doesn't validate or coerce arguments.
	 *
	 * @private
	 * @param {Function} func The function to apply a rest parameter to.
	 * @param {number} [start=func.length-1] The start position of the rest parameter.
	 * @returns {Function} Returns the new function.
	 */
	function baseRest(func, start) {
	  return setToString(overRest(func, start, identity), func + '');
	}
	
	module.exports = baseRest;


/***/ }),
/* 478 */
/***/ (function(module, exports, __webpack_require__) {

	var assignValue = __webpack_require__(190),
	    castPath = __webpack_require__(135),
	    isIndex = __webpack_require__(84),
	    isObject = __webpack_require__(13),
	    toKey = __webpack_require__(57);
	
	/**
	 * The base implementation of `_.set`.
	 *
	 * @private
	 * @param {Object} object The object to modify.
	 * @param {Array|string} path The path of the property to set.
	 * @param {*} value The value to set.
	 * @param {Function} [customizer] The function to customize path creation.
	 * @returns {Object} Returns `object`.
	 */
	function baseSet(object, path, value, customizer) {
	  if (!isObject(object)) {
	    return object;
	  }
	  path = castPath(path, object);
	
	  var index = -1,
	      length = path.length,
	      lastIndex = length - 1,
	      nested = object;
	
	  while (nested != null && ++index < length) {
	    var key = toKey(path[index]),
	        newValue = value;
	
	    if (index != lastIndex) {
	      var objValue = nested[key];
	      newValue = customizer ? customizer(objValue, key, nested) : undefined;
	      if (newValue === undefined) {
	        newValue = isObject(objValue)
	          ? objValue
	          : (isIndex(path[index + 1]) ? [] : {});
	      }
	    }
	    assignValue(nested, key, newValue);
	    nested = nested[key];
	  }
	  return object;
	}
	
	module.exports = baseSet;


/***/ }),
/* 479 */,
/* 480 */
/***/ (function(module, exports) {

	/**
	 * The base implementation of `_.times` without support for iteratee shorthands
	 * or max array length checks.
	 *
	 * @private
	 * @param {number} n The number of times to invoke `iteratee`.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Array} Returns the array of results.
	 */
	function baseTimes(n, iteratee) {
	  var index = -1,
	      result = Array(n);
	
	  while (++index < n) {
	    result[index] = iteratee(index);
	  }
	  return result;
	}
	
	module.exports = baseTimes;


/***/ }),
/* 481 */
/***/ (function(module, exports, __webpack_require__) {

	var Symbol = __webpack_require__(56),
	    arrayMap = __webpack_require__(455),
	    isArray = __webpack_require__(6),
	    isSymbol = __webpack_require__(140);
	
	/** Used as references for various `Number` constants. */
	var INFINITY = 1 / 0;
	
	/** Used to convert symbols to primitives and strings. */
	var symbolProto = Symbol ? Symbol.prototype : undefined,
	    symbolToString = symbolProto ? symbolProto.toString : undefined;
	
	/**
	 * The base implementation of `_.toString` which doesn't convert nullish
	 * values to empty strings.
	 *
	 * @private
	 * @param {*} value The value to process.
	 * @returns {string} Returns the string.
	 */
	function baseToString(value) {
	  // Exit early for strings to avoid a performance hit in some environments.
	  if (typeof value == 'string') {
	    return value;
	  }
	  if (isArray(value)) {
	    // Recursively convert values (susceptible to call stack limits).
	    return arrayMap(value, baseToString) + '';
	  }
	  if (isSymbol(value)) {
	    return symbolToString ? symbolToString.call(value) : '';
	  }
	  var result = (value + '');
	  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
	}
	
	module.exports = baseToString;


/***/ }),
/* 482 */
/***/ (function(module, exports) {

	/**
	 * The base implementation of `_.unary` without support for storing metadata.
	 *
	 * @private
	 * @param {Function} func The function to cap arguments for.
	 * @returns {Function} Returns the new capped function.
	 */
	function baseUnary(func) {
	  return function(value) {
	    return func(value);
	  };
	}
	
	module.exports = baseUnary;


/***/ }),
/* 483 */
/***/ (function(module, exports) {

	/**
	 * Checks if a `cache` value for `key` exists.
	 *
	 * @private
	 * @param {Object} cache The cache to query.
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function cacheHas(cache, key) {
	  return cache.has(key);
	}
	
	module.exports = cacheHas;


/***/ }),
/* 484 */
/***/ (function(module, exports, __webpack_require__) {

	var identity = __webpack_require__(86);
	
	/**
	 * Casts `value` to `identity` if it's not a function.
	 *
	 * @private
	 * @param {*} value The value to inspect.
	 * @returns {Function} Returns cast function.
	 */
	function castFunction(value) {
	  return typeof value == 'function' ? value : identity;
	}
	
	module.exports = castFunction;


/***/ }),
/* 485 */
/***/ (function(module, exports, __webpack_require__) {

	var Uint8Array = __webpack_require__(185);
	
	/**
	 * Creates a clone of `arrayBuffer`.
	 *
	 * @private
	 * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
	 * @returns {ArrayBuffer} Returns the cloned array buffer.
	 */
	function cloneArrayBuffer(arrayBuffer) {
	  var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
	  new Uint8Array(result).set(new Uint8Array(arrayBuffer));
	  return result;
	}
	
	module.exports = cloneArrayBuffer;


/***/ }),
/* 486 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var root = __webpack_require__(12);
	
	/** Detect free variable `exports`. */
	var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;
	
	/** Detect free variable `module`. */
	var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;
	
	/** Detect the popular CommonJS extension `module.exports`. */
	var moduleExports = freeModule && freeModule.exports === freeExports;
	
	/** Built-in value references. */
	var Buffer = moduleExports ? root.Buffer : undefined,
	    allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined;
	
	/**
	 * Creates a clone of  `buffer`.
	 *
	 * @private
	 * @param {Buffer} buffer The buffer to clone.
	 * @param {boolean} [isDeep] Specify a deep clone.
	 * @returns {Buffer} Returns the cloned buffer.
	 */
	function cloneBuffer(buffer, isDeep) {
	  if (isDeep) {
	    return buffer.slice();
	  }
	  var length = buffer.length,
	      result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);
	
	  buffer.copy(result);
	  return result;
	}
	
	module.exports = cloneBuffer;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(42)(module)))

/***/ }),
/* 487 */
/***/ (function(module, exports, __webpack_require__) {

	var cloneArrayBuffer = __webpack_require__(485);
	
	/**
	 * Creates a clone of `typedArray`.
	 *
	 * @private
	 * @param {Object} typedArray The typed array to clone.
	 * @param {boolean} [isDeep] Specify a deep clone.
	 * @returns {Object} Returns the cloned typed array.
	 */
	function cloneTypedArray(typedArray, isDeep) {
	  var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
	  return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
	}
	
	module.exports = cloneTypedArray;


/***/ }),
/* 488 */
/***/ (function(module, exports, __webpack_require__) {

	var assignValue = __webpack_require__(190),
	    baseAssignValue = __webpack_require__(132);
	
	/**
	 * Copies properties of `source` to `object`.
	 *
	 * @private
	 * @param {Object} source The object to copy properties from.
	 * @param {Array} props The property identifiers to copy.
	 * @param {Object} [object={}] The object to copy properties to.
	 * @param {Function} [customizer] The function to customize copied values.
	 * @returns {Object} Returns `object`.
	 */
	function copyObject(source, props, object, customizer) {
	  var isNew = !object;
	  object || (object = {});
	
	  var index = -1,
	      length = props.length;
	
	  while (++index < length) {
	    var key = props[index];
	
	    var newValue = customizer
	      ? customizer(object[key], source[key], key, object, source)
	      : undefined;
	
	    if (newValue === undefined) {
	      newValue = source[key];
	    }
	    if (isNew) {
	      baseAssignValue(object, key, newValue);
	    } else {
	      assignValue(object, key, newValue);
	    }
	  }
	  return object;
	}
	
	module.exports = copyObject;


/***/ }),
/* 489 */,
/* 490 */
/***/ (function(module, exports, __webpack_require__) {

	var baseRest = __webpack_require__(477),
	    isIterateeCall = __webpack_require__(511);
	
	/**
	 * Creates a function like `_.assign`.
	 *
	 * @private
	 * @param {Function} assigner The function to assign values.
	 * @returns {Function} Returns the new assigner function.
	 */
	function createAssigner(assigner) {
	  return baseRest(function(object, sources) {
	    var index = -1,
	        length = sources.length,
	        customizer = length > 1 ? sources[length - 1] : undefined,
	        guard = length > 2 ? sources[2] : undefined;
	
	    customizer = (assigner.length > 3 && typeof customizer == 'function')
	      ? (length--, customizer)
	      : undefined;
	
	    if (guard && isIterateeCall(sources[0], sources[1], guard)) {
	      customizer = length < 3 ? undefined : customizer;
	      length = 1;
	    }
	    object = Object(object);
	    while (++index < length) {
	      var source = sources[index];
	      if (source) {
	        assigner(object, source, index, customizer);
	      }
	    }
	    return object;
	  });
	}
	
	module.exports = createAssigner;


/***/ }),
/* 491 */
/***/ (function(module, exports, __webpack_require__) {

	var isArrayLike = __webpack_require__(59);
	
	/**
	 * Creates a `baseEach` or `baseEachRight` function.
	 *
	 * @private
	 * @param {Function} eachFunc The function to iterate over a collection.
	 * @param {boolean} [fromRight] Specify iterating from right to left.
	 * @returns {Function} Returns the new base function.
	 */
	function createBaseEach(eachFunc, fromRight) {
	  return function(collection, iteratee) {
	    if (collection == null) {
	      return collection;
	    }
	    if (!isArrayLike(collection)) {
	      return eachFunc(collection, iteratee);
	    }
	    var length = collection.length,
	        index = fromRight ? length : -1,
	        iterable = Object(collection);
	
	    while ((fromRight ? index-- : ++index < length)) {
	      if (iteratee(iterable[index], index, iterable) === false) {
	        break;
	      }
	    }
	    return collection;
	  };
	}
	
	module.exports = createBaseEach;


/***/ }),
/* 492 */
/***/ (function(module, exports) {

	/**
	 * Creates a base function for methods like `_.forIn` and `_.forOwn`.
	 *
	 * @private
	 * @param {boolean} [fromRight] Specify iterating from right to left.
	 * @returns {Function} Returns the new base function.
	 */
	function createBaseFor(fromRight) {
	  return function(object, iteratee, keysFunc) {
	    var index = -1,
	        iterable = Object(object),
	        props = keysFunc(object),
	        length = props.length;
	
	    while (length--) {
	      var key = props[fromRight ? length : ++index];
	      if (iteratee(iterable[key], key, iterable) === false) {
	        break;
	      }
	    }
	    return object;
	  };
	}
	
	module.exports = createBaseFor;


/***/ }),
/* 493 */,
/* 494 */
/***/ (function(module, exports, __webpack_require__) {

	var Symbol = __webpack_require__(56),
	    Uint8Array = __webpack_require__(185),
	    eq = __webpack_require__(58),
	    equalArrays = __webpack_require__(197),
	    mapToArray = __webpack_require__(525),
	    setToArray = __webpack_require__(535);
	
	/** Used to compose bitmasks for value comparisons. */
	var COMPARE_PARTIAL_FLAG = 1,
	    COMPARE_UNORDERED_FLAG = 2;
	
	/** `Object#toString` result references. */
	var boolTag = '[object Boolean]',
	    dateTag = '[object Date]',
	    errorTag = '[object Error]',
	    mapTag = '[object Map]',
	    numberTag = '[object Number]',
	    regexpTag = '[object RegExp]',
	    setTag = '[object Set]',
	    stringTag = '[object String]',
	    symbolTag = '[object Symbol]';
	
	var arrayBufferTag = '[object ArrayBuffer]',
	    dataViewTag = '[object DataView]';
	
	/** Used to convert symbols to primitives and strings. */
	var symbolProto = Symbol ? Symbol.prototype : undefined,
	    symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;
	
	/**
	 * A specialized version of `baseIsEqualDeep` for comparing objects of
	 * the same `toStringTag`.
	 *
	 * **Note:** This function only supports comparing values with tags of
	 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
	 *
	 * @private
	 * @param {Object} object The object to compare.
	 * @param {Object} other The other object to compare.
	 * @param {string} tag The `toStringTag` of the objects to compare.
	 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	 * @param {Function} customizer The function to customize comparisons.
	 * @param {Function} equalFunc The function to determine equivalents of values.
	 * @param {Object} stack Tracks traversed `object` and `other` objects.
	 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	 */
	function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
	  switch (tag) {
	    case dataViewTag:
	      if ((object.byteLength != other.byteLength) ||
	          (object.byteOffset != other.byteOffset)) {
	        return false;
	      }
	      object = object.buffer;
	      other = other.buffer;
	
	    case arrayBufferTag:
	      if ((object.byteLength != other.byteLength) ||
	          !equalFunc(new Uint8Array(object), new Uint8Array(other))) {
	        return false;
	      }
	      return true;
	
	    case boolTag:
	    case dateTag:
	    case numberTag:
	      // Coerce booleans to `1` or `0` and dates to milliseconds.
	      // Invalid dates are coerced to `NaN`.
	      return eq(+object, +other);
	
	    case errorTag:
	      return object.name == other.name && object.message == other.message;
	
	    case regexpTag:
	    case stringTag:
	      // Coerce regexes to strings and treat strings, primitives and objects,
	      // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
	      // for more details.
	      return object == (other + '');
	
	    case mapTag:
	      var convert = mapToArray;
	
	    case setTag:
	      var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
	      convert || (convert = setToArray);
	
	      if (object.size != other.size && !isPartial) {
	        return false;
	      }
	      // Assume cyclic values are equal.
	      var stacked = stack.get(object);
	      if (stacked) {
	        return stacked == other;
	      }
	      bitmask |= COMPARE_UNORDERED_FLAG;
	
	      // Recursively compare objects (susceptible to call stack limits).
	      stack.set(object, other);
	      var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
	      stack['delete'](object);
	      return result;
	
	    case symbolTag:
	      if (symbolValueOf) {
	        return symbolValueOf.call(object) == symbolValueOf.call(other);
	      }
	  }
	  return false;
	}
	
	module.exports = equalByTag;


/***/ }),
/* 495 */
/***/ (function(module, exports, __webpack_require__) {

	var getAllKeys = __webpack_require__(497);
	
	/** Used to compose bitmasks for value comparisons. */
	var COMPARE_PARTIAL_FLAG = 1;
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * A specialized version of `baseIsEqualDeep` for objects with support for
	 * partial deep comparisons.
	 *
	 * @private
	 * @param {Object} object The object to compare.
	 * @param {Object} other The other object to compare.
	 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	 * @param {Function} customizer The function to customize comparisons.
	 * @param {Function} equalFunc The function to determine equivalents of values.
	 * @param {Object} stack Tracks traversed `object` and `other` objects.
	 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	 */
	function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
	  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
	      objProps = getAllKeys(object),
	      objLength = objProps.length,
	      othProps = getAllKeys(other),
	      othLength = othProps.length;
	
	  if (objLength != othLength && !isPartial) {
	    return false;
	  }
	  var index = objLength;
	  while (index--) {
	    var key = objProps[index];
	    if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) {
	      return false;
	    }
	  }
	  // Assume cyclic values are equal.
	  var stacked = stack.get(object);
	  if (stacked && stack.get(other)) {
	    return stacked == other;
	  }
	  var result = true;
	  stack.set(object, other);
	  stack.set(other, object);
	
	  var skipCtor = isPartial;
	  while (++index < objLength) {
	    key = objProps[index];
	    var objValue = object[key],
	        othValue = other[key];
	
	    if (customizer) {
	      var compared = isPartial
	        ? customizer(othValue, objValue, key, other, object, stack)
	        : customizer(objValue, othValue, key, object, other, stack);
	    }
	    // Recursively compare objects (susceptible to call stack limits).
	    if (!(compared === undefined
	          ? (objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack))
	          : compared
	        )) {
	      result = false;
	      break;
	    }
	    skipCtor || (skipCtor = key == 'constructor');
	  }
	  if (result && !skipCtor) {
	    var objCtor = object.constructor,
	        othCtor = other.constructor;
	
	    // Non `Object` object instances with different constructors are not equal.
	    if (objCtor != othCtor &&
	        ('constructor' in object && 'constructor' in other) &&
	        !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
	          typeof othCtor == 'function' && othCtor instanceof othCtor)) {
	      result = false;
	    }
	  }
	  stack['delete'](object);
	  stack['delete'](other);
	  return result;
	}
	
	module.exports = equalObjects;


/***/ }),
/* 496 */,
/* 497 */
/***/ (function(module, exports, __webpack_require__) {

	var baseGetAllKeys = __webpack_require__(460),
	    getSymbols = __webpack_require__(500),
	    keys = __webpack_require__(142);
	
	/**
	 * Creates an array of own enumerable property names and symbols of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names and symbols.
	 */
	function getAllKeys(object) {
	  return baseGetAllKeys(object, keys, getSymbols);
	}
	
	module.exports = getAllKeys;


/***/ }),
/* 498 */
/***/ (function(module, exports, __webpack_require__) {

	var isStrictComparable = __webpack_require__(202),
	    keys = __webpack_require__(142);
	
	/**
	 * Gets the property names, values, and compare flags of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the match data of `object`.
	 */
	function getMatchData(object) {
	  var result = keys(object),
	      length = result.length;
	
	  while (length--) {
	    var key = result[length],
	        value = object[key];
	
	    result[length] = [key, value, isStrictComparable(value)];
	  }
	  return result;
	}
	
	module.exports = getMatchData;


/***/ }),
/* 499 */,
/* 500 */
/***/ (function(module, exports, __webpack_require__) {

	var arrayFilter = __webpack_require__(454),
	    stubArray = __webpack_require__(558);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Built-in value references. */
	var propertyIsEnumerable = objectProto.propertyIsEnumerable;
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeGetSymbols = Object.getOwnPropertySymbols;
	
	/**
	 * Creates an array of the own enumerable symbols of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of symbols.
	 */
	var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
	  if (object == null) {
	    return [];
	  }
	  object = Object(object);
	  return arrayFilter(nativeGetSymbols(object), function(symbol) {
	    return propertyIsEnumerable.call(object, symbol);
	  });
	};
	
	module.exports = getSymbols;


/***/ }),
/* 501 */
/***/ (function(module, exports, __webpack_require__) {

	var DataView = __webpack_require__(447),
	    Map = __webpack_require__(129),
	    Promise = __webpack_require__(449),
	    Set = __webpack_require__(450),
	    WeakMap = __webpack_require__(186),
	    baseGetTag = __webpack_require__(19),
	    toSource = __webpack_require__(208);
	
	/** `Object#toString` result references. */
	var mapTag = '[object Map]',
	    objectTag = '[object Object]',
	    promiseTag = '[object Promise]',
	    setTag = '[object Set]',
	    weakMapTag = '[object WeakMap]';
	
	var dataViewTag = '[object DataView]';
	
	/** Used to detect maps, sets, and weakmaps. */
	var dataViewCtorString = toSource(DataView),
	    mapCtorString = toSource(Map),
	    promiseCtorString = toSource(Promise),
	    setCtorString = toSource(Set),
	    weakMapCtorString = toSource(WeakMap);
	
	/**
	 * Gets the `toStringTag` of `value`.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @returns {string} Returns the `toStringTag`.
	 */
	var getTag = baseGetTag;
	
	// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
	if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
	    (Map && getTag(new Map) != mapTag) ||
	    (Promise && getTag(Promise.resolve()) != promiseTag) ||
	    (Set && getTag(new Set) != setTag) ||
	    (WeakMap && getTag(new WeakMap) != weakMapTag)) {
	  getTag = function(value) {
	    var result = baseGetTag(value),
	        Ctor = result == objectTag ? value.constructor : undefined,
	        ctorString = Ctor ? toSource(Ctor) : '';
	
	    if (ctorString) {
	      switch (ctorString) {
	        case dataViewCtorString: return dataViewTag;
	        case mapCtorString: return mapTag;
	        case promiseCtorString: return promiseTag;
	        case setCtorString: return setTag;
	        case weakMapCtorString: return weakMapTag;
	      }
	    }
	    return result;
	  };
	}
	
	module.exports = getTag;


/***/ }),
/* 502 */,
/* 503 */
/***/ (function(module, exports, __webpack_require__) {

	var castPath = __webpack_require__(135),
	    isArguments = __webpack_require__(87),
	    isArray = __webpack_require__(6),
	    isIndex = __webpack_require__(84),
	    isLength = __webpack_require__(139),
	    toKey = __webpack_require__(57);
	
	/**
	 * Checks if `path` exists on `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {Array|string} path The path to check.
	 * @param {Function} hasFunc The function to check properties.
	 * @returns {boolean} Returns `true` if `path` exists, else `false`.
	 */
	function hasPath(object, path, hasFunc) {
	  path = castPath(path, object);
	
	  var index = -1,
	      length = path.length,
	      result = false;
	
	  while (++index < length) {
	    var key = toKey(path[index]);
	    if (!(result = object != null && hasFunc(object, key))) {
	      break;
	    }
	    object = object[key];
	  }
	  if (result || ++index != length) {
	    return result;
	  }
	  length = object == null ? 0 : object.length;
	  return !!length && isLength(length) && isIndex(key, length) &&
	    (isArray(object) || isArguments(object));
	}
	
	module.exports = hasPath;


/***/ }),
/* 504 */
/***/ (function(module, exports, __webpack_require__) {

	var nativeCreate = __webpack_require__(85);
	
	/**
	 * Removes all key-value entries from the hash.
	 *
	 * @private
	 * @name clear
	 * @memberOf Hash
	 */
	function hashClear() {
	  this.__data__ = nativeCreate ? nativeCreate(null) : {};
	  this.size = 0;
	}
	
	module.exports = hashClear;


/***/ }),
/* 505 */
/***/ (function(module, exports) {

	/**
	 * Removes `key` and its value from the hash.
	 *
	 * @private
	 * @name delete
	 * @memberOf Hash
	 * @param {Object} hash The hash to modify.
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function hashDelete(key) {
	  var result = this.has(key) && delete this.__data__[key];
	  this.size -= result ? 1 : 0;
	  return result;
	}
	
	module.exports = hashDelete;


/***/ }),
/* 506 */
/***/ (function(module, exports, __webpack_require__) {

	var nativeCreate = __webpack_require__(85);
	
	/** Used to stand-in for `undefined` hash values. */
	var HASH_UNDEFINED = '__lodash_hash_undefined__';
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Gets the hash value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf Hash
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function hashGet(key) {
	  var data = this.__data__;
	  if (nativeCreate) {
	    var result = data[key];
	    return result === HASH_UNDEFINED ? undefined : result;
	  }
	  return hasOwnProperty.call(data, key) ? data[key] : undefined;
	}
	
	module.exports = hashGet;


/***/ }),
/* 507 */
/***/ (function(module, exports, __webpack_require__) {

	var nativeCreate = __webpack_require__(85);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Checks if a hash value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf Hash
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function hashHas(key) {
	  var data = this.__data__;
	  return nativeCreate ? (data[key] !== undefined) : hasOwnProperty.call(data, key);
	}
	
	module.exports = hashHas;


/***/ }),
/* 508 */
/***/ (function(module, exports, __webpack_require__) {

	var nativeCreate = __webpack_require__(85);
	
	/** Used to stand-in for `undefined` hash values. */
	var HASH_UNDEFINED = '__lodash_hash_undefined__';
	
	/**
	 * Sets the hash `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf Hash
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the hash instance.
	 */
	function hashSet(key, value) {
	  var data = this.__data__;
	  this.size += this.has(key) ? 0 : 1;
	  data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
	  return this;
	}
	
	module.exports = hashSet;


/***/ }),
/* 509 */
/***/ (function(module, exports, __webpack_require__) {

	var baseCreate = __webpack_require__(133),
	    getPrototype = __webpack_require__(201),
	    isPrototype = __webpack_require__(137);
	
	/**
	 * Initializes an object clone.
	 *
	 * @private
	 * @param {Object} object The object to clone.
	 * @returns {Object} Returns the initialized clone.
	 */
	function initCloneObject(object) {
	  return (typeof object.constructor == 'function' && !isPrototype(object))
	    ? baseCreate(getPrototype(object))
	    : {};
	}
	
	module.exports = initCloneObject;


/***/ }),
/* 510 */,
/* 511 */
/***/ (function(module, exports, __webpack_require__) {

	var eq = __webpack_require__(58),
	    isArrayLike = __webpack_require__(59),
	    isIndex = __webpack_require__(84),
	    isObject = __webpack_require__(13);
	
	/**
	 * Checks if the given arguments are from an iteratee call.
	 *
	 * @private
	 * @param {*} value The potential iteratee value argument.
	 * @param {*} index The potential iteratee index or key argument.
	 * @param {*} object The potential iteratee object argument.
	 * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
	 *  else `false`.
	 */
	function isIterateeCall(value, index, object) {
	  if (!isObject(object)) {
	    return false;
	  }
	  var type = typeof index;
	  if (type == 'number'
	        ? (isArrayLike(object) && isIndex(index, object.length))
	        : (type == 'string' && index in object)
	      ) {
	    return eq(object[index], value);
	  }
	  return false;
	}
	
	module.exports = isIterateeCall;


/***/ }),
/* 512 */
/***/ (function(module, exports) {

	/**
	 * Checks if `value` is suitable for use as unique object key.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
	 */
	function isKeyable(value) {
	  var type = typeof value;
	  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
	    ? (value !== '__proto__')
	    : (value === null);
	}
	
	module.exports = isKeyable;


/***/ }),
/* 513 */,
/* 514 */,
/* 515 */
/***/ (function(module, exports) {

	/**
	 * Removes all key-value entries from the list cache.
	 *
	 * @private
	 * @name clear
	 * @memberOf ListCache
	 */
	function listCacheClear() {
	  this.__data__ = [];
	  this.size = 0;
	}
	
	module.exports = listCacheClear;


/***/ }),
/* 516 */
/***/ (function(module, exports, __webpack_require__) {

	var assocIndexOf = __webpack_require__(82);
	
	/** Used for built-in method references. */
	var arrayProto = Array.prototype;
	
	/** Built-in value references. */
	var splice = arrayProto.splice;
	
	/**
	 * Removes `key` and its value from the list cache.
	 *
	 * @private
	 * @name delete
	 * @memberOf ListCache
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function listCacheDelete(key) {
	  var data = this.__data__,
	      index = assocIndexOf(data, key);
	
	  if (index < 0) {
	    return false;
	  }
	  var lastIndex = data.length - 1;
	  if (index == lastIndex) {
	    data.pop();
	  } else {
	    splice.call(data, index, 1);
	  }
	  --this.size;
	  return true;
	}
	
	module.exports = listCacheDelete;


/***/ }),
/* 517 */
/***/ (function(module, exports, __webpack_require__) {

	var assocIndexOf = __webpack_require__(82);
	
	/**
	 * Gets the list cache value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf ListCache
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function listCacheGet(key) {
	  var data = this.__data__,
	      index = assocIndexOf(data, key);
	
	  return index < 0 ? undefined : data[index][1];
	}
	
	module.exports = listCacheGet;


/***/ }),
/* 518 */
/***/ (function(module, exports, __webpack_require__) {

	var assocIndexOf = __webpack_require__(82);
	
	/**
	 * Checks if a list cache value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf ListCache
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function listCacheHas(key) {
	  return assocIndexOf(this.__data__, key) > -1;
	}
	
	module.exports = listCacheHas;


/***/ }),
/* 519 */
/***/ (function(module, exports, __webpack_require__) {

	var assocIndexOf = __webpack_require__(82);
	
	/**
	 * Sets the list cache `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf ListCache
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the list cache instance.
	 */
	function listCacheSet(key, value) {
	  var data = this.__data__,
	      index = assocIndexOf(data, key);
	
	  if (index < 0) {
	    ++this.size;
	    data.push([key, value]);
	  } else {
	    data[index][1] = value;
	  }
	  return this;
	}
	
	module.exports = listCacheSet;


/***/ }),
/* 520 */
/***/ (function(module, exports, __webpack_require__) {

	var Hash = __webpack_require__(448),
	    ListCache = __webpack_require__(81),
	    Map = __webpack_require__(129);
	
	/**
	 * Removes all key-value entries from the map.
	 *
	 * @private
	 * @name clear
	 * @memberOf MapCache
	 */
	function mapCacheClear() {
	  this.size = 0;
	  this.__data__ = {
	    'hash': new Hash,
	    'map': new (Map || ListCache),
	    'string': new Hash
	  };
	}
	
	module.exports = mapCacheClear;


/***/ }),
/* 521 */
/***/ (function(module, exports, __webpack_require__) {

	var getMapData = __webpack_require__(83);
	
	/**
	 * Removes `key` and its value from the map.
	 *
	 * @private
	 * @name delete
	 * @memberOf MapCache
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function mapCacheDelete(key) {
	  var result = getMapData(this, key)['delete'](key);
	  this.size -= result ? 1 : 0;
	  return result;
	}
	
	module.exports = mapCacheDelete;


/***/ }),
/* 522 */
/***/ (function(module, exports, __webpack_require__) {

	var getMapData = __webpack_require__(83);
	
	/**
	 * Gets the map value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf MapCache
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function mapCacheGet(key) {
	  return getMapData(this, key).get(key);
	}
	
	module.exports = mapCacheGet;


/***/ }),
/* 523 */
/***/ (function(module, exports, __webpack_require__) {

	var getMapData = __webpack_require__(83);
	
	/**
	 * Checks if a map value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf MapCache
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function mapCacheHas(key) {
	  return getMapData(this, key).has(key);
	}
	
	module.exports = mapCacheHas;


/***/ }),
/* 524 */
/***/ (function(module, exports, __webpack_require__) {

	var getMapData = __webpack_require__(83);
	
	/**
	 * Sets the map `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf MapCache
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the map cache instance.
	 */
	function mapCacheSet(key, value) {
	  var data = getMapData(this, key),
	      size = data.size;
	
	  data.set(key, value);
	  this.size += data.size == size ? 0 : 1;
	  return this;
	}
	
	module.exports = mapCacheSet;


/***/ }),
/* 525 */
/***/ (function(module, exports) {

	/**
	 * Converts `map` to its key-value pairs.
	 *
	 * @private
	 * @param {Object} map The map to convert.
	 * @returns {Array} Returns the key-value pairs.
	 */
	function mapToArray(map) {
	  var index = -1,
	      result = Array(map.size);
	
	  map.forEach(function(value, key) {
	    result[++index] = [key, value];
	  });
	  return result;
	}
	
	module.exports = mapToArray;


/***/ }),
/* 526 */
/***/ (function(module, exports, __webpack_require__) {

	var memoize = __webpack_require__(553);
	
	/** Used as the maximum memoize cache size. */
	var MAX_MEMOIZE_SIZE = 500;
	
	/**
	 * A specialized version of `_.memoize` which clears the memoized function's
	 * cache when it exceeds `MAX_MEMOIZE_SIZE`.
	 *
	 * @private
	 * @param {Function} func The function to have its output memoized.
	 * @returns {Function} Returns the new memoized function.
	 */
	function memoizeCapped(func) {
	  var result = memoize(func, function(key) {
	    if (cache.size === MAX_MEMOIZE_SIZE) {
	      cache.clear();
	    }
	    return key;
	  });
	
	  var cache = result.cache;
	  return result;
	}
	
	module.exports = memoizeCapped;


/***/ }),
/* 527 */,
/* 528 */
/***/ (function(module, exports, __webpack_require__) {

	var overArg = __webpack_require__(204);
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeKeys = overArg(Object.keys, Object);
	
	module.exports = nativeKeys;


/***/ }),
/* 529 */
/***/ (function(module, exports) {

	/**
	 * This function is like
	 * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
	 * except that it includes inherited enumerable properties.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 */
	function nativeKeysIn(object) {
	  var result = [];
	  if (object != null) {
	    for (var key in Object(object)) {
	      result.push(key);
	    }
	  }
	  return result;
	}
	
	module.exports = nativeKeysIn;


/***/ }),
/* 530 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var freeGlobal = __webpack_require__(198);
	
	/** Detect free variable `exports`. */
	var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;
	
	/** Detect free variable `module`. */
	var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;
	
	/** Detect the popular CommonJS extension `module.exports`. */
	var moduleExports = freeModule && freeModule.exports === freeExports;
	
	/** Detect free variable `process` from Node.js. */
	var freeProcess = moduleExports && freeGlobal.process;
	
	/** Used to access faster Node.js helpers. */
	var nodeUtil = (function() {
	  try {
	    return freeProcess && freeProcess.binding && freeProcess.binding('util');
	  } catch (e) {}
	}());
	
	module.exports = nodeUtil;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(42)(module)))

/***/ }),
/* 531 */,
/* 532 */,
/* 533 */
/***/ (function(module, exports) {

	/** Used to stand-in for `undefined` hash values. */
	var HASH_UNDEFINED = '__lodash_hash_undefined__';
	
	/**
	 * Adds `value` to the array cache.
	 *
	 * @private
	 * @name add
	 * @memberOf SetCache
	 * @alias push
	 * @param {*} value The value to cache.
	 * @returns {Object} Returns the cache instance.
	 */
	function setCacheAdd(value) {
	  this.__data__.set(value, HASH_UNDEFINED);
	  return this;
	}
	
	module.exports = setCacheAdd;


/***/ }),
/* 534 */
/***/ (function(module, exports) {

	/**
	 * Checks if `value` is in the array cache.
	 *
	 * @private
	 * @name has
	 * @memberOf SetCache
	 * @param {*} value The value to search for.
	 * @returns {number} Returns `true` if `value` is found, else `false`.
	 */
	function setCacheHas(value) {
	  return this.__data__.has(value);
	}
	
	module.exports = setCacheHas;


/***/ }),
/* 535 */
/***/ (function(module, exports) {

	/**
	 * Converts `set` to an array of its values.
	 *
	 * @private
	 * @param {Object} set The set to convert.
	 * @returns {Array} Returns the values.
	 */
	function setToArray(set) {
	  var index = -1,
	      result = Array(set.size);
	
	  set.forEach(function(value) {
	    result[++index] = value;
	  });
	  return result;
	}
	
	module.exports = setToArray;


/***/ }),
/* 536 */,
/* 537 */
/***/ (function(module, exports, __webpack_require__) {

	var ListCache = __webpack_require__(81);
	
	/**
	 * Removes all key-value entries from the stack.
	 *
	 * @private
	 * @name clear
	 * @memberOf Stack
	 */
	function stackClear() {
	  this.__data__ = new ListCache;
	  this.size = 0;
	}
	
	module.exports = stackClear;


/***/ }),
/* 538 */
/***/ (function(module, exports) {

	/**
	 * Removes `key` and its value from the stack.
	 *
	 * @private
	 * @name delete
	 * @memberOf Stack
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function stackDelete(key) {
	  var data = this.__data__,
	      result = data['delete'](key);
	
	  this.size = data.size;
	  return result;
	}
	
	module.exports = stackDelete;


/***/ }),
/* 539 */
/***/ (function(module, exports) {

	/**
	 * Gets the stack value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf Stack
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function stackGet(key) {
	  return this.__data__.get(key);
	}
	
	module.exports = stackGet;


/***/ }),
/* 540 */
/***/ (function(module, exports) {

	/**
	 * Checks if a stack value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf Stack
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function stackHas(key) {
	  return this.__data__.has(key);
	}
	
	module.exports = stackHas;


/***/ }),
/* 541 */
/***/ (function(module, exports, __webpack_require__) {

	var ListCache = __webpack_require__(81),
	    Map = __webpack_require__(129),
	    MapCache = __webpack_require__(130);
	
	/** Used as the size to enable large array optimizations. */
	var LARGE_ARRAY_SIZE = 200;
	
	/**
	 * Sets the stack `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf Stack
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the stack cache instance.
	 */
	function stackSet(key, value) {
	  var data = this.__data__;
	  if (data instanceof ListCache) {
	    var pairs = data.__data__;
	    if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
	      pairs.push([key, value]);
	      this.size = ++data.size;
	      return this;
	    }
	    data = this.__data__ = new MapCache(pairs);
	  }
	  data.set(key, value);
	  this.size = data.size;
	  return this;
	}
	
	module.exports = stackSet;


/***/ }),
/* 542 */
/***/ (function(module, exports, __webpack_require__) {

	var memoizeCapped = __webpack_require__(526);
	
	/** Used to match property names within property paths. */
	var rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
	
	/** Used to match backslashes in property paths. */
	var reEscapeChar = /\\(\\)?/g;
	
	/**
	 * Converts `string` to a property path array.
	 *
	 * @private
	 * @param {string} string The string to convert.
	 * @returns {Array} Returns the property path array.
	 */
	var stringToPath = memoizeCapped(function(string) {
	  var result = [];
	  if (string.charCodeAt(0) === 46 /* . */) {
	    result.push('');
	  }
	  string.replace(rePropName, function(match, number, quote, subString) {
	    result.push(quote ? subString.replace(reEscapeChar, '$1') : (number || match));
	  });
	  return result;
	});
	
	module.exports = stringToPath;


/***/ }),
/* 543 */,
/* 544 */,
/* 545 */,
/* 546 */,
/* 547 */
/***/ (function(module, exports, __webpack_require__) {

	var baseGet = __webpack_require__(193);
	
	/**
	 * Gets the value at `path` of `object`. If the resolved value is
	 * `undefined`, the `defaultValue` is returned in its place.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.7.0
	 * @category Object
	 * @param {Object} object The object to query.
	 * @param {Array|string} path The path of the property to get.
	 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
	 * @returns {*} Returns the resolved value.
	 * @example
	 *
	 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
	 *
	 * _.get(object, 'a[0].b.c');
	 * // => 3
	 *
	 * _.get(object, ['a', '0', 'b', 'c']);
	 * // => 3
	 *
	 * _.get(object, 'a.b.c', 'default');
	 * // => 'default'
	 */
	function get(object, path, defaultValue) {
	  var result = object == null ? undefined : baseGet(object, path);
	  return result === undefined ? defaultValue : result;
	}
	
	module.exports = get;


/***/ }),
/* 548 */
/***/ (function(module, exports, __webpack_require__) {

	var baseHasIn = __webpack_require__(461),
	    hasPath = __webpack_require__(503);
	
	/**
	 * Checks if `path` is a direct or inherited property of `object`.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Object
	 * @param {Object} object The object to query.
	 * @param {Array|string} path The path to check.
	 * @returns {boolean} Returns `true` if `path` exists, else `false`.
	 * @example
	 *
	 * var object = _.create({ 'a': _.create({ 'b': 2 }) });
	 *
	 * _.hasIn(object, 'a');
	 * // => true
	 *
	 * _.hasIn(object, 'a.b');
	 * // => true
	 *
	 * _.hasIn(object, ['a', 'b']);
	 * // => true
	 *
	 * _.hasIn(object, 'b');
	 * // => false
	 */
	function hasIn(object, path) {
	  return object != null && hasPath(object, path, baseHasIn);
	}
	
	module.exports = hasIn;


/***/ }),
/* 549 */
/***/ (function(module, exports, __webpack_require__) {

	var isArrayLike = __webpack_require__(59),
	    isObjectLike = __webpack_require__(14);
	
	/**
	 * This method is like `_.isArrayLike` except that it also checks if `value`
	 * is an object.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an array-like object,
	 *  else `false`.
	 * @example
	 *
	 * _.isArrayLikeObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isArrayLikeObject(document.body.children);
	 * // => true
	 *
	 * _.isArrayLikeObject('abc');
	 * // => false
	 *
	 * _.isArrayLikeObject(_.noop);
	 * // => false
	 */
	function isArrayLikeObject(value) {
	  return isObjectLike(value) && isArrayLike(value);
	}
	
	module.exports = isArrayLikeObject;


/***/ }),
/* 550 */
/***/ (function(module, exports, __webpack_require__) {

	var baseGetTag = __webpack_require__(19),
	    isObjectLike = __webpack_require__(14);
	
	/** `Object#toString` result references. */
	var numberTag = '[object Number]';
	
	/**
	 * Checks if `value` is classified as a `Number` primitive or object.
	 *
	 * **Note:** To exclude `Infinity`, `-Infinity`, and `NaN`, which are
	 * classified as numbers, use the `_.isFinite` method.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a number, else `false`.
	 * @example
	 *
	 * _.isNumber(3);
	 * // => true
	 *
	 * _.isNumber(Number.MIN_VALUE);
	 * // => true
	 *
	 * _.isNumber(Infinity);
	 * // => true
	 *
	 * _.isNumber('3');
	 * // => false
	 */
	function isNumber(value) {
	  return typeof value == 'number' ||
	    (isObjectLike(value) && baseGetTag(value) == numberTag);
	}
	
	module.exports = isNumber;


/***/ }),
/* 551 */
/***/ (function(module, exports, __webpack_require__) {

	var baseGetTag = __webpack_require__(19),
	    getPrototype = __webpack_require__(201),
	    isObjectLike = __webpack_require__(14);
	
	/** `Object#toString` result references. */
	var objectTag = '[object Object]';
	
	/** Used for built-in method references. */
	var funcProto = Function.prototype,
	    objectProto = Object.prototype;
	
	/** Used to resolve the decompiled source of functions. */
	var funcToString = funcProto.toString;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/** Used to infer the `Object` constructor. */
	var objectCtorString = funcToString.call(Object);
	
	/**
	 * Checks if `value` is a plain object, that is, an object created by the
	 * `Object` constructor or one with a `[[Prototype]]` of `null`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.8.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 * }
	 *
	 * _.isPlainObject(new Foo);
	 * // => false
	 *
	 * _.isPlainObject([1, 2, 3]);
	 * // => false
	 *
	 * _.isPlainObject({ 'x': 0, 'y': 0 });
	 * // => true
	 *
	 * _.isPlainObject(Object.create(null));
	 * // => true
	 */
	function isPlainObject(value) {
	  if (!isObjectLike(value) || baseGetTag(value) != objectTag) {
	    return false;
	  }
	  var proto = getPrototype(value);
	  if (proto === null) {
	    return true;
	  }
	  var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
	  return typeof Ctor == 'function' && Ctor instanceof Ctor &&
	    funcToString.call(Ctor) == objectCtorString;
	}
	
	module.exports = isPlainObject;


/***/ }),
/* 552 */
/***/ (function(module, exports, __webpack_require__) {

	var baseGetTag = __webpack_require__(19),
	    isArray = __webpack_require__(6),
	    isObjectLike = __webpack_require__(14);
	
	/** `Object#toString` result references. */
	var stringTag = '[object String]';
	
	/**
	 * Checks if `value` is classified as a `String` primitive or object.
	 *
	 * @static
	 * @since 0.1.0
	 * @memberOf _
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a string, else `false`.
	 * @example
	 *
	 * _.isString('abc');
	 * // => true
	 *
	 * _.isString(1);
	 * // => false
	 */
	function isString(value) {
	  return typeof value == 'string' ||
	    (!isArray(value) && isObjectLike(value) && baseGetTag(value) == stringTag);
	}
	
	module.exports = isString;


/***/ }),
/* 553 */
/***/ (function(module, exports, __webpack_require__) {

	var MapCache = __webpack_require__(130);
	
	/** Error message constants. */
	var FUNC_ERROR_TEXT = 'Expected a function';
	
	/**
	 * Creates a function that memoizes the result of `func`. If `resolver` is
	 * provided, it determines the cache key for storing the result based on the
	 * arguments provided to the memoized function. By default, the first argument
	 * provided to the memoized function is used as the map cache key. The `func`
	 * is invoked with the `this` binding of the memoized function.
	 *
	 * **Note:** The cache is exposed as the `cache` property on the memoized
	 * function. Its creation may be customized by replacing the `_.memoize.Cache`
	 * constructor with one whose instances implement the
	 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
	 * method interface of `clear`, `delete`, `get`, `has`, and `set`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Function
	 * @param {Function} func The function to have its output memoized.
	 * @param {Function} [resolver] The function to resolve the cache key.
	 * @returns {Function} Returns the new memoized function.
	 * @example
	 *
	 * var object = { 'a': 1, 'b': 2 };
	 * var other = { 'c': 3, 'd': 4 };
	 *
	 * var values = _.memoize(_.values);
	 * values(object);
	 * // => [1, 2]
	 *
	 * values(other);
	 * // => [3, 4]
	 *
	 * object.a = 2;
	 * values(object);
	 * // => [1, 2]
	 *
	 * // Modify the result cache.
	 * values.cache.set(object, ['a', 'b']);
	 * values(object);
	 * // => ['a', 'b']
	 *
	 * // Replace `_.memoize.Cache`.
	 * _.memoize.Cache = WeakMap;
	 */
	function memoize(func, resolver) {
	  if (typeof func != 'function' || (resolver != null && typeof resolver != 'function')) {
	    throw new TypeError(FUNC_ERROR_TEXT);
	  }
	  var memoized = function() {
	    var args = arguments,
	        key = resolver ? resolver.apply(this, args) : args[0],
	        cache = memoized.cache;
	
	    if (cache.has(key)) {
	      return cache.get(key);
	    }
	    var result = func.apply(this, args);
	    memoized.cache = cache.set(key, result) || cache;
	    return result;
	  };
	  memoized.cache = new (memoize.Cache || MapCache);
	  return memoized;
	}
	
	// Expose `MapCache`.
	memoize.Cache = MapCache;
	
	module.exports = memoize;


/***/ }),
/* 554 */
/***/ (function(module, exports, __webpack_require__) {

	var baseMerge = __webpack_require__(472),
	    createAssigner = __webpack_require__(490);
	
	/**
	 * This method is like `_.assign` except that it recursively merges own and
	 * inherited enumerable string keyed properties of source objects into the
	 * destination object. Source properties that resolve to `undefined` are
	 * skipped if a destination value exists. Array and plain object properties
	 * are merged recursively. Other objects and value types are overridden by
	 * assignment. Source objects are applied from left to right. Subsequent
	 * sources overwrite property assignments of previous sources.
	 *
	 * **Note:** This method mutates `object`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.5.0
	 * @category Object
	 * @param {Object} object The destination object.
	 * @param {...Object} [sources] The source objects.
	 * @returns {Object} Returns `object`.
	 * @example
	 *
	 * var object = {
	 *   'a': [{ 'b': 2 }, { 'd': 4 }]
	 * };
	 *
	 * var other = {
	 *   'a': [{ 'c': 3 }, { 'e': 5 }]
	 * };
	 *
	 * _.merge(object, other);
	 * // => { 'a': [{ 'b': 2, 'c': 3 }, { 'd': 4, 'e': 5 }] }
	 */
	var merge = createAssigner(function(object, source, srcIndex) {
	  baseMerge(object, source, srcIndex);
	});
	
	module.exports = merge;


/***/ }),
/* 555 */,
/* 556 */
/***/ (function(module, exports, __webpack_require__) {

	var baseProperty = __webpack_require__(474),
	    basePropertyDeep = __webpack_require__(475),
	    isKey = __webpack_require__(136),
	    toKey = __webpack_require__(57);
	
	/**
	 * Creates a function that returns the value at `path` of a given object.
	 *
	 * @static
	 * @memberOf _
	 * @since 2.4.0
	 * @category Util
	 * @param {Array|string} path The path of the property to get.
	 * @returns {Function} Returns the new accessor function.
	 * @example
	 *
	 * var objects = [
	 *   { 'a': { 'b': 2 } },
	 *   { 'a': { 'b': 1 } }
	 * ];
	 *
	 * _.map(objects, _.property('a.b'));
	 * // => [2, 1]
	 *
	 * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
	 * // => [1, 2]
	 */
	function property(path) {
	  return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
	}
	
	module.exports = property;


/***/ }),
/* 557 */
/***/ (function(module, exports, __webpack_require__) {

	var baseSet = __webpack_require__(478);
	
	/**
	 * Sets the value at `path` of `object`. If a portion of `path` doesn't exist,
	 * it's created. Arrays are created for missing index properties while objects
	 * are created for all other missing properties. Use `_.setWith` to customize
	 * `path` creation.
	 *
	 * **Note:** This method mutates `object`.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.7.0
	 * @category Object
	 * @param {Object} object The object to modify.
	 * @param {Array|string} path The path of the property to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns `object`.
	 * @example
	 *
	 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
	 *
	 * _.set(object, 'a[0].b.c', 4);
	 * console.log(object.a[0].b.c);
	 * // => 4
	 *
	 * _.set(object, ['x', '0', 'y', 'z'], 5);
	 * console.log(object.x[0].y.z);
	 * // => 5
	 */
	function set(object, path, value) {
	  return object == null ? object : baseSet(object, path, value);
	}
	
	module.exports = set;


/***/ }),
/* 558 */
/***/ (function(module, exports) {

	/**
	 * This method returns a new empty array.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.13.0
	 * @category Util
	 * @returns {Array} Returns the new empty array.
	 * @example
	 *
	 * var arrays = _.times(2, _.stubArray);
	 *
	 * console.log(arrays);
	 * // => [[], []]
	 *
	 * console.log(arrays[0] === arrays[1]);
	 * // => false
	 */
	function stubArray() {
	  return [];
	}
	
	module.exports = stubArray;


/***/ }),
/* 559 */
/***/ (function(module, exports) {

	/**
	 * This method returns `false`.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.13.0
	 * @category Util
	 * @returns {boolean} Returns `false`.
	 * @example
	 *
	 * _.times(2, _.stubFalse);
	 * // => [false, false]
	 */
	function stubFalse() {
	  return false;
	}
	
	module.exports = stubFalse;


/***/ }),
/* 560 */
/***/ (function(module, exports, __webpack_require__) {

	var copyObject = __webpack_require__(488),
	    keysIn = __webpack_require__(210);
	
	/**
	 * Converts `value` to a plain object flattening inherited enumerable string
	 * keyed properties of `value` to own properties of the plain object.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.0.0
	 * @category Lang
	 * @param {*} value The value to convert.
	 * @returns {Object} Returns the converted plain object.
	 * @example
	 *
	 * function Foo() {
	 *   this.b = 2;
	 * }
	 *
	 * Foo.prototype.c = 3;
	 *
	 * _.assign({ 'a': 1 }, new Foo);
	 * // => { 'a': 1, 'b': 2 }
	 *
	 * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
	 * // => { 'a': 1, 'b': 2, 'c': 3 }
	 */
	function toPlainObject(value) {
	  return copyObject(value, keysIn(value));
	}
	
	module.exports = toPlainObject;


/***/ }),
/* 561 */
/***/ (function(module, exports, __webpack_require__) {

	var baseToString = __webpack_require__(481);
	
	/**
	 * Converts `value` to a string. An empty string is returned for `null`
	 * and `undefined` values. The sign of `-0` is preserved.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to convert.
	 * @returns {string} Returns the converted string.
	 * @example
	 *
	 * _.toString(null);
	 * // => ''
	 *
	 * _.toString(-0);
	 * // => '-0'
	 *
	 * _.toString([1, 2, 3]);
	 * // => '1,2,3'
	 */
	function toString(value) {
	  return value == null ? '' : baseToString(value);
	}
	
	module.exports = toString;


/***/ }),
/* 562 */,
/* 563 */
/***/ (function(module, exports) {

	function n(n){return n=n||Object.create(null),{on:function(c,e){(n[c]||(n[c]=[])).push(e)},off:function(c,e){n[c]&&n[c].splice(n[c].indexOf(e)>>>0,1)},emit:function(c,e){(n[c]||[]).slice().map(function(n){n(e)}),(n["*"]||[]).slice().map(function(n){n(c,e)})}}}module.exports=n;
	//# sourceMappingURL=mitt.js.map

/***/ }),
/* 564 */
/***/ (function(module, exports, __webpack_require__) {

	// Generated by CoffeeScript 1.9.1
	var isNumber, ratios;
	
	isNumber = __webpack_require__(446);
	
	ratios = {
	  "minor second": 16 / 15,
	  "major second": 9 / 8,
	  "minor third": 6 / 5,
	  "major third": 4 / 3,
	  "diminished fourth": Math.sqrt(2),
	  "perfect fifth": 3 / 2,
	  "minor sixth": 8 / 5,
	  "golden": 1.61803398875,
	  "phi": 1.61803398875,
	  "major sixth": 5 / 3,
	  "minor seventh": 16 / 9,
	  "major seventh": 15 / 8,
	  "octave": 2,
	  "major tenth": 5 / 2,
	  "major eleventh": 8 / 3,
	  "major twelfth": 3,
	  "double octave": 4
	};
	
	module.exports = function(value, ratio) {
	  var r;
	  if (value == null) {
	    value = 0;
	  }
	  if (ratio == null) {
	    ratio = "golden";
	  }
	  if (isNumber(ratio)) {
	    r = ratio;
	  } else if (ratios[ratio] != null) {
	    r = ratios[ratio];
	  } else {
	    r = ratios['golden'];
	  }
	  return Math.pow(r, value);
	};


/***/ }),
/* 565 */,
/* 566 */,
/* 567 */,
/* 568 */,
/* 569 */,
/* 570 */,
/* 571 */,
/* 572 */,
/* 573 */,
/* 574 */,
/* 575 */,
/* 576 */,
/* 577 */,
/* 578 */,
/* 579 */,
/* 580 */,
/* 581 */,
/* 582 */,
/* 583 */,
/* 584 */,
/* 585 */,
/* 586 */,
/* 587 */,
/* 588 */,
/* 589 */,
/* 590 */,
/* 591 */,
/* 592 */,
/* 593 */,
/* 594 */,
/* 595 */,
/* 596 */,
/* 597 */,
/* 598 */,
/* 599 */,
/* 600 */,
/* 601 */,
/* 602 */,
/* 603 */,
/* 604 */,
/* 605 */,
/* 606 */,
/* 607 */,
/* 608 */,
/* 609 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	// Pulled from react-compat
	// https://github.com/developit/preact-compat/blob/7c5de00e7c85e2ffd011bf3af02899b63f699d3a/src/index.js#L349
	function shallowDiffers(a, b) {
	  for (var i in a) {
	    if (!(i in b)) return true;
	  }for (var _i in b) {
	    if (a[_i] !== b[_i]) return true;
	  }return false;
	}
	
	exports.default = function (instance, nextProps, nextState) {
	  return shallowDiffers(instance.props, nextProps) || shallowDiffers(instance.state, nextState);
	};
	
	module.exports = exports["default"];

/***/ }),
/* 610 */,
/* 611 */,
/* 612 */,
/* 613 */,
/* 614 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	/* eslint-disable */
	/*! normalize.css v4.1.1 | MIT License | github.com/necolas/normalize.css */
	exports.default = 'html{font-family:sans-serif;-ms-text-size-adjust:100%;-webkit-text-size-adjust:100%}body{margin:0}article,aside,details,figcaption,figure,footer,header,main,menu,nav,section,summary{display:block}audio,canvas,progress,video{display:inline-block}audio:not([controls]){display:none;height:0}progress{vertical-align:baseline}[hidden],template{display:none}a{background-color:transparent;-webkit-text-decoration-skip:objects}a:active,a:hover{outline-width:0}abbr[title]{border-bottom:none;text-decoration:underline;text-decoration:underline dotted}b,strong{font-weight:inherit;font-weight:bolder}dfn{font-style:italic}h1{font-size:2em;margin:.67em 0}mark{background-color:#ff0;color:#000}small{font-size:80%}sub,sup{font-size:75%;line-height:0;position:relative;vertical-align:baseline}sub{bottom:-.25em}sup{top:-.5em}img{border-style:none}svg:not(:root){overflow:hidden}code,kbd,pre,samp{font-family:monospace,monospace;font-size:1em}figure{margin:1em 40px}hr{box-sizing:content-box;height:0;overflow:visible}button,input,optgroup,select,textarea{font:inherit;margin:0}optgroup{font-weight:700}button,input{overflow:visible}button,select{text-transform:none}[type=reset],[type=submit],button,html [type=button]{-webkit-appearance:button}[type=button]::-moz-focus-inner,[type=reset]::-moz-focus-inner,[type=submit]::-moz-focus-inner,button::-moz-focus-inner{border-style:none;padding:0}[type=button]:-moz-focusring,[type=reset]:-moz-focusring,[type=submit]:-moz-focusring,button:-moz-focusring{outline:1px dotted ButtonText}fieldset{border:1px solid silver;margin:0 2px;padding:.35em .625em .75em}legend{box-sizing:border-box;color:inherit;display:table;max-width:100%;padding:0;white-space:normal}textarea{overflow:auto}[type=checkbox],[type=radio]{box-sizing:border-box;padding:0}[type=number]::-webkit-inner-spin-button,[type=number]::-webkit-outer-spin-button{height:auto}[type=search]{-webkit-appearance:textfield;outline-offset:-2px}[type=search]::-webkit-search-cancel-button,[type=search]::-webkit-search-decoration{-webkit-appearance:none}::-webkit-input-placeholder{color:inherit;opacity:.54}::-webkit-file-upload-button{-webkit-appearance:button;font:inherit}';

/***/ }),
/* 615 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	
	var theme = {
	  title: 'Noriega',
	  baseFontSize: '18px',
	  baseLineHeight: 1.61,
	  headerFontFamily: ['Lato', 'sans-serif'],
	  bodyFontFamily: ['Lato', 'sans-serif'],
	  bodyWeight: 400,
	  headerWeight: 700,
	  boldWeight: 700,
	  googleFonts: [{
	    name: 'Lato',
	    styles: ['400', '700']
	  }],
	  scaleRatio: 1.618
	};
	exports.default = theme;

/***/ }),
/* 616 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _objectAssign = __webpack_require__(11);
	
	var _objectAssign2 = _interopRequireDefault(_objectAssign);
	
	var _compassVerticalRhythm = __webpack_require__(291);
	
	var _compassVerticalRhythm2 = _interopRequireDefault(_compassVerticalRhythm);
	
	var _modularscale = __webpack_require__(564);
	
	var _modularscale2 = _interopRequireDefault(_modularscale);
	
	var _createStyles = __webpack_require__(618);
	
	var _createStyles2 = _interopRequireDefault(_createStyles);
	
	var _compileStyles = __webpack_require__(617);
	
	var _compileStyles2 = _interopRequireDefault(_compileStyles);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var typography = function typography(opts) {
	  var defaults = {
	    baseFontSize: '16px',
	    baseLineHeight: 1.45,
	    headerLineHeight: 1.1,
	    scaleRatio: 2,
	    googleFonts: [],
	    headerFontFamily: ['-apple-system', 'BlinkMacSystemFont', 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', 'sans-serif'],
	    bodyFontFamily: ['georgia', 'serif'],
	    headerColor: 'inherit',
	    bodyColor: 'hsla(0,0%,0%,0.8)',
	    headerWeight: 'bold',
	    bodyWeight: 'normal',
	    boldWeight: 'bold',
	    includeNormalize: true,
	    blockMarginBottom: 1
	  };
	
	  var options = (0, _objectAssign2.default)({}, defaults, opts);
	
	  var vr = (0, _compassVerticalRhythm2.default)(options);
	
	  // Add this function to the vertical rhythm object so it'll be passed around
	  // as well and be available. Not related really but this is the easiest
	  // way to pass around extra utility functions atm... :-\
	  vr.scale = function (value) {
	    // This doesn't pick the right scale ratio if a theme has more than one ratio.
	    // Perhaps add optional parameter for a width and it'll get the ratio
	    // for this width. Tricky part is maxWidth could be set in non-pixels.
	    var baseFont = parseInt(options.baseFontSize, 10);
	    var newFontSize = (0, _modularscale2.default)(value, options.scaleRatio) * baseFont + 'px';
	    return vr.adjustFontSizeTo(newFontSize);
	  };
	
	  return _extends({
	    options: options
	  }, vr, {
	    createStyles: function createStyles() {
	      return this.toString();
	    },
	    // TODO remove in next breaking release.
	    toJSON: function toJSON() {
	      return (0, _createStyles2.default)(vr, options);
	    },
	    toString: function toString() {
	      return (0, _compileStyles2.default)(vr, options, this.toJSON());
	    },
	    injectStyles: function injectStyles() {
	      if (typeof document !== 'undefined') {
	        // Replace existing
	        if (document.getElementById('typography.js')) {
	          var styleNode = document.getElementById('typography.js');
	          styleNode.innerHTML = this.toString();
	        } else {
	          var node = document.createElement('style');
	          node.id = 'typography.js';
	          node.innerHTML = this.toString();
	          document.head.appendChild(node);
	        }
	      }
	    }
	  });
	};
	
	module.exports = typography;
	
	/*
	const test = typography({
	  baseFontSize: '16px',
	  includeNormalize: false,
	})
	
	console.log(test.toJSON())
	console.log(test.toString())
	*/

/***/ }),
/* 617 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _typographyNormalize = __webpack_require__(614);
	
	var _typographyNormalize2 = _interopRequireDefault(_typographyNormalize);
	
	var _decamelize = __webpack_require__(365);
	
	var _decamelize2 = _interopRequireDefault(_decamelize);
	
	var _forEach = __webpack_require__(209);
	
	var _forEach2 = _interopRequireDefault(_forEach);
	
	var _reduce = __webpack_require__(211);
	
	var _reduce2 = _interopRequireDefault(_reduce);
	
	var _isObject = __webpack_require__(13);
	
	var _isObject2 = _interopRequireDefault(_isObject);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var compileStyles = function compileStyles(styles) {
	  return (0, _reduce2.default)(styles, function (stylesStr, ruleSet, selector) {
	    stylesStr += selector + '{'; // eslint-disable-line
	    (0, _forEach2.default)(ruleSet, function (value, property) {
	      if ((0, _isObject2.default)(value)) {
	        var newObject = {};
	        newObject[property] = value;
	        stylesStr += compileStyles(newObject); // eslint-disable-line
	      } else {
	        var newStyle = (0, _decamelize2.default)(property, '-') + ':' + value + ';'; // eslint-disable-line
	        // If the property is prefixed, add an additional dash at the beginning.
	        var prefixes = ['Webkit', 'ms', 'Moz', 'O'];
	        prefixes.forEach(function (prefix) {
	          if (property.slice(0, prefix.length) === prefix) {
	            newStyle = '-' + newStyle;
	          }
	        });
	        stylesStr += newStyle;
	      }
	    });
	    stylesStr += '}'; // eslint-disable-line
	    return stylesStr;
	  }, '');
	};
	
	
	module.exports = function (vr, options, styles) {
	  // Compile styles to string.
	  var stylesStr = compileStyles(styles);
	
	  if (options.includeNormalize) {
	    stylesStr = '' + _typographyNormalize2.default + stylesStr;
	  }
	
	  return stylesStr;
	};

/***/ }),
/* 618 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _grayPercentage = __webpack_require__(424);
	
	var _grayPercentage2 = _interopRequireDefault(_grayPercentage);
	
	var _set = __webpack_require__(557);
	
	var _set2 = _interopRequireDefault(_set);
	
	var _forEach = __webpack_require__(209);
	
	var _forEach2 = _interopRequireDefault(_forEach);
	
	var _isNumber = __webpack_require__(550);
	
	var _isNumber2 = _interopRequireDefault(_isNumber);
	
	var _isString = __webpack_require__(552);
	
	var _isString2 = _interopRequireDefault(_isString);
	
	var _isFunction = __webpack_require__(88);
	
	var _isFunction2 = _interopRequireDefault(_isFunction);
	
	var _isArray = __webpack_require__(6);
	
	var _isArray2 = _interopRequireDefault(_isArray);
	
	var _merge = __webpack_require__(554);
	
	var _merge2 = _interopRequireDefault(_merge);
	
	var _reduce = __webpack_require__(211);
	
	var _reduce2 = _interopRequireDefault(_reduce);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var setStyles = function setStyles() {
	  var styles = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	  var els = arguments[1];
	  var rules = arguments[2];
	
	  var elements = void 0;
	  if (!(0, _isArray2.default)(els)) {
	    elements = [els];
	  } else {
	    elements = els;
	  }
	  (0, _forEach2.default)(elements, function (element) {
	    (0, _forEach2.default)(rules, function (value, prop) {
	      (0, _set2.default)(styles, element + "." + prop, value);
	    });
	  });
	  return styles;
	};
	
	// Wrap font names in quotes, unless the font name is actually a keyword.
	// See https://stackoverflow.com/a/13752149 and https://www.w3.org/TR/CSS2/fonts.html#font-family-prop
	var genericFontFamilies = ['inherit', 'default', 'serif', 'sans-serif', 'monospace', 'fantasy', 'cursive', '-apple-system'];
	var wrapFontFamily = function wrapFontFamily(fontFamily) {
	  return genericFontFamilies.indexOf(fontFamily) !== -1 ? fontFamily : "'" + fontFamily + "'";
	};
	
	module.exports = function (vr, options) {
	  var styles = {};
	
	  var _vr$establishBaseline = vr.establishBaseline(),
	      fontSize = _vr$establishBaseline.fontSize,
	      lineHeight = _vr$establishBaseline.lineHeight;
	
	  // Base HTML styles.
	
	
	  styles = setStyles(styles, "html", {
	    font: fontSize + "/" + lineHeight + " " + options.bodyFontFamily.map(wrapFontFamily).join(","),
	    boxSizing: "border-box",
	    overflowY: "scroll"
	  });
	
	  // box-sizing reset.
	  styles = setStyles(styles, ["*", "*:before", "*:after"], {
	    boxSizing: "inherit"
	  });
	
	  // Base body styles.
	  styles = setStyles(styles, "body", {
	    color: options.bodyColor,
	    fontFamily: options.bodyFontFamily.map(wrapFontFamily).join(","),
	    fontWeight: options.bodyWeight,
	    wordWrap: "break-word",
	    fontKerning: "normal",
	    MozFontFeatureSettings: '"kern", "liga", "clig", "calt"',
	    msFontFeatureSettings: '"kern", "liga", "clig", "calt"',
	    WebkitFontFeatureSettings: '"kern", "liga", "clig", "calt"',
	    fontFeatureSettings: '"kern", "liga", "clig", "calt"'
	  });
	
	  // Make images responsive.
	  styles = setStyles(styles, "img", {
	    maxWidth: "100%"
	  });
	
	  // All block elements get one rhythm of bottom margin by default
	  // or whatever is passed in as option.
	  var blockMarginBottom = "";
	  if ((0, _isNumber2.default)(options.blockMarginBottom)) {
	    blockMarginBottom = vr.rhythm(options.blockMarginBottom);
	  } else if ((0, _isString2.default)(options.blockMarginBottom)) {
	    blockMarginBottom = options.blockMarginBottom;
	  } else {
	    blockMarginBottom = vr.rhythm(1);
	  }
	  styles = setStyles(styles, ["h1", "h2", "h3", "h4", "h5", "h6", "hgroup", "ul", "ol", "dl", "dd", "p", "figure", "pre", "table", "fieldset", "blockquote", "form", "noscript", "iframe", "img", "hr", "address"], {
	    // Reset margin/padding to 0.
	    marginLeft: 0,
	    marginRight: 0,
	    marginTop: 0,
	    paddingBottom: 0,
	    paddingLeft: 0,
	    paddingRight: 0,
	    paddingTop: 0,
	    marginBottom: blockMarginBottom
	  });
	
	  // Basic blockquote styles.
	  styles = setStyles(styles, "blockquote", {
	    marginRight: vr.rhythm(1),
	    marginBottom: blockMarginBottom,
	    marginLeft: vr.rhythm(1)
	  });
	
	  // b, strong.
	  styles = setStyles(styles, ["b", "strong", "dt", "th"], {
	    fontWeight: options.boldWeight
	  });
	
	  // hr.
	  styles = setStyles(styles, "hr", {
	    background: (0, _grayPercentage2.default)(80),
	    border: "none",
	    height: "1px",
	    marginBottom: "calc(" + blockMarginBottom + " - 1px)"
	  });
	
	  // ol, ul.
	  styles = setStyles(styles, ["ol", "ul"], {
	    listStylePosition: "outside",
	    listStyleImage: "none",
	    marginLeft: vr.rhythm(1)
	  });
	
	  // li.
	  styles = setStyles(styles, "li", {
	    marginBottom: "calc(" + blockMarginBottom + " / 2)"
	  });
	
	  // Remove default padding on list items.
	  styles = setStyles(styles, ["ol li", "ul li"], {
	    paddingLeft: 0
	  });
	
	  // children ol, ul.
	  styles = setStyles(styles, ["li > ol", "li > ul"], {
	    marginLeft: vr.rhythm(1),
	    marginBottom: "calc(" + blockMarginBottom + " / 2)",
	    marginTop: "calc(" + blockMarginBottom + " / 2)"
	  });
	
	  // Remove margin-bottom on the last-child of a few block elements
	  // The worst offender of this seems to be markdown => html compilers
	  // as they put paragraphs within LIs amoung other oddities.
	  styles = setStyles(styles, ["blockquote *:last-child", "li *:last-child", "p *:last-child"], {
	    marginBottom: 0
	  });
	
	  // Ensure li > p is 1/2 margin — this is another markdown => compiler oddity.
	  styles = setStyles(styles, ["li > p"], {
	    marginBottom: "calc(" + blockMarginBottom + " / 2)"
	  });
	
	  // Make generally smaller elements, smaller.
	  styles = setStyles(styles, ["code", "kbd", "pre", "samp"], _extends({}, vr.adjustFontSizeTo("85%")));
	
	  // Abbr, Acronym.
	  styles = setStyles(styles, ["abbr", "acronym"], {
	    borderBottom: "1px dotted " + (0, _grayPercentage2.default)(50),
	    cursor: "help"
	  });
	  styles["abbr[title]"] = {
	    borderBottom: "1px dotted " + (0, _grayPercentage2.default)(50),
	    cursor: "help",
	    textDecoration: "none"
	  };
	
	  // Table styles.
	  styles = setStyles(styles, ["table"], _extends({}, vr.adjustFontSizeTo(options.baseFontSize), {
	    borderCollapse: "collapse",
	    width: "100%"
	  }));
	  styles = setStyles(styles, ["thead"], {
	    textAlign: "left"
	  });
	  styles = setStyles(styles, ["td,th"], {
	    textAlign: "left",
	    borderBottom: "1px solid " + (0, _grayPercentage2.default)(88),
	    fontFeatureSettings: '"tnum"',
	    MozFontFeatureSettings: '"tnum"',
	    msFontFeatureSettings: '"tnum"',
	    WebkitFontFeatureSettings: '"tnum"',
	    paddingLeft: vr.rhythm(2 / 3),
	    paddingRight: vr.rhythm(2 / 3),
	    paddingTop: vr.rhythm(1 / 2),
	    paddingBottom: "calc(" + vr.rhythm(1 / 2) + " - 1px)"
	  });
	  styles = setStyles(styles, "th:first-child,td:first-child", {
	    paddingLeft: 0
	  });
	  styles = setStyles(styles, "th:last-child,td:last-child", {
	    paddingRight: 0
	  });
	
	  // Create styles for headers.
	  styles = setStyles(styles, ["h1", "h2", "h3", "h4", "h5", "h6"], {
	    color: options.headerColor,
	    fontFamily: options.headerFontFamily.map(wrapFontFamily).join(","),
	    fontWeight: options.headerWeight,
	    textRendering: "optimizeLegibility"
	  });
	
	  // Set header sizes.
	  var h1 = vr.scale(5 / 5);
	  var h2 = vr.scale(3 / 5);
	  var h3 = vr.scale(2 / 5);
	  var h4 = vr.scale(0 / 5);
	  var h5 = vr.scale(-1 / 5);
	  var h6 = vr.scale(-1.5 / 5);
	
	  (0, _forEach2.default)([h1, h2, h3, h4, h5, h6], function (header, i) {
	    styles = (0, _set2.default)(styles, "h" + (i + 1) + ".fontSize", header.fontSize);
	    styles = (0, _set2.default)(styles, "h" + (i + 1) + ".lineHeight", options.headerLineHeight);
	  });
	
	  // TODO add support for Breakpoints here.
	
	  // Call plugins if any.
	  if ((0, _isArray2.default)(options.plugins)) {
	    styles = (0, _reduce2.default)(options.plugins, function (stylesObj, plugin) {
	      return (0, _merge2.default)(stylesObj, plugin(vr, options, stylesObj));
	    }, styles);
	  }
	
	  // Call overrideStyles function on options (if set).
	  if (options.overrideStyles && (0, _isFunction2.default)(options.overrideStyles)) {
	    styles = (0, _merge2.default)(styles, options.overrideStyles(vr, options, styles));
	  }
	
	  // Call overrideThemeStyles function on options (if set).
	  if (options.overrideThemeStyles && (0, _isFunction2.default)(options.overrideThemeStyles)) {
	    styles = (0, _merge2.default)(styles, options.overrideThemeStyles(vr, options, styles));
	  }
	
	  return styles;
	};

/***/ })
]);


// WEBPACK FOOTER //
// app-ac481471d128d14cce97.js